module.exports = {
  BusinessNo: 'Số doanh nghiệp',
  WarehouseNo: 'Số lượng thùng vào',
  MasterBillNo: 'Số đơn chính',
  HBL: 'HBL',
  FileNo: 'Số tập tin',
  BookingNo: 'Số đặt phòng',
  ItemNo: 'Số mặt hàng',
  BusinessReferenceNo: 'Số tham chiếu doanh nghiệp',
  BillNo: 'Số hóa đơn',
  PreBookingNo: 'Số cabin đặt phòng',
  CBANumber: 'Số ủy thác khai hải quan',
  CustomsStatus: 'Tình trạng hải quan',
  CustomsStatusUpdateTime: 'Thời gian cập nhật tình trạng hải quan',
  ReceiptDetails: 'Chi tiết',
  CustomsBrokerStatus: 'Trạng thái môi giới hải quan',
  CustomsReceiptRecord: 'Hồ sơ hoàn trả hải quan',
  CustomsTime: 'Thời gian hải quan',
  CustomsCode2: 'Mã hải quan',
  CustomsDescription: 'Mô tả hải quan',
  UnifiedCoding: 'Mã hóa thống nhất',
  HBLSplitCombineNo: 'HBL và số',
  MBLSplitCombineNo: 'MBL số chẵn',
  ConsignationCompany: 'Đơn vị ủy thác',
  BookingAgent: 'Đại lý đặt phòng',
  BookingOrExchangeAgent: 'Đại lý đặt hàng/Đại lý thay đổi đơn',
  CarrierAgent: 'Đại diện tàu',
  DestinationAgent: 'Đại lý cảng đích',
  ShippingCompany: 'Công ty tàu',
  OperateCarrier: 'Hãng tàu chính',
  VSACarrier: 'Hãng tàu chia chuyến',
  InternalVoy: 'Chuyến nội bộ',
  CopyShip: 'Sao chép thông tin hãng tàu chính sang hãng tàu chia chuyến',
  ContainerNo: 'Số hộp',
  BoxController: 'Người kiểm soát hộp',
  LFD: 'LFD',
  CarNumber: 'Số xe',
  ContainerNoOutOfRange: 'Chiều dài hộp vượt quá giới hạn',
  PortOfLoading: 'Cảng khởi hành (POL)',
  PortOfLoadingPOR: 'Cảng khởi hành (POR)',
  TransitPort: 'Cảng trung chuyển',
  PortOfDestination: 'Cảng đích',
  PortOfDestinationPod: 'Cảng đích (POD)',
  PortOfDischarge: 'Cảng dỡ hàng (POD)',
  PortOfDischargeSeaAndComprehensive: 'Cảng dỡ hàng (bằng đường biển/tích hợp)',
  DischargingPortCountry: 'Cảng xả Quốc gia/Khu vực',
  DestinationPortCountry: 'Cảng đích Quốc gia/Khu vực',
  dischargingPort: 'Cảng dỡ hàng',
  FirstPortOfDischarge: 'Một cảng dỡ hàng',
  branchLineDateOfDeparture: 'Ngày khởi hành',
  branchLineDateOfArrival: 'Đường nhánh đến cảng ngày',
  DateOfDeparture: 'Ngày khởi hành',
  DateOfDeparture2: 'Ngày KH(ETD)',
  BookingDate: 'Ngày đặt phòng',
  BargeDateOfDeparture: 'Ngày khởi hành sà lan',
  BargeCYCutOffDate2: 'Ngày đóng cửa sà lan',
  BargePortOfLoading: 'Cảng khởi hành sà lan (POL)',
  BargeVessel: 'Name',
  BargeVoyage: 'Chuyến bay Barge',
  BargePOL: 'Xà lan POL',
  SecondDateOfDeparture: 'Ngày khởi hành 2 chiều',
  DeliveryCompletionDate: 'Thời gian hoàn thành giao hàng',
  DateOfArrival: 'Ngày đến cảng',
  DateOfArrival2: 'Ngày đến cảng (ETA)',
  DateOfArrival3: 'Ngày đến cảng (ETA)',
  DateOfCreation: 'Ngày tạo',
  CYCutOffDate2: 'Ngày đóng cửa',
  DocCutOffDate: 'Ngày cắt',
  DeclareCutOffDate: 'Chặn ngày khai báo',
  LoadingDate: 'Ngày đóng gói',
  PreAuditTime: 'Thời gian xét duyệt sơ thẩm',
  CallSignOfBookingShip: 'Đăng ký tàu',
  MasterBLFreightTerm: 'Điều khoản vận chuyển chính',
  MasterBLFreightTermTootip: 'Điều khoản vận chuyển chính',
  OrderChannels: 'Kênh đặt hàng',
  CargoType: 'Loại HH',
  Shipper: 'Gửi hàng',
  ShipperCode: 'Người gửi code',
  Consignee: 'Người nhận hàng',
  ConsigneeCode: 'Mã người nhận hàng',
  SONO: 'SO NO.',
  ShippingCompanyContractNo: 'Công ty tàu',
  PleaseEnterTheShippingCompanyContractNumber: 'Vui lòng nhập số hợp đồng của hãng tàu',
  CargoInsuranceQuantity: 'Số lượng bảo hiểm hàng hóa',
  CargoInsuranceUnit: 'Đơn vị bảo hiểm hàng hóa',
  ValidityStartDate: 'Ngày bắt đầu hiệu lực',
  ValidityEndDate: 'Ngày kết thúc hiệu lực',
  InnerContractNo: 'Bên trong số xấp xỉ',
  HBLRemarks: 'Ghi chú của HBL B/L',
  quotationNum: 'Số báo giá',
  Vessel: 'Tên tàu',
  Voyage: 'Chuyến bay',
  CarrierVoyage: 'Tàu nội bộ',
  OperationDepartment: 'Phòng điều hành',
  SalesDepartment: 'Bộ phận bán hàng',
  FLCLType: 'Loại cắt dán hoàn chỉnh',
  ExportControlledProducts: 'Sản phẩm ống xuất khẩu',
  LocalService: 'Dịch vụ địa phương',
  NotLocalService: 'Không có dịch vụ địa phương',
  SolicitationType: 'Loại Range Rover',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: 'Sản phẩm dịch vụ',
  WoodOrNotWood: 'Gỗ/không gỗ',
  handlingInformation: 'Handling Information',
  HazardousGoodsOption: 'Lựa chọn hàng nguy hiểm',
  ContractRateProperty: 'Tính chất xấp xỉ',
  IsNac: 'Có phải NAC hay không',
  ApplicableProductName: 'Tên sản phẩm áp dụng',
  PleaseEnterNAC: 'Vui lòng nhập NAC',
  CargoInsurance: 'Bảo hiểm hàng hóa',
  ShutOut: 'Hủy bỏ',
  ShutOutDate: 'thời gian Hủy bỏ',
  CancelShutOut: 'Hủy bỏ đóng cửa',
  ABargeOrNot: 'Nếu có xà lan',
  yes: 'Vâng',
  no: 'Không',
  Operation: 'Hoạt động',
  Sales: 'Bán hàng',
  CustomerService: 'Dịch vụ',
  Documents: 'Chứng từ',
  Airline: 'Đường bay',
  PreAuditPerson: 'Người đánh giá trước khi xét xử',
  Creator: 'Tạo bởi',
  Code: 'CODE',
  Accrued: 'Đã tính toán.',
  AirlineCode: 'LINE CODE',
  ShowRelevantBusiness: 'Hiển thị doanh nghiệp liên kết',
  CustomsBroker: 'Nhà môi giới hải quan',
  AdvancePayment: 'Có nên ứng trước thuế quan hay không',
  HasPrintBooking: 'In đơn đặt hàng',
  PaymentTime: 'Thời gian nộp thuế',
  CustomsDutyAmount: 'Số tiền thuế',
  VatAmount: 'Số tiền VAT',
  TaxRemarks: 'Ghi chú thuế',
  Warehouse: 'Trang chủ',
  HaulageCompany: 'Công ty vận tải',
  CarryingCmpAdjustBlockedTip: 'Đơn hàng đã chọn có mục chưa tích Đóng gói/Giao hàng tận cửa, không thể điều chỉnh công ty vận tải',
  AbnormalBusinessNo: 'Số nghiệp vụ bất thường',
  TradeTerms2: 'Điều khoản thương mại',
  BusinessStatus: 'Tình trạng kinh doanh',
  StatusTracking: 'Theo dõi trạng thái',
  AuditStatus: 'Trạng thái kiểm toán',
  Display: 'HT',
  EstimatedArrivalTime: 'Thời gian dự kiến đến cảng',
  EstimatedPortArrivalTime: 'Thời gian dự kiến đến cảng/điểm đến',
  ArrivalTime: 'Thời gian đến cảng thực tế',
  CustomsClearance: 'Cảng đích đóng cửa',
  ActualCustomsReleaseTime: 'Thời gian đóng cửa thực tế',
  DeliveryTime: 'Thời gian giao hàng',
  ReturnTime: 'Thời gian hoàn trả hộp',
  DeliveryTime2: 'Thời gian giao kho',
  DeliveryDate: 'Ngày giao hàng',
  Query: 'Yêu cầu',
  Return: 'Quay lại',
  Prompt1: 'Vui lòng nhập số doanh nghiệp để yêu cầu',
  ResetFilter: 'Đặt lại điều kiện',
  Tip1: 'Nhấp đúp để hiển thị trạng thái SOP',
  TipCharge: 'Nhấp để hiển thị thông tin cơ bản về doanh nghiệp',
  MBLIssueBillLading: 'Tình trạng phát hành MBL B/L',
  HBLIssueBillLading: 'HBL tình trạng phát hành B/L',
  ConsignationRelationNumber: 'Số liên kết ủy quyền',
  BusinessCommissionedRelationNumber: 'Liên hệ',
  ChannelNo: 'Số kênh',
  Customer: 'Khách hàng',
  ConsignationStatus: 'Trạng thái ủy nhiệm',
  ConsignationStatusTime: 'Thời gian delegate state',
  PlaceOfDelivery: 'Nơi giao hàng',
  FinalPlaceOfDelivery: 'Nơi giao hàng cuối cùng',
  DeliveryCountry: 'Quốc gia nơi giao hàng',
  AirlineArea: 'Tuyến đường (khu vực)',
  SequenceNumber: 'Số sê-ri',
  Tip2: 'Truy vấn bản ghi đẩy dữ liệu',
  View: 'Xem thêm',
  Edit: 'Chỉnh sửa',
  Cancel: 'Hủy bỏ',
  SaveTheDefaultValues: 'Lưu mặc định',
  NominatedAgent: 'ĐL VC chỉ định',
  NominatedAgentCount: 'Chỉ định số lượng đại lý hàng hóa',
  ActualQuantity: 'Số mảnh TT',
  ActualWeight: 'T.trọng TT',
  ActualVolume: 'KL thực tế',
  ChargedWeight: 'Trọng lượng TT',
  VolumetricWeight: 'Tài liệu',
  ChargedWeightRT: 'Trọng lượng thanh toán RT',
  BookingProperty: 'Tính chất đặt cọc',
  IssueMethod: 'Cách ra đơn',
  TradeMethod: 'Phương thức giao dịch',
  HBLFreightClause: 'Điều khoản cước vận chuyển',
  HBLFreightClauseTootip: 'Điều khoản cước vận chuyển',
  MBLTransportationClause: 'Điều khoản vận chuyển đơn chính',
  MBLTransportationClauseTootip: 'Điều khoản vận chuyển đơn chính',
  HBLTransportationClause: 'Điều khoản vận chuyển Split Order',
  HBLTransportationClauseTootip: 'Điều khoản vận chuyển Split Order',
  ContainerDescription: 'Mô tả khối lượng hộp',
  FeeCreationDate: 'Ngày tạo phí',
  MBLSplitNo: 'Số đơn hàng chính',
  HBLSplitNo: 'Số tách',
  HarborDistrict: 'Khu cảng',
  SOPStatus: 'Trạng thái SOP',
  HDS: 'HDS',
  TEU: 'TEU',
  AirlinePerson: 'Đường bay (người phụ trách)',
  AirlinePerson2: 'Trang chủ',
  AirlineOffice: 'Công ty đường bay',
  AirlineDepartment: 'Phòng tuyến',
  BusinessCreator: 'Người sáng lập doanh nghiệp',
  Status: 'Trạng thái',
  HblNo: 'HBL NO',
  RelevanceSoNo: 'Liên hệ SO NO',
  DangerousGoodsClassification: 'Phân loại mức nguy hiểm',
  DangerousGoodsUNNo: 'Hàng hóa nguy hiểm UN No',
  FinalDestination: 'Điểm đến cuối cùng',
  HBLShipper: 'Vận chuyển bởi Drop Order',
  HBLConsignee: 'Người nhận hàng',
  Add: 'Mới',
  mergeHblData: 'Hợp nhất thông tin hủy HB/L',
  Delete: 'Xoá',
  AddHbl: 'Vé chính mới',
  SplitHbl: 'Chia vé chính',
  ExportToExcel: 'Xuất Excel',
  OverseasAgentEDI: 'Đại lý nước ngoài EDI',
  EditSopStatus: 'Sửa đổi trạng thái',
  BatchPrint: 'In hàng loạt',
  BatchVessel: 'Chuyển hàng loạt',
  BatchUpdateType: 'Sửa đổi hàng loạt kiểu đánh vần hoàn chỉnh',
  Statistics: 'Thống kê',
  BatchCommit: 'Gửi hàng loạt',
  AddCharges: 'Phí mới',
  EditCharges: 'Chi phí biên tập',
  DeleteCharges: 'Phí xóa',
  print: 'In ấn',
  PrintFclProfit: 'In lợi nhuận FCL',
  PrintLclProfit: 'LCL lợi nhuận in',
  PreSubmission: 'Gửi trước',
  BatchPreSubmission: 'Pre-Submission số lượng lớn',
  BatchCancellation: 'Hủy bỏ hàng loạt',
  Submission: 'Giới thiệu',
  SubmissionDateTime: 'Thời gian gửi',
  AuditDateTime: 'Thời gian xét duyệt',
  Consignation: 'Trang chủ',
  FreightStation: 'Trạm hàng hóa',
  SignBill: 'Đăng ký',
  ConsignationSI: 'Xuất khẩu sang nhập khẩu',
  CrossTenantSeToSiEtaMustNoNull: 'Xin vui lòng điền thêm vào trường: ngày dự kiến đến cảng, trường này là bắt buộc ở bên nhập khẩu!',
  ReturnAction: 'Quay lại hoạt động',
  PrintReturn: 'Rút tiền',
  AssociationBusinessInformation: 'Thông tin doanh nghiệp liên kết',
  AssociationBusinessInformationSI: 'Thông tin doanh nghiệp liên quan',
  ShowAssociationBusinessInformationSI: 'Xem thông tin doanh nghiệp nhập khẩu đường biển liên kết',
  Basic: 'Cơ bản',
  Booking: 'Đặt phòng',
  EnterTheCabin: 'vào cabin',
  DataTracking: 'Theo dõi dữ liệu',
  AirDataTracking: 'Theo dõi vận chuyển',
  CustomsDeclaration: 'Khai báo hải quan',
  InsureInfo: 'Bảo hiểm',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: 'Hình thức đặt hàng',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: 'Kiểm tra thương mại',
  Fumigation: 'Khử trùng',
  ForeignTrade: 'Ngoại thương',
  ConsignInfo: 'Thông tin ủy quyền',
  RequiredItem: 'Mục bắt buộc',
  CustomerProperty: 'Tài sản khách hàng',
  ContactPerson: 'Liên hệ',
  CustomerContactPerson: 'Liên hệ khách hàng',
  ContactPhone: 'Điện thoại liên hệ khách hàng',
  ContactMobile: 'Điện thoại liên hệ khách hàng',
  Detail: 'Chi tiết',
  OperationDate: 'Ngày hoạt động',
  ManageAuditStatus: 'Tình trạng kiểm toán lợi nhuận',
  PlaceOfDelivery2: 'Địa điểm nhận hàng',
  Transit: 'TrungC',
  PleaseSelectShippingCompany: 'Vui lòng chọn công ty tàu',
  AdditionalInformation: 'Thông tin bổ sung',
  WarehouseLoadingStorage: 'ĐG/KB',
  DoorLoadingDelivery: 'PKG PT/PU',
  NotResponsibleForTruckingAndLoading: 'Tự kéo tự gửi',
  AutoDistribution: 'Phân phối tự động',
  ObtainTheWarehouseNo: 'Số VT đến',
  MblNo3: 'Số vé chính',
  MasterBusinessNo: 'Số doanh nghiệp vé chính',
  PleaseTickCustomsDeclarationOption: 'Chọn 【Khai báo hải quan】',
  PleaseTickDoorLoadingDeliveryOption: 'Chọn 【Điểm đóng gói/Pick Up】',
  PleaseSelectWarehouse: 'Chọn 【Đóng gói/lưu trữ bên trong】',
  PleaseCheckWarehouses: 'Chọn 【Kho bãi】',
  PlaceOfMblPayment: 'Nơi thanh toán đơn hàng chính',
  PlaceOfHblPayment: 'Nơi thanh toán thả',
  CargoSize: 'Kích thước hàng hóa',
  SpecialPriceInstructions: 'Mô tả đặc biệt',
  DirectBusiness: 'ĐT',
  Transport: 'VC',
  InBatches: 'HL',
  SpecialPrice: 'GĐB',
  ContainerInfo: 'Thông tin đóng gói',
  QuantityConsignActual: 'Số kiện (ủy ban)',
  WeightConsignActual: 'Tổng trọng lượng (ủy ban)',
  CubageConsignActual: 'Thể tích (ủy/thực)',
  VolumetricWeightConsignActual: 'Tài liệu (ủy ban)',
  ChargeWeightConsignActual: 'Trọng lượng tính phí (ủy ban)',
  Package: 'Đóng gói',
  Pieces: 'Số mảnh nhỏ',
  PiecesType: 'Số lượng nhỏ bao bì',
  Copy2: 'Bản sao',
  EnglishDescriptionOfGoods: 'Tên tiếng Anh',
  Marks: 'NH Vận chuyển',
  NCReferenceNo: 'Số tham chiếu hàng hóa được chỉ định',
  SendProxyForecasts: 'Gửi dự báo proxy',
  SerialNumber: 'Số sê-ri S/N',
  Brand: 'Thương hiệu Brand',
  ProductiveYear: 'Năm sản xuất',
  CustomsValue: 'Giá trị khai hải quan',
  UnitType: 'Mô hình thiết bị',
  DeviceType: 'Loại thiết bị Category',
  CountryOrigin1: 'Nước xuất xứ',
  DeviceStatus: 'Tình trạng thiết bị (cũ và mới)',
  HsCode: 'Số HS',
  bookingNotes: 'Ghi chú đặt phòng',
  DangerousGoodsRemarks: 'Hàng nguy hiểm Ghi chú',
  BootHelperPage: 'Trang trợ giúp khởi động',
  ChineseDescriptionOfGoods: 'Tên Trung Quốc',
  OperationInfo: 'Thông tin hoạt động',
  SalesCompany: 'Công ty bán hàng',
  OperationCompany: 'Công ty vận hành',
  OperationRequirements: 'Yêu cầu hoạt động',
  DoubleClickToAddOperationRequirements: 'Nhấp đúp vào Add Action Requirements',
  OperationTips: 'Mẹo hoạt động',
  ExtraChargeClause: 'Điều khoản phụ phí',
  DoubleClickToAddExtraChargeClause: 'Double Click Thêm điều khoản phụ phí',
  WarehousingInfo: 'Thông tin nhập kho',
  Remarks: 'Ghi chú',
  BasicRemarks: 'Ghi chú (cơ bản)',
  manifestInformation: 'Thông tin cơ bản về Manifest',
  manifestChannel: 'Kênh Manifest được trang bị sẵn',
  CustomerDeliveryInfo: 'Thông tin vận chuyển của khách hàng',
  CodeSearching: 'Mã TX',
  CopyToSeller: 'SC cho NB',
  CopyToBuyer: 'SC cho NM',
  ExpandSellerBuyer: 'Mở rộng người bán/người mua',
  NoHouseNumber: 'Không có số nhà',
  NotifyParty: 'Thông báo',
  NotifyPartyCode: 'Thông báo code',
  MblShipperLine1: 'Người gửi hàng MBL',
  MblConsigneeLine1: 'Người nhận hàng MBL',
  MblNotifyLine1: 'Thông báo MBL',
  DocDispatchingPlace: 'Nơi vận chuyển B/L',
  SecondNotifyParty: 'Thông báo thứ hai',
  PleaseSelect: 'Vui lòng chọn',
  Add2: 'Mới',
  WhetherDeclarations: 'Khai báo hải quan',
  InBatchesOrNot: 'Hàng loạt',
  BookingInfo: 'Thông tin đặt phòng',
  MultiJourneyAirline: 'Bộ phận đa hành trình',
  NumberPasses: 'Số chương trình',
  MergingTickets: 'Gộp vé nhỏ',
  TicketsInfo: 'Thông tin vé nhỏ',
  TotalTickets: 'Tổng số phiếu',
  NewTickets: 'Thêm vé nhỏ',
  EditTickets: 'Biên tập vé nhỏ',
  AddTickets: 'Tham gia vé nhỏ',
  RemoveTickets: 'Xóa vé nhỏ',
  DeleteTickets: 'Xóa vé nhỏ',
  Etd: 'ETD',
  SoNo: 'Số đóng',
  FunctionalOperation: 'Hoạt động chức năng',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: 'Biển hiệu tàu',
  USAirlineInfo: 'Thông tin Beauty Line',
  PortInfo: 'Thông tin cảng',
  PolPortInfo: 'Thông tin cảng khởi hành',
  PolAirPortInfo: 'Cảng khởi hành Thông tin sân bay',
  PodPortInfo: 'Thông tin cảng đích',
  PodAirPortInfo: 'Thông tin sân bay cảng đích',
  LocalTime: '(Dữ liệu được trả về theo giờ địa phương)',
  TopLocalTime: 'Lưu ý: Thời gian hiển thị giờ địa phương',
  CYOpeningDate: 'Ngày mở cửa',
  PolPortInfoPrompt: 'Trường màu cam có thể hỗ trợ ghi lại dữ liệu sau khi mở dịch vụ dữ liệu',
  CYOpeningTime: 'Thời gian mở cửa',
  CYCutOffDate: 'Ngày chặn cảng',
  PortAreaCYCutOffTime: 'Thời gian đóng cảng',
  CarrierCyCutOffTime: 'Thời gian đóng tàu của công ty',
  PlannedDateOfBerthing: 'Lịch trình neo đậu',
  PlannedDateOfLeavingBerth: 'Ngày khởi hành dự kiến',
  ActualDateOfBerthing: 'Ngày neo đậu thực tế',
  ActualDateOfLeavingBerth: 'Ngày khởi hành thực tế',
  PlannedDockingBerths: 'Kế hoạch neo đậu',
  TheActualDockingBerths: 'Bến thực tế',
  ActualTimeOfArrivalThePort: 'Ngày đến thực tế',
  EquipmentEstimatedReturnTime: 'Dự kiến trong thời gian hoàn trả',
  EquipmentEstimatedReturnTimeTootip: 'Dự kiến trong thời gian hoàn trả',
  To: 'Đến',
  OtherInfo: 'Thông tin khác',
  CyCode: 'Mã sân',
  PortCodeOfDischarge: 'Mã cảng dỡ hàng',
  EquipmentReceiptAddress: 'Địa chỉ D/P',
  EquipmentReceiptContactPerson: 'Liên hệ D/P',
  EquipmentReceiptContactWay: 'D/P Thông tin liên hệ',
  CustomerCyCutOffDate: 'Ngày đóng cửa của khách hàng',
  CustomerShutOutDate: 'Ngày hoàn thuế của khách hàng',
  AmsEnsCyCutOffDate: 'Ngày đóng cửa AMS/ENS',
  FreeDetension: 'Thời gian thuê miễn phí',
  SecondVesselInfo: 'Thông tin đường biển 2',
  AirSecondVesselInfo: 'Thông tin chuyến bay thứ hai',
  SecondVoyage: 'Chuyến bay hai chiều',
  BargeInfo: 'Thông tin Barge',
  ServiceCode: 'Mã đường tàu',
  ModulesInfo: 'Thông tin cabin',
  ShippingAdviceRemark: 'Shippingadvice Ghi chú',
  BookingConfirmationRemarks: 'Ghi chú thông báo cabin',
  InviteToChecktheBL: 'Mời đến Single',
  ConfirmChecking: 'Xác nhận cặp',
  IdentificationList: 'Xác định cặp đơn',
  ChecktheBLBySmart: 'Thông minh đến Single',
  ViewCheckingFile: 'Xem tập tin cặp đơn',
  CheckingHistory: 'Lịch sử Single',
  UploadGuarantee: 'Tải lên bảo lãnh',
  ReceiptHistory: 'Trả lại lịch sử',
  CopyTheDataBy: 'Sao chép dữ liệu',
  CopyFromTheLastTime: 'Sao chép lần trước',
  CopyFromOtherBill: 'Bản sao số đơn',
  CopyFromHbl: 'Bản sao HBL',
  CompleteTheDetails: 'Hoàn thành bổ sung',
  Printed: 'Đã in',
  Locked: 'Đã khóa',
  ShipperLocked: 'Gửi hàng bị khóa',
  BlBeReleased: 'Đặt hàng ngoài trời',
  BlEdi: 'Vận đơn EDI',
  ManifestEdi: 'Bản kê khai EDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: 'Số niêm phong hộp theo sau là số mảnh Tổng khối lượng',
  PrintBargeVesselAndVoyage: 'In tên tàu sà lan',
  ConsigneeShipperAndNotifyInfo: 'Gửi và nhận tin nhắn',
  Reset: 'Xoá',
  CopyTheConsignee: 'SaoChép NH',
  CargoInfo: 'Thông tin hàng hóa',
  OnlyOriginalSend: 'Chỉ gửi bản gốc',
  OnlyAddAndDeleteSend: 'Chỉ gửi sửa đổi và xóa',
  NoSuccessAddAndDeleteNotSend: 'Gửi không thành công, không thể gửi lại sửa đổi hoặc xóa',
  NeedFillPortBeforeEnteringEU: 'Cần điền cảng trước khi vào EU',
  SyncContainerInfoTotal: 'Lấy thông tin đóng gói Các bộ phận tóc',
  SyncContainerInfoContent: 'Thông tin đóng gói Phần tóc phủ MBL, nó có được phủ không?',
  SyncContainerInfoQuantity: 'Số lượng kiện (packing): {0}->Số lượng kiện (MBL): {1}',
  SyncContainerInfoWeight: 'Tổng trọng lượng (đóng hộp): {0}->Tổng trọng lượng (MBL): {1}',
  SyncContainerInfoCubage: 'Khối lượng (đóng hộp): {0}->Khối lượng (MBL): {1}',
  NumberOfPackagesOnBl: 'Nâng số mảnh',
  Pieces2: 'Số mảnh nhỏ',
  PiecesType2: 'Gói mảnh nhỏ',
  Weight: 'Tổng trọng lượng',
  WeightUnit: 'Đơn vị tổng trọng lượng',
  Cubage: 'Khối lượng',
  CubageUnit: 'Đơn vị khối lượng',
  CopyEnglishDescriptionOfGoodsFromReceipt: 'Tên hóa đơn (EN)',
  CopyEnglishDescriptionOfGoodsFromHBL: 'Tên HBL (EN)',
  CopyMarksFromHbl: 'Lấy nhãn hiệu HBL',
  CapitalizedNumbersOfPackages: 'Số mảnh viết hoa',
  TransportInfo: 'Thông tin vận chuyển',
  VesselAndVoyage: 'Tên tàu Chuyến bay',
  PlaceOfReceipt: 'Nơi gửi hàng',
  PlaceOfReceiptOnBl: 'Nơi vận chuyển B/L',
  PlaceOfReceiptCodeOnBl: 'Nơi giao hàng (Mã)',
  PlaceHolderPOR: 'Vui lòng chọn nơi vận chuyển B/L',
  PlaceOfReceiptOnBlTootip: 'Nơi vận chuyển B/L',
  PortOfLoadingOnBl: 'Cảng khởi hành B/L',
  PortOfDischargeOnBl: 'Cảng dỡ hàng B/L',
  PlaceOfDeliveryOnBl: 'Nơi giao hàng B/L',
  BlFinalDestination: 'Điểm đến cuối cùng của B/L',
  MethodOfMblPayment: 'Phương thức thanh toán MBL',
  PlaceOfMblPayment2: 'Nơi thanh toán MBL',
  TransportationClause: 'Điều khoản vận chuyển',
  NoOfOriginalBls: 'Số lượng khẩu phần B/L',
  NoOfCopyBls: 'Số bản sao',
  PlaceOfIssue: 'Nơi phát hành',
  DateOfIssue: 'Ngày cấp',
  HBLDateOfIssue: 'Ngày cấp HBL',
  BlRemarks: 'Ghi chú B/L',
  BlType: 'Phương pháp B/L',
  HBLBlType: 'Cách HBL B/L',
  MBLBlType: 'Phương pháp vận đơn MBL',
  MBLBlProperty: 'Các loại vận đơn MBL',
  HBLBlProperty: 'Các loại HBL B/L',
  LastEntryPort: 'Cảng nhập cảnh cuối cùng',
  BlProperty: 'Loại B/L',
  CheckingStatus: 'B/L xác nhận trạng thái',
  BillLadingIssued: 'Tình trạng phát hành B/L',
  HBLCheckingStatus: 'Trạng thái vận đơn HBL',
  MBLCheckingStatus: 'Tình trạng vận đơn MBL',
  ReleasingStatus: 'Trạng thái kiểm tra đặt hàng',
  HBLReleasingStatus: 'Trạng thái HBL',
  MBLReleasingStatus: 'MBL đặt trạng thái',
  ReleaseEligibleStatus: 'Release Eligibility',
  ReleaseEligibleYes: 'Releasable',
  ReleaseEligibleNo: 'Not Releasable',
  FormalHblReleaseType: 'Hình thức Phương pháp chia nhỏ',
  FormalHblStatus: 'Hình thức Trạng thái đơn hàng',
  FormalHblIssuedStatus: 'Hình thức Trạng thái phát hành lệnh phụ',
  FormalHblType: 'Hình thức Loại đơn đặt hàng',
  FormalHblCombineNo: 'Mẫu đơn và số đơn',
  fields: 'Field và',
  tab: 'Trang ký',
  hint: 'Trường không phù hợp, bạn có xác nhận gửi không?',
  Audit: 'Đánh giá',
  Payable: 'Thanh toán sẵn có',
  CargoDetention: 'Khấu trừ hàng hóa',
  PaymentDate: 'Ngày thanh toán',
  PaymentDate2: 'Ngày thanh toán',
  DateOfCargoDetention: 'Ngày khấu trừ',
  BlReleasingNo: 'Đặt số đơn',
  BlReleasingApplicationTime: 'Thời gian nộp đơn',
  BlReleasingApplicationPerson: 'Đặt đơn xin việc',
  ParamRemark: 'Ghi chú chữ ký',
  ShippingCompanySCAC: 'Hãng tàu SCAC',
  OverseasAgentSCAC: 'Đại lý nước ngoài SCAC',
  ShipperType: 'Loại vận chuyển',
  ManifestDescriptionOfGoods: 'Danh sách sản phẩm',
  ReasonOfCargoDetention: 'Lý do khấu trừ',
  HblNo2: 'Số HBL',
  MblNo: 'Số MBL',
  Quantity: 'Số mảnh',
  WeightKg: 'Tổng trọng lượng (KG)',
  CubageCbm: 'Khối lượng (CBM)',
  ContainerAmount: 'Số lượng hộp',
  CNTRNOSSEALNOS: 'Thông tin niêm phong hộp',
  BillOfLadingPackingInfo: 'Thông tin đóng gói B/L',
  CopyMblConsignee: 'NC.NNH',
  CopyNominatedAgentInfo: 'Lấy thông tin đại lý đặt hàng',
  PrintTheOriginalBl: 'In bản gốc',
  TelexRelease: 'In điện phóng',
  Unlock: 'Mở khóa',
  AntiTerroristFormattedAddress: 'Định dạng chống KB',
  BlBeReleasedElsewhereOrNot: 'Đặt hàng ngoài đất liền',
  ClauseOfNoWoodPackingMaterial: 'Điều khoản đóng gói không bằng gỗ',
  AFRTheLastBill: 'Phiếu bầu cuối cùng của AFR',
  CopyEnglishDescriptionOfGoodsFromMbl: 'Lấy tên tiếng Anh của MBL',
  CopyMarksFromMbl: 'Lấy nhãn hiệu MBL',
  BillOfLadingNumber: 'Số dòng chảy B/L',
  HBLBillOfLadingNumber: 'Số dòng vận đơn HBL',
  MethodOfHblPayment: 'Phương thức thanh toán HBL',
  PlaceOfHblPayment2: 'Địa điểm thanh toán HBL',
  CheckingQuestions: 'Câu hỏi đơn',
  BlType2: 'Loại B/L',
  HBLBlType2: 'Loại HBL B/L',
  DataSent: 'Thông tin đã gửi',
  Completed: 'Hoàn thành',
  paste: 'Dán tập tin đính kèm',
  V3remind: 'Vui lòng sao chép tệp đính kèm trước',
  DateOfcompletion: 'Ngày hoàn thành',
  GenerationOfABillOfLading: 'Vận đơn thế hệ',
  GenerationOfABillOfLading2: 'Vận đơn thế hệ',
  ShipperContactTelNo: 'Số điện thoại liên lạc của người gửi hàng',
  ConsigneeContactTelNo: 'Số điện thoại liên lạc người nhận hàng',
  NotifyPartyTelNo: 'Thông báo số điện thoại liên lạc',
  ChargeClause: 'Điều khoản thanh toán',
  Amount: 'Số lượng',
  CopyCargoDescriptionAndMarks: 'Nhãn hiệu Sao chép tên',
  CopyMbl: 'Sao chép MBL',
  RelatedMbl: 'Danh sách chính liên quan',
  Add3: 'Tham gia',
  Copy: 'Bản sao',
  Send: 'Gửi',
  CheckStatus: 'Trạng thái truy vấn',
  ImportButNotSend: 'Nhập khẩu không gửi',
  CapitalizedNumbersOfEquipmentWeight: 'Trọng lượng hộp Chữ hoa',
  AmsSplitNo: 'Đơn vị AMS',
  AmsNo: 'Số AMS',
  EManifestSplitNo: 'Mã số eManifest',
  EManifestNo: 'Số eManifest',
  BlSplitList: 'Danh sách thả',
  sendStatusAMS: 'Trạng thái gửi (AMS)',
  sendStatusISF: 'Trạng thái gửi (ISF)',
  sendStatus: 'Trạng thái gửi',
  SealNoChangeAdfterInspection: 'Kiểm tra Thay đổi dấu niêm phong',
  AutoAllocation: 'Đóng hộp tự động',
  AutoAllocationContract: 'Đóng hộp tự động (ủy quyền)',
  CleanOutTheLoadingRecord: 'Xóa hồ sơ đóng gói',
  DeleteTheLoadingRecord: 'Gỡ bỏ Boxing Records',
  CargoQuantityDescription: 'Mô tả khối lượng hàng hóa',
  TotalNumberOfPackages: 'Tổng số mảnh',
  ContainerSize: 'Loại hộp',
  ContainerType: 'Loại hộp',
  ContainerWeight: 'Trọng lượng hộp',
  SealNo: 'Số niêm phong',
  TravelTrajectory: 'Đường mòn đột quỵ',
  DrivingState: 'Trạng thái lái hiện tại',
  CurrentVehicleLocation: 'Vị trí xe hiện tại',
  GetContainerNo: 'Lấy số hộp',
  TotalWeight: 'Tổng trọng lượng',
  TotalCubage: 'Tổng khối lượng',
  Soc: 'Hộp chính',
  Inspection: 'Kiểm tra',
  ApproachDate: 'Thời gian nhập cảnh',
  PlayDate: 'Thời gian xuất hiện',
  LoadingPort: 'Cảng bốc hàng',
  TheArrivalOfPacketsSent: 'Thời gian gửi thư đến',
  CustomsClearanceInfo: 'Thông tin phát hành hải quan',
  DataTrackingBlHasNotContainer: 'Số vận đơn {0}, vui lòng truy cập trang thông tin đóng gói sau khi sử dụng chức năng so sánh dữ liệu. Trang này sẽ hiển thị các chi tiết của hộp.',
  WharfReleaseInfo: 'Thông tin giải phóng bến tàu',
  ContainerAscription: 'Hộp thuộc',
  PlateNumber: 'Số xe',
  plateApproachDate: 'Thời gian nhận thẻ',
  platePlayDate: 'Thời gian xuất hiện của thẻ',
  PackageType: 'Loại bao bì',
  NumberOfVotes: 'Số phiếu',
  EmptyContainerWeight: 'Trọng lượng thùng rỗng',
  VgmWeight: 'Trọng lượng VGM',
  VgmWeighingMethod: 'Phương pháp cân VGM',
  VgmWeighingTime: 'VGM cân thời gian',
  WeightTime: 'Thời gian cân',
  VgmWeighingPlace: 'Vị trí cân VGM',
  WeighingPartyAddress: 'Địa chỉ bên cân trọng lượng',
  StationStatus: 'Trạng thái trạm',
  CargosGrossWeight: 'Tổng trọng lượng hàng hóa',
  VgmContactPerson: 'Liên hệ VGM',
  VgmContactEmailAddress: 'Hộp thư liên hệ VGM',
  VgmContactWay: 'Thông tin liên hệ VGM',
  VgmResponsiblePerson: 'Giám đốc VGM',
  ContactEmailAddress: 'Liên hệ hộp thư',
  ContactWay: 'Thông tin liên hệ',
  ContactAddress: 'Địa chỉ liên hệ',
  ResponsiblePerson: 'Trang chủ',
  Name: 'Tên',
  Warehouse2: 'Kho chứa bên trong',
  WarehouseLoading: 'Đóng gói trong kho',
  LoadingCharge: 'Phí đóng gói',
  LoadingCharge2: 'Phí đóng gói',
  BoxOwner: 'Hộp chủ',
  RmbNumberOfDamagedAndDamp: 'Số mảnh vỡ ẩm',
  RmbNumberOfDamagedAndDamp2: 'Số mảnh vỡ ẩm',
  Tel: 'Đ.thoại',
  CargosExpectedArrivalDate: 'Ngày giao hàng dự kiến',
  WarehouseAddress: 'Địa chỉ kho',
  LoadingRemarks: 'Trang bị bên trong',
  DoorToDoorLoading: 'Cửa đến cửa Boxing',
  MultiDoors: 'Điểm nhiều cửa',
  HaulageNo: 'Số xe.',
  HaulageCharge: 'Phí trailer',
  AuditMoney: 'Số tiền xác nhận',
  AuditState: 'Tình trạng chi phí',
  HaulageContactPerson: 'Liên hệ',
  Door: 'Điểm cửa',
  AddDoor: 'Thêm điểm cửa',
  DestinationGatewayCity: 'Điểm đến thành phố',
  DoorContactPerson: 'Liên hệ DoorPoint',
  DoorAddress: 'Địa chỉ cửa',
  DispatchVehiclesAtDestinationDoorAddress: 'Địa chỉ cửa xe',
  DoorCity: 'Thành phố Gate Point',
  Driver: 'Tài xế',
  ComprehensiveLogisticsOrderType: 'Các loại lệnh logistics tích hợp',
  ComprehensiveLogisticsTransportationType: 'Các loại hình vận tải logistics tích hợp',
  TransportType: 'Loại vận chuyển',
  SameTransportationCompany: 'Các công ty vận tải tương tự',
  SameDoorPoint: 'Cửa giống nhau',
  ReturnYard: 'Bãi trả thùng',
  DriverIDCard: 'ID tài xế',
  DestinationGatePoint: 'Điểm đến',
  DepartureGatePoint: 'Điểm khởi hành',
  AddressOfDestinationGatePoint: 'Địa chỉ điểm đến',
  DestinationGateCity: 'Thành phố Gateway Point',
  CarryingCaseYard: 'bãi tote',
  EstimatedPackingDate: 'Ngày đóng gói dự kiến (đến nhà máy)',
  ActualPackingDate: 'Ngày đóng gói thực tế (đến nhà máy)',
  EstPackingDate: 'Ngày đóng gói dự kiến (đến kho)',
  ActPackingDate: 'Ngày đóng gói thực tế (đến kho)',
  ExpectedArrivalDate2: 'Ngày giao hàng dự kiến',
  ActualArrivalDate: 'Ngày đến thực tế',
  GatheringTrailer: 'Bộ sưu tập Trailer',
  WholeVehicleLessThanCarload: 'Toàn bộ xe tải',
  TruckCustomerService: 'Hỗ trợ xe tải',
  DtdDTWWTD: 'Cửa đến cửa/Cửa đến silo/Thùng đến cửa',
  DoorToDoor: 'Cửa đến cửa',
  DoorToWarehouse: 'Cửa đến kho',
  WarehouseToDoor: 'Kho đến cửa',
  AdditionalNotes: 'Hướng dẫn bổ sung',
  AssociatedPackingInfo: 'Thông tin đóng gói liên kết',
  RemoveAssociations: 'Xóa liên kết',
  DispatchTuckOrder: 'Đặt hàng',
  ModifyTuckOrder: 'Thay đổi danh sách',
  TuckStatusDescription: 'Gửi xe Chi tiết',
  ManualDistribution: 'Giao hàng thủ công',
  Unlock2: 'Giải tán',
  Size: 'Kích thước',
  WhetherOrNotBroken: 'Phá vỡ',
  BrokenDesc: 'Mô tả thiệt hại hàng hóa',
  BangPic: 'Ảnh vào kho',
  WareHouseName: 'Tên kho',
  WarehouseSupplier: 'Nhà cung cấp kho',
  WareHouseMarks: 'Thương hiệu vận chuyển kho',
  CustomsDeclarationInfo: 'Thông tin khai hải quan',
  OnwardInfo: 'Thông tin tiếp tục',
  TheActualFlight: 'Chuyến bay thực tế',
  NewCustomsDeclaration: 'Tờ khai hải quan mới',
  EditCustomsDeclaration: 'Biên tập tờ khai hải quan',
  DeleteCustomsDeclaration: 'Xóa tờ khai hải quan',
  BlNo: 'Số vận đơn',
  OperatingCompany: 'Đơn vị kinh doanh',
  CustomsCode: 'Mã khai hải quan 10 chữ số',
  DateOfCustomsDeclaration: 'Ngày khai hải quan',
  StatusOfCustomsDeclaration: 'Tình trạng khai hải quan',
  CommodityInspectionOrNot: 'Kiểm tra thương mại',
  CustomsInspectionOrNot: 'Kiểm tra',
  UploadFile: 'Tải lên tập tin',
  CustomsFile: 'Tài liệu khai hải quan',
  Chargeback: 'Thanh toán',
  TemplateDownload: 'Tải xuống mẫu',
  ExcelImport: 'Excel nhập',
  ExcelExport: 'Xuất Excel',
  OrderNo: 'Order No Số đơn hàng',
  CaseNo: 'Case No_Số',
  Item: 'ITEM Mã sản phẩm',
  Sub: 'SUB Số lô',
  Size2: 'Thông số',
  CommodityClassification: 'Danh mục',
  Qty: 'QTY_Số lượng',
  BillingQTY: 'Số hóa đơn',
  UnitOfMeasurement: 'Đơn vị đo lường',
  NetWeight: 'Trọng lượng tịnh',
  CustomsDutyRate: 'Thuế suất thuế',
  CustomsDuties: 'Thuế quan',
  IncrementValueDutyRate: 'Thuế suất VAT',
  IncrementValueDuty: 'Thuế giá trị gia tăng',
  ConsumptionDutyRate: 'Thuế suất GST',
  ConsumptionDuty: 'Thuế tiêu thụ đặc biệt',
  ConsolidatedTax: 'Thuế tổng hợp',
  Currency: 'Tiền tệ',
  ExchangeRate: 'Tỷ giá hối đoái',
  CargoPrice: 'Giá hàng',
  Tax: 'Tiền thuế',
  TaxRate: 'Thuế suất',
  BigBagNo: 'Số gói lớn',
  BigBagWeight: 'Trọng lượng túi lớn',
  BigBagWeightUnit: 'Đơn vị trọng lượng',
  BigBagLength: 'Túi lớn bọc chiều dài',
  BigBagWidth: 'Chiều rộng gói lớn',
  BigBagHeight: 'Gói lớn cao',
  BigBagDimensionUnit: 'Đơn vị chiều dài túi lớn',
  BigBagGoodsType: 'Loại hàng hóa túi lớn',
  FulfillmentLabel: 'Loại Performance',
  LandingPort: 'Cửa khẩu hạ cánh',
  PackageQuantity: 'Số lượng gói nhỏ',
  ExpectPickupStartTime: 'Mong đợi thời gian bắt đầu',
  ExpectPickupEndTime: 'Mong chờ thời gian kết thúc',
  PreviousCarrierCode: 'Mã dịch vụ trước',
  PreviousResourceCode: 'Mã nguồn trước',
  NextCarrierCode: 'Mã dịch vụ tiếp theo',
  NextResourceCode: 'Mã nguồn tiếp theo',
  SortCode: 'Mã phân loại túi lớn',
  BuyerRegion: 'Quốc gia đích',
  AddressL0: 'Địa chỉ L0',
  AddressL1: 'Địa chỉ L1',
  AddressL2: 'Địa chỉ L2',
  AddressL3: 'Địa chỉ cấp L3',
  AddressL4: 'Địa chỉ L4',
  DetailsAddressMore: 'Chi tiết địa chỉ 2',
  PickupFirstName: 'Tên người nhận',
  PickupLastName: 'Tên người nhận',
  PickupCompany: 'Name',
  PickupZip: 'Địa chỉ bưu điện',
  PickupPhone: 'Số điện thoại di động',
  TtOrderCode: 'Số bảng tt',
  MwbNo: 'Số vận đơn của người phục vụ',
  Export9610File: 'Xuất tập tin 9610',
  BatchChangeCompany: 'Công ty thay thế hàng loạt',
  OnlyCheckOneData: 'Chỉ cho phép đánh dấu một phần dữ liệu',
  NoteUseNumLast: 'Lưu ý: Số đơn sẽ không được tạo lại sau khi thay thế công ty và vẫn sử dụng số đơn hiện có.',
  OrderNo2: 'Số thứ tự',
  SupportSales: 'Hỗ trợ bán hàng',
  OrderAmount: 'Số lượng đặt hàng',
  ServiceFeeDiscountRate: 'Tỷ lệ chiết khấu phí dịch vụ',
  OperatingInstructions: 'Hướng dẫn vận hành',
  OrderCurrency: 'Đơn hàng tiền tệ',
  TheAmountOfWriteOffs: 'Số lượng lệnh nuclei',
  TheFirstBusinessOrNot: 'Đơn hàng đầu tiên',
  Salesman: 'Nhân viên kinh doanh',
  OrderExchangeRate: 'Tỷ giá đặt hàng',
  Difference: 'Khác biệt',
  FrameContractNumber: 'Số hợp đồng khung',
  PaymentNo: 'Số chuyển khoản',
  PaymentAmount: 'Số tiền thanh toán',
  ThePrePayment: 'Thanh toán trước',
  PaymentExchangeRate: 'Tỷ giá hối đoái',
  ActualPaymentAmount: 'Số tiền chuyển khoản thực tế',
  ServiceCharge: 'Phí xử lý',
  PostalCharges: 'Chi phí bưu điện',
  AcceptanceFee: 'Phí chấp nhận',
  RetreatMoreFillLessAmount: 'Trả lại nhiều, trả lại ít.',
  Total: 'Tóm tắt',
  UnpaidAmount: 'Số tiền chưa thanh toán',
  No: 'Không',
  Yes: 'Vâng',
  New: 'Mới',
  Clone: 'Sao chép',
  Send2: 'Gửi đi',
  Back: 'Lấy lại',
  ExpressInfo: 'CPN',
  PrintReceipt: 'In phiếu trả lại',
  FileType: 'Kiểu tập tin',
  FileType2: 'Loại',
  FileCategory: 'Danh mục tập tin',
  CustomsNo: 'Số hải quan',
  SendingDate: 'Ngày gửi',
  SendingExpressNumber: 'Gửi số chuyển phát nhanh',
  ReceivingDate: 'Lấy ngày',
  Receiver: 'Lấy lại người',
  ReturnDate: 'Ngày hoàn trả',
  ReturnExpressNumber: 'Trả lại số Express',
  DateOfDeclaration: 'Ngày khai báo',
  FileStatus: 'Trạng thái tập tin',
  TenBitCode: 'Mã mười chữ số',
  ReceiverCompanyName: 'Đơn vị nhận',
  Receiver2: 'Người nhận',
  CustomsDeclarationPages: 'Số trang khai hải quan',
  CustomsTransitOrNot: 'Chuyển',
  TakeByCustomsBroker: 'Tự khai hải quan',
  ExpressAddress: 'Địa chỉ chuyển phát nhanh',
  PrintChargebackList: 'In (Danh sách hoàn trả)',
  ViewFile: 'Xem tập tin',
  ChargebackFile: 'Tài liệu hoàn trả',
  CheckPreRecordedCustomsDeclaration: 'Yêu cầu ghi trước tờ khai hải quan',
  CheckStatusOfCustomsDeclaration: 'Tra cứu trạng thái khai hải quan',
  All: 'Tất cả',
  GeneralTrade: 'Thương mại chung',
  Processing: 'Xử lý nguyên liệu đến',
  FeedingCounterparts: 'Cho ăn đúng miệng',
  SamplesOfAdvertisingProducts: 'Mẫu quảng cáo',
  OtherImportsFree: 'Miễn phí nhập khẩu khác',
  CustomerName: 'Tên khách hàng',
  CustomerAddress: 'Địa chỉ khách hàng',
  Confirm: 'Xác nhận',
  DangerousGoods: 'Hàng nguy hiểm',
  DangerousGoodsRequired: '"Hộp thư liên lạc hàng nguy hiểm", "Số fax liên lạc hàng nguy hiểm" là bắt buộc',
  DangerousGoodsLabel: 'Nhãn hàng hóa nguy hiểm',
  MedicalEmergencyGuideNo: 'Hướng dẫn cấp cứu y tế',
  SetTemperature: 'Đặt nhiệt độ',
  MinimumTemperature: 'Nhiệt độ thấp nhất',
  MaximumTemperature: 'Nhiệt độ tối đa',
  PortForReturningContainer: 'Cảng giao hàng',
  NonStandardContainer: 'Hộp tiêu chuẩn cộng với phi',
  OverFront: 'Siêu trước',
  OverBack: 'Siêu sau',
  OverHeight: 'Siêu cao',
  OverLeft: 'Trái siêu',
  OverRight: 'Siêu phải',
  EditionStatus: 'Trạng thái sửa',
  UpdateExternalState: 'Cập nhật trạng thái bên ngoài',
  Refresh: 'Làm mới',
  Save: 'Lưu',
  ShowAllPoints: 'Hiển thị tất cả các nút',
  SopStateNote: '* LƯU Ý: Các nút đã đóng sẽ không còn gửi cảnh báo nút và thông báo thay đổi trạng thái SOP',
  PaymentInformationImport: 'Nhập thông tin thanh toán',
  Invalid: 'Hủy bỏ',
  QueryContainerInfo: 'Truy vấn thông tin đóng gói',
  Hbl2: 'Số phụ',
  Mbl2: 'Số đơn chính',
  PortOfLoadingAgent: 'Đại lý cảng khởi hành',
  TheFirstVessel: 'Name',
  CustomerReferenceNumber: 'Số tham chiếu khách hàng',
  BusinessType: 'Loại hình kinh doanh',
  BillExchange: 'Có nên đổi đơn hàng hay không',
  Storage: 'Kho bãi',
  Devanning: 'Mở hộp',
  DeliveryToDoor: 'Giao hàng tận nơi',
  MblNo4: 'Số vé chính',
  InternationalTransport: 'Vận chuyển quốc tế',
  ActualNotifyParty: 'Thông báo thực tế',
  ActualNotifyPartyHeader: 'Thông báo thực tế',
  ConsignationCompanyHeader: 'Đơn vị ủy thác ngẩng đầu',
  Fax: 'Thư điện tử',
  BillExchangeAgent: 'Thay đổi đại lý đơn',
  CustomsHblNo: 'Số phụ hải quan',
  SecondCheck: 'Trình độ 2',
  SecondVessel: 'Name',
  AutoRetrieve: 'Tự động lấy',
  AccordingToVesselVoyageGets: 'Lấy theo tên tàu.',
  ActualDateOfArrival: 'Ngày đến cảng thực tế',
  ActualDateOfArrival2: 'Ngày đến cảng thực tế (ATA)',
  AtaImport: 'ATA (Nhập khẩu)',
  DateOfDelivery: 'Ngày nhận hàng',
  DateOfArrivalTheWarehouse: 'Ngày thư viện',
  Code2: 'Mã số',
  Region: 'Mã vùng',
  CountryOrigin: 'Xuất xứ',
  PartyIDType: 'Loại giấy tờ',
  PartyID: 'Số giấy tờ',
  BillsOfLadingDoubleClickEject: 'B/L Head - Double Click để Pop',
  TradeTerms: 'Điều khoản giao dịch',
  PreCollection: 'Thu trước',
  HblCargoReleaseWay: 'Cách đặt hàng',
  MblCargoReleaseWay: 'Cách đặt hàng chính',
  VesselCode: 'Mã tàu',
  BillExchangeDate: 'Đổi ngày',
  Department: 'Trang chủ',
  PolOperation: 'Vận hành cảng khởi hành',
  PodOperation: 'Hoạt động cảng đích',
  VesselOfChineseName: 'Tên tàu Trung Quốc',
  TotalWeight2: 'Tổng trọng lượng',
  TotalWeightUnit: 'Tổng trọng lượng đơn vị',
  NumberOfDamagedAndDamp: 'Số mảnh vỡ ẩm',
  EstimatedDateOfArrivalTheWarehouse: 'Ngày dự kiến vào kho',
  EstimatedDateOfPickingUpTheContainer: 'Ngày hành lý dự kiến',
  DateOfReturningTheContainer: 'Ngày hoàn trả',
  SanitaryAndPhytosanitaryStandard: 'Kiểm tra sức khỏe',
  PriceCalculation: 'Tính toán giá bán',
  Down: 'Di chuyển xuống',
  Up: 'Di chuyển lên',
  Total2: 'Tổng cộng',
  PrintBooking: 'In đặt cọc',
  FirstLegNo: 'Số đầu',
  FirstLegNoTips: 'Số nhận dạng chính được sử dụng trong vận tải hàng không quốc tế để quản lý vận chuyển trong nước và hoạt động trước khi xuất khẩu',
  OperateType: 'Chế độ hoạt động',
  CustomsDeclarationWay: 'Cách khai hải quan',
  CustomsDeclarationType: 'Loại khai hải quan',
  AirlineCompany: 'Hãng hàng không',
  Flight: 'Chuyến bay',
  FlightNo: 'Số chuyến bay',
  PortOfHub: 'Cảng HUB',
  CommissionedNumberOfPackages: 'Số lượng delegate',
  CommissionedGrossWeight: 'T.trọng ủy thác',
  CommissionedVolume: 'Khối lượng ủy quyền',
  ActualChargedWeight: 'Trọng lượng thanh toán thực tế',
  PrintingPlatePhotos: 'Ảnh của Punchboarding',
  ProtocolType: 'Loại giao thức',
  FieldOperation: 'Hoạt động tại chỗ',
  OverseaOperation: 'Hoạt động ở nước ngoài',
  Auditor: 'Đánh giá',
  preverifyDate: 'Ngày đánh giá',
  OtherWarehouseNotes: 'Mô tả khác',
  JobNo: 'Số công việc',
  NominatedAgent2: 'Chỉ định proxy',
  AirFreighMode: 'Chế độ vận chuyển hàng không',
  WarehouseNo2: 'Số cabin',
  PleaseInputJobNo: 'Vui lòng nhập số công việc',
  PrintProfitAnalysis: 'In phân tích lợi nhuận',
  SendToBranchCompany: 'Gửi văn phòng chi nhánh',
  EnterTransitInfo: 'Nhập TT quá cảnh',
  ArrivalForTheSecondJourney: 'Đến đoạn 2',
  LeaveForTheSecondJourney: 'Rời đi.',
  ArrivalForTheThirdJourney: 'Đến Triple',
  LeaveForTheThirdJourney: 'Rời khỏi Three Way',
  PreAlertOperation: 'Hoạt động dự báo',
  Actual: 'Thực tế',
  Frontcabin: 'Cabin phía trước',
  FrontCabinActual: 'Kho trước (thực tế)',
  Documentation: 'Sản phẩm',
  Select: 'Chọn',
  Join: 'Tham gia',
  Separate: 'Tách biệt',
  pbProportion: 'KH Pb',
  pbProportion2: 'NCC.Pb',
  SpaceRquirement: 'Yêu cầu cabin',
  OnBoardRequirements: 'Yêu cầu lắp đặt tấm',
  DocumentationRequirements: 'Yêu cầu sản xuất',
  SellingPrice: 'Giá bán',
  BuyingPrice: 'Giá bán',
  SalesBranchCompany: 'Chi nhánh bán hàng',
  CopyFromOtherBill2: 'Sao chép số',
  CodeSearching2: 'Mã chọn',
  ResetInitialValue: 'Đặt lại giá trị ban đầu',
  CopyTheMbl: 'SC DS chính',
  InputWarehouseData: 'Nhập dữ liệu vào kho',
  EditWarehouseData: 'Chỉnh sửa dữ liệu vào kho',
  DeleteWarehouseData: 'Xóa dữ liệu vào vị trí',
  CancelInvalid: 'Hủy bỏ',
  MblInfo: 'Thông tin vé chính',
  AirOperation: 'Vận hành hàng không',
  CustomerSpecialRequirements: 'Nhu cầu đặc biệt của khách hàng',
  AirportHandlingAgent: 'Đại lý mặt đất',
  CustomsTenBitCode: 'Khai báo hải quan Mã hóa mười chữ số',
  InspectionTenBitCode: 'Kiểm tra 10 mã',
  TradeDetail: 'Chi tiết hàng hóa',
  TradeCommission: 'Thương mại',
  HblInfo: 'Thông tin đặt hàng',
  MBLInfo: 'Thông tin Vận đơn chính (MBL)',
  Charge: 'Chi phí',
  InternalBillInfo: 'Hóa đơn nội địa',
  OverseaBillInfo: 'Hóa đơn nước ngoài',
  AdvanceChargeInfo: 'Ứng trước thu hộ',
  DocumentCirculation: 'Dòng chảy chứng từ',
  FileHistory: 'Lịch sử tập tin',
  ImportToPDF: 'Nhập PDF',
  Trucking: 'Khách hàng Door Point',
  ImportOperation: 'Hoạt động nhập khẩu',
  CustomsDeclarationOnward: 'Khai hải quan/Quá trình tiếp tục',
  WarehouseDoorLoading: 'Đóng gói trong kho/Đóng gói điểm cửa',
  GrossWeight: 'Tổng trọng lượng',
  CustomJobType: 'Loại hình kinh doanh tùy chỉnh',
  TaxNature: 'Tài sản thuế',
  ContainerInfo2: 'Thông tin thùng hàng',
  ContainerIdentification: 'Logo hàng hóa hộp',
  CopyConsignationDescriptionAndMarks: 'Sao chép từ đầu ủy thác',
  SelecteAll: 'Chọn tất cả',
  ConsigneeShipperAndNotifyAddress: 'Địa chỉ Email',
  ShipperId: 'Mã vận chuyển',
  ConsigneeId: 'Mã nhận hàng',
  NotifyId: 'Mã thông báo',
  ShipperInfo: 'Thông tin người gửi hàng',
  ConsigneeInfo: 'Thông tin người nhận hàng',
  NotifyInfo: 'Thông tin thông báo',
  CopyShipper: 'Chọn Shipper',
  CopyConsignee: 'Chọn người nhận hàng',
  CopyNotify: 'Chọn người thông báo',
  CopyManifestShipper: 'Chọn Manifest Shipper',
  CopyManifestConsignee: 'Chọn người nhận bản kê khai',
  CopyManifestNotify: 'Chọn người thông báo bản kê khai',
  CopyAll: 'Chọn',
  FillInQuantityOfVotes: 'Số phiếu điền',
  QueryLCLJobOrder: 'Tham gia một truy vấn LCL',
  QueryLCLJobOrder2: 'Tham gia một yêu cầu đặt hàng làm việc',
  QuantityOfSelectedOrder: 'Chọn số phiếu',
  NoDisplay: 'Không hiển thị',
  Number: 'Số phiếu',
  SelectSoNo: 'S/O Không chọn',
  MBLHBR: 'MBL có số',
  AgentInfo: 'Thông tin đại lý',
  HBLHBR: 'HBL có số',
  ChargeItem: 'Tên chi phí',
  Close: 'Đóng cửa',
  SearchJobNo: 'Truy xuất danh sách công việc',
  SerialNo: 'Số dòng chảy',
  Search: 'Truy xuất',
  VolumeOnBl: 'Khối lượng B/L',
  MethodOfPayment: 'Phương thức thanh toán',
  PortOfFinalDestination: 'Cảng đích cuối cùng',
  SelectContainerInfo: 'Chọn thông tin đóng gói',
  SearchTheWarehouseRecords: 'Truy vấn hồ sơ kho',
  ReceiptNo: 'Số nhận lại',
  warehouseOp: 'Nhân viên kho',
  deliveryCMP: 'Công ty giao hàng',
  inDate: 'Ngày nhập kho',
  DamagedAndDamp: 'Độ ẩm bị hỏng',
  EntryCustomsInformation: 'Nhập thông tin hải quan',
  Recorded: 'Đã nhập',
  ListPulled: 'Đã kéo đơn',
  AtReception: 'Tại quầy lễ tân',
  CustomsDeclared: 'Báo cáo đi.',
  Undeclared: 'Chưa báo cáo.',
  CustomsExamination: 'Kiểm tra hải quan',
  InspectionExamination: 'Kiểm tra thương mại.',
  ExamedWithoutReleasing: 'Đã kiểm tra chưa thả',
  AmendDeclaration: 'Thay đổi danh sách',
  NotifyToDeclare: 'Chờ thông báo khai hải quan',
  CustomsExamed: 'Kiểm tra hải quan có vấn đề',
  PreNumber: 'Nhập số',
  ContainerNo2: 'Loại tủ Số tủ',
  UnknownState: 'Trạng thái không rõ',
  ProductName: 'Tên chương trình',
  Carrier: 'Hãng vận chuyển',
  RecordCount: 'Số lượng hồ sơ',
  Autowire: 'Tự động khớp',
  SchemaName: 'Tên chương trình/Chi phí',
  Receivable: 'Nhận và nhận',
  PartnerType: 'Loại đơn vị thanh toán',
  Account: 'Đơn vị thanh toán cố định',
  MeasureCurrency: 'Đơn vị thanh toán',
  MeasureUnit: 'Đơn vị thanh toán',
  UnitRate: 'Đơn giá',
  MiniMum: 'Phí tối thiểu',
  FCLFreightTariff: 'Bảng cước vận chuyển FCL',
  PleaseInputTariffSheet: 'Vui lòng nhập số vận chuyển.',
  CostLeave: 'Xếp hạng vận chuyển:',
  ValidFrom: 'Hiệu lực từ',
  ValidTo: 'Ngày hết hạn',
  MON: 'Thứ hai',
  TUE: 'Thứ ba',
  WED: 'Thứ Tư',
  THU: 'Thứ năm',
  FRI: 'Thứ sáu',
  SAT: 'Thứ bảy',
  SUN: 'Chủ Nhật',
  GetCostsByTheCabinet: 'Chi phí theo loại tủ',
  ShippingFeesAreALLINTHEWAYImport: 'Vận chuyển hàng hóa theo cách nhập khẩu',
  PriceNo: 'Số vận chuyển',
  BranchCMP: 'Chi nhánh',
  IsDirect: 'Trực tiếp',
  PriceState: 'Trạng thái cabin',
  Trend: 'Xu hướng',
  Share: 'Tính chất cabin',
  ContractNo: 'Số xấp xỉ',
  PriceFrom: 'Nguồn cước vận chuyển',
  SailingDate: 'Thời gian tàu',
  Voyage2: 'Hành trình',
  Cargo: 'Hàng hóa',
  Box: 'Hộp',
  Dock: 'Trực tiếp bến tàu',
  LCLFreightTariff: 'Bảng cước vận chuyển FCL',
  ImportCostsByPeers: 'Phí nhập khẩu theo Peer Price',
  PriceState2: 'Trạng thái vận chuyển',
  CostValue: 'Giá thành',
  PeerPrice: 'Giá ngang hàng',
  DirectPrice: 'Giá hành khách thẳng',
  MarketPrice: 'Giá thị trường',
  ClosingDay: 'Ngày đóng cửa',
  ShareCarrier: 'Hãng tàu Common Cabin',
  VerificationSchedule: 'Bảng chi tiết bán hàng hạt nhân',
  Cash: 'Tiền mặt',
  Check: 'Chi phiếu',
  Transfer: 'Chuyển khoản',
  ClearingDate: 'Ngày bán hạt nhân',
  PayReceiveDate: 'Ngày nhận',
  VerificationBy: 'Người bán hạt nhân',
  ClearCurrency: 'Đồng tiền hạt nhân',
  ClearRate: 'Tỷ giá bán hạt nhân',
  ClearAmount: 'Số lượng nucleic marketing',
  VoucherNo: 'Số chứng từ',
  OurBank: 'Ngân hàng của chúng tôi',
  AddBillCharge: 'Phí tham gia',
  RemoveBillCharge: 'Phí loại bỏ',
  ShowBillDetail: 'Hiển thị thông tin thanh toán',
  Close2: 'Thu gọn',
  OverseasBillingMaintenance: 'Bảo trì hóa đơn ở nước ngoài',
  MainOffice: 'Hóa đơn công ty',
  BillType: 'Loại hóa đơn',
  BillAmount: 'Số tiền thuế',
  AccountObject: 'Đối tượng thanh toán',
  Bank: 'Mở tài khoản ngân hàng',
  BankAccount: 'Số tài khoản ngân hàng',
  CounterPartyBillingNo: 'Số hóa đơn của nhau',
  InputDate: 'Ngày thanh toán',
  RevenueTotalGroup: 'Tổng số đồng xu',
  IncludingTaxAmount: 'Giá đã bao gồm thuế',
  ExcludingTaxAmount: 'Giá chưa bao gồm thuế',
  WhetherCollectingAdvance: 'Có nên ứng trước hay không?',
  Unit: 'Đơn vị',
  Quantity2: 'Số lượng',
  ShowLcl: 'Hiển thị chi phí vé nhỏ',
  AgentIntoBills: 'Đại lý chia hóa đơn',
  Office: 'Hóa đơn chi nhánh',
  Percentage: 'Chia tỷ lệ',
  IsPercentage: 'Phân chia',
  ChargeEnglishName: 'Chi phí Tên tiếng Anh',
  ChangeSchema: 'Chương trình chi phí',
  SendEMail: 'Gửi thư',
  LocalAgent: 'Đại lý địa phương',
  placeholderVal: 'Vui lòng chọn mẫu email trước khi chọn mẫu',
  UpDestAgent: 'Đại lý cảng khởi hành/điểm đến',
  Haulage: 'Trang chủ',
  CompanyName: 'Tên công ty',
  GroupCode: 'Mã công ty',
  CompanyAddress: 'Địa chỉ công ty',
  Contact: 'Liên hệ',
  OtherInformation: 'Thông tin khác',
  BlTitle: 'Tên công ty vận đơn',
  BlAddress: 'Địa chỉ B/L',
  BlContact: 'B/L Thông tin liên hệ',
  MscBlAddress: 'Địa chỉ vận đơn Msc',
  PleaseChooseItem: 'Vui lòng chọn mục cần thực hiện trước.',
  WhetherDelete: 'Xác nhận xóa?',
  IsEmptyPleaseEnter: 'Để trống, xin điền đầy đủ.',
  Cc: 'Cc',
  MailContent: 'Nội dung thư',
  SystemEmail: 'Hộp thư hệ thống',
  CompanyMail: 'Hộp thư công ty',
  PersonalMailbox: 'Hộp thư cá nhân',
  emailSubject: 'Chủ đề thư',
  mailTemplate: 'Mẫu thư',
  SaveTheDefaultCC: 'Lưu mặc định CC-BY',
  Title: 'Chủ đề',
  Content: 'Nội dung',
  operationalMotion: 'Hành động thao tác',
  operationTime: 'Thời gian hoạt động',
  customsReceiptStatus: 'Tình trạng trả lại hải quan',
  returnTime: 'Thời gian trở về',
  source: 'Nguồn',
  FileUpload: 'Tải lên tập tin',
  FileName: 'Tên tập tin',
  FileSize: 'Cỡ tập tin',
  UploadProgress: 'Tiến trình tải lên',
  DocumentType: 'Danh mục tài liệu',
  SelectFile: 'Chọn tập tin',
  DeleteFile: 'Xoá tập tin',
  Upload: 'Tải lên',
  PlsSeeEIR: 'Vui lòng xem danh sách bàn giao thiết bị',
  SelectCopyContent: 'Chọn nội dung sao chép',
  DuplicateContent: 'Sao chép nội dung',
  BasicInfo: 'Thông tin cơ bản',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: 'Sau này sao chép theo lựa chọn lần này, không cần hỏi nữa. Nếu cần thiết lập lại các điều kiện, bạn có thể nhấn nút Cài đặt trong Cài đặt và Công cụ ở góc trên bên phải - Cá nhân hóa trang',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: 'Đặt vùng chọn này làm bản sao mặc định và không nhắc lại lần sau',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: 'Để thiết lập lại nội dung sao chép, vui lòng vào biểu tượng menu ở góc trên bên phải - Cài đặt&Công cụ - Cá nhân hóa trang, nhấp vào nút Cài đặt',
  Slaves: 'Số phiếu nhỏ',
  Master: 'Tổng số phiếu',
  CustomerCount: 'Số lượng khách hàng',
  SingleWeight: 'Trọng lượng mảnh duy nhất',
  Weight2: 'Cân nặng',
  ReceivableType: 'Loại thu và thanh toán',
  AccountType: 'Loại đơn vị thanh toán',
  Account2: 'Đơn vị thanh toán',
  Oversea: 'Trong và ngoài nước',
  Remove: 'Xóa',
  SourceAmount: 'Số tiền gốc',
  NewAmount: 'Số tiền mới',
  IsUpdate: 'Cập nhật',
  ExportLog: 'Nhật ký xuất',
  Role: 'Chức năng',
  Mobile: 'Điện thoại',
  Email: 'Địa chỉ email',
  SOPOperatingState: 'Trạng thái hoạt động SOP',
  KG: 'Kg',
  CBM: 'mét khối',
  Tons: 'Tấn',
  SelectOpRequirement: 'Lựa chọn yêu cầu hoạt động',
  PleaseInputAKeyword: 'Vui lòng nhập từ khóa truy xuất',
  contentDescription: 'Mô tả nội dung',
  chargeItem: 'Mục chi phí',
  LCLLastBillOfLading: 'LCL Vận đơn cuối cùng',
  Addr: 'Địa chỉ',
  HouseNumber: 'Số nhà',
  Country: 'Quốc gia',
  Province: 'Tỉnh',
  City: 'Thành phố',
  ZIP: 'Mã bưu điện',
  SelectCharge: 'Phí lựa chọn',
  First: 'Trang đầu',
  Pre: 'Trang trước',
  Page: 'Số',
  AllPage1: 'Tổng cộng',
  AllPage2: 'Trang',
  Next: 'Trang tiếp theo',
  Last: 'Trang cuối',
  ShowFromTo1: 'Hiển thị',
  ShowFromTo2: 'Đến',
  AllRecord1: 'Tổng cộng',
  AllRecord2: 'Hồ sơ',
  Convert: 'Liên kết',
  Received: 'Thực thu',
  Paid: 'Thanh toán thực',
  AllPositions: 'Tất cả bài viết',
  DestinationAgent1: 'Đại lý ở nước ngoài',
  Accessible: 'Truy cập',
  IsDisplay: 'Hiện hay không',
  Uncertain: 'Không xác định',
  PrincipalUnitSOPReceiver: 'Đơn vị nhận SOP',
  PortOfDestinationAgency: 'Đại lý cảng đích SOP Người nhận',
  DesignatedFreightAgentSOPReceiver: 'Người nhận SOP được chỉ định',
  PortOfDepartureAgentSOPReceiver: 'Đại lý cảng khởi hành SOP Người nhận',
  Unconfirmed: 'Không xác nhận',
  Confirmed: 'Xác nhận',
  PassAudit: 'Kiểm toán thông qua',
  Refuse: 'Từ chối',
  Bl: 'Vận đơn',
  Original: 'Nguyên bản',
  LateOriginal: 'Buổi tối Shin',
  Correct: 'Sửa',
  Message: 'Thông báo',
  DeleteCustoms: 'Disable (adj): khuyết tật (',
  DeleteAll: 'Disable (adj): khuyết tật (',
  send: 'Gửi',
  change: 'Thay đổi danh sách',
  deleteSingle: 'Xóa danh sách',
  cancelBill: 'Bỏ lệnh',
  OverseasAgeFore: 'Dự báo ĐLNN',
  JclForecast: 'Dự báo JCL',
  AnnPackingList: 'Hộp lắp đặt',
  PreShippingBill: 'Bản kê khai trước',
  PreShippingBillPperation: 'Vận hành Manifest',
  ShippingBill: 'Bản kê khai',
  Anti_terrorismShipping: 'Bản kê chống khủng bố',
  CleanShipping: 'Làm sạch Manifest',
  Suitcase: 'Túi xách',
  DelSuitcase: 'Xóa hộp',
  ViewHistory: 'Xem lịch sử',
  ElectronicPackingList: 'Danh sách đóng gói điện tử 99 cách',
  SendHistory: 'Gửi lịch sử',
  ShippingSchedule: 'Lịch tàu',
  PortOfLoadingArea: 'Cảng khởi hành',
  PortOfDestinationArea: 'Khu cảng đích',
  ShipsCallSign: 'Biển hiệu tàu EDI',
  ImportTheVoyage: 'Nhập hàng hải',
  IncreaseThePort: 'Tăng cảng',
  DeletePorts: 'Xóa cảng',
  AutomaticallyImportVoyage: 'Tự động nhập hàng hải',
  CountryOfRegistration: 'Quốc gia đăng ký tên tàu',
  AddShippingCompany: 'Tăng công ty tàu',
  DelShippingCompany: 'Loại bỏ công ty tàu',
  DepartureTime: 'Thời gian khởi hành',
  DateOfOrder: 'Ngày nhận đơn',
  ProjectReceivedBy: 'Nhận đơn',
  dateOfFiling: 'Ngày nộp hồ sơ',
  ArchivePeople: 'Lưu trữ bởi',
  ReturnOrderExpressNumber: 'Số chuyển phát nhanh',
  StateOfTheWithdrawal: 'Trạng thái rút tiền',
  EmptyTheList: 'Danh sách trống',
  BatchStateTransition: 'Chuyển đổi trạng thái hàng loạt',
  CollectFormation: 'Thông tin thu tiền',
  RetreatASingle: 'Danh sách hoàn trả',
  BatchSaving: 'Lưu hàng loạt',
  AppendQueryRecord: 'Thêm bản ghi truy vấn',
  StateHisCase: 'Trạng thái vali',
  BoxStatus: 'Trạng thái hộp (Chỉ có cảng Thượng Hải)',
  StatusOfAnti_TerrorismManifest: 'Bản kê khai chống khủng bố EDI',
  ManifestStatus: 'Bản kê khai EDI',
  AdvanceManifestStatus: 'Bản kê khai trước EDI Status',
  InstallPackingListStatus: 'Trạng thái EDI',
  StateOfTheBillOfLading: 'Trạng thái vận đơn EDI',
  BookingStatus: 'Trạng thái EDI',
  reset: 'Đặt lại',
  PrintStatus: 'Trạng thái in',
  TeamContact: 'Liên hệ Hạm đội',
  ContactNumber: 'Số điện thoại',
  DoorContact: 'Liên hệ DoorPoint',
  DoorContactNumber: 'Số điện thoại Door Point',
  PleaseScanTheBarcodeOrInputDirectly: 'Vui lòng quét mã vạch hoặc nhập trực tiếp',
  CollectionSituation: 'Tình hình thu tiền',
  DocumentDate: 'Ngày chứng từ',
  checkbox: '【Nhiều hộp chọn】',
  RefundDate: 'Ngày hoàn thuế',
  RefundPerson: 'Người hoàn thuế',
  AutomaticallyRefresh: 'Tự động làm mới',
  Piece: 'Phần',
  Volume: 'Cơ thể',
  CartonQuantity: 'Loại hộp Số lượng hộp',
  ClientsRequirement: 'Yêu cầu của khách hàng',
  LandCarriage: 'Vận chuyển đường bộ',
  HLID: 'ID liên kết',
  ShippingCmp: 'Thuyền trưởng',
  CarrierSpecificCode: 'Mã tàu đặc biệt',
  PortOfLoadingAI: 'Cảng khởi hành',
  RiverCarrier: 'Công ty Giang Thuyền',
  Synchronization: 'Đồng bộ',
  BatchShutOut: 'Hủy bỏ hàng loạt',
  OverseaCustomerService: 'Dịch vụ khách hàng nước ngoài',
  CargoFeature: 'Tài sản hàng hóa',
  CustomerLevel: 'Cấp độ khách hàng',
  ContractStatus: 'Trạng thái hợp đồng',
  HBLNotifier: 'Thông báo lệnh phụ',
  ExportWithSOPToExcel: 'Xuất Excel (bao gồm chi tiết SOP)',
  ManagerSubmission: 'Gửi bởi Supervisor',
  CustomerSelfRelease: 'Khách hàng tự đặt hàng',
  CompanySelfRelease: 'Công ty tự đặt hàng',
  QuantitySize: 'Kích thước phần',
  EquipmentEstimatedReturnTimeFrom: 'Dự kiến tủ bắt đầu',
  EquipmentEstimatedReturnTimeTo: 'Dự kiến sẽ trả lại.',
  copyDGStuffing: 'Sao chép',
  pasteDGStuffing: 'Dán',
  viewDGStuffing: 'Xem thêm',
  copyAndAddPoItems: 'Sao chép Thêm',
  SynchroHBLInfo: 'Đồng bộ hóa thông tin HBL',
  Cubage2: 'Khối lượng M³',
  AMSLog: 'Đăng nhập',
  AMSReceiptInfo: 'Xem trả lại',
  ViewAssociatedBusiness: 'Xem doanh nghiệp liên kết',
  isShutOut: 'Đã hoàn quan',
  RevokeTuckOrder: 'Bỏ lệnh',
  SearchTuckOrder: 'Yêu cầu',
  ShowTuckOrderLog: 'Đăng nhập',
  TuckStatus: 'Trạng thái gửi xe',
  DriverNameHL: 'Tài xế kết nối',
  DriverPhoneHL: 'Điện thoại kết nối',
  TruckNoHL: 'Giấy phép liên kết',
  TmsNoHL: 'Số xe.',
  ContainerSerialNo: 'Số hộp',
  ContainerNoDiff: 'Mẹo khác biệt',
  isRelated: 'Liên hệ',
  viewDGStuffingInvalid: 'Hủy bỏ',
  CommissionedChargedWeight: 'Trọng lượng thanh toán ủy quyền',
  CustomsHasCheck: 'Hải quan đã kiểm tra',
  CustomsOneRelease: 'Một lần thả',
  CustomsRelease2: 'Thả',
  PartnerShortType: 'Loại',
  Transit2: 'TCH',
  AuditDate: 'Điều chỉnh ngày',
  IsNeedInvoice: 'Có cần lập hóa đơn không?',
  needInvoice: 'Yêu cầu thanh toán',
  InvoiceNo: 'Số thuế',
  Email2: 'Hộp thư',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'ShowPODAgency',
  FnlTm: 'Cách vận chuyển điểm nội địa',
  InvokeLocalMailClient: 'Gọi hộp thư cục bộ',
  preview: 'Tạo tệp đính kèm',
  attachment: 'Phụ kiện:',
  AddPackingInfo: 'Thêm thông tin đóng hộp',
  RemovePackingInfo: 'Xóa thông tin đóng gói',
  sendJdy: 'Gửi đám mây',
  sendFailInfo: 'Gửi thành công {0} thanh, không thành công {1} thanh：',
  batchSendJdy: 'Gửi hàng loạt đám mây Giản Đạo',
  batchUnlockGoodsDetails: 'Chi tiết hàng hóa mở khóa hàng loạt',
  IdentifyPackingList: 'nhận dạng hoá đơn đóng gói hàng',
  BoxListRecognition: 'nhận diện hộp',
  SupportingUploadFormat: 'Hỗ trợ các định dạng tải lên pdf/ xls/ xlsx/ doc/ docx/ jpg/ gif/ png, mỗi tập tin không quá 4MB',
  UploadedFile: 'Tập tin đã tải lên',
  Parsing: 'Đang phân tích',
  SpecialCharactersNotAllow: 'tên tệp không cho phép các ký tự đặc biệt',
  MaterialInformation: 'thông tin về vật liệu',
  MaterialNumber: 'Mục Vật',
  HsCode2: 'HS CODE',
  NetWeightKg: 'trọng lượng ròng (kg)',
  PONumber: 'Số PO',
  FilePreview: 'xem thử tài liệu',
  MultiCabinets: 'Nhiều tủ',
  CopyDoorPoint: 'Sao chép dữ liệu tủ kéo điểm cửa',
  SelectCabinetData: 'Chọn thông tin tủ',
  ExportPackingInfo: 'Xuất thông tin Do-box',
  ImportPackingInfo: 'Nhập thông tin Do-box',
  ContainerId: 'Hộp ID',
  TrailerRemark: 'Trailer Ghi chú',
  RemarkItems: 'Ghi chú',
  DriverId: 'Chứng minh thư',
  DriverName: 'Tài xế',
  DriverPhone: 'Điện thoại',
  TruckNo: 'Biển số xe',
  EstimatArrivalTime: 'Thời gian dự kiến đến nhà máy',
  DownloadImportResults: 'Tải về kết quả nhập khẩu',
  ImportSuccess: 'Nhập thành công',
  ImportFaildAndDownFile: 'Có một bộ dữ liệu nhập khẩu không thành công, vui lòng tải xuống kết quả nhập khẩu để xem!',
  SendBack: 'Trả lại',
  MSC: 'MSC',
  CompanyInfo: 'Thông tin công ty',
  LadingBillInfo: 'Thông tin vận đơn',
  HV: 'HV',
  RefNo: 'Số tham chiếu',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSCODE',
  CustomsCommodity: 'Tên khai hải quan',
  TradeShortName: 'Hàng hóa gọi tắt',
  Code3: 'Mã số',
  TradeDescription: 'Mô tả hàng hóa',
  ShippingMark: 'Nhãn hiệu vận chuyển',
  ZipCode: 'Mã bưu điện',
  EmailAddress: 'Thư điện tử',
  VipCode: 'Mã VIP',
  InttraCode: 'Mã INTTRA',
  MscCode: 'Mã MSC',
  CompanyCode: 'Mã công ty',
  LadingBillTitle: 'Đầu B/L',
  LadingBillAddress: 'Địa chỉ B/L',
  LadingBillContactInfo: 'B/L Thông tin liên hệ',
  MstBooking: 'MST BOOKING',
  SplitType: 'Loại Split',
  RelatedOrderNo: 'Số đơn hàng liên quan',
  SignedType: 'Loại hợp đồng',
  FreightTerm: 'Điều khoản vận chuyển',
  PlaceOfPayment: 'Nơi thanh toán',
  ProductionInstallationPlace: 'Đất sản xuất',
  ProductionInstallationPlaceStation: 'Trạm sản xuất và lắp đặt',
  ProductionInstallationModeOfTransportation: 'Phương thức vận chuyển sản xuất và lắp ráp',
  PortOfLoadingWharf: 'Bến cảng khởi hành',
  PortOfDischargeWharf: 'Bến cảng dỡ hàng',
  PortOfDischargeRequire: 'Yêu cầu cảng dỡ hàng',
  Destination: 'Điểm đến',
  DestinationStation: 'Trạm đích',
  DestinationTransportWay: 'Cách vận chuyển điểm đến',
  TransferCountry: 'Quốc gia trung chuyển',
  BlNumber: 'BL NUMBER',
  FreightBL: 'Freight BL',
  PODAgency: 'POD Agency',
  MscServiceCode: 'Mã dịch vụ',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: 'Mã bưu điện',
  CopyCompany: 'Bản sao thông tin công ty',
  ChargeImport: 'Nhập chi phí',
  customerLevel: 'Cấp độ khách hàng',
  isSignContract: 'Đăng ký hay không',
  RemovePacking: 'Loại bỏ Boxing',
  LastContainerDescription: 'Bản vẽ cuối cùng',
  SelectLocation: 'Chọn địa điểm',
  GetBack: 'Lấy lại',
  CancelGetBack: 'Thu hồi',
  Releasing: 'Đặt hàng',
  CancelReleasing: 'Hủy đặt hàng',
  StatusModefySuccessfully: 'Thay đổi trạng thái thành công',
  BillingOfLadingRecordManager: 'Nhật ký vận đơn',
  ApplyForARelease: 'Yêu cầu thanh toán',
  RequestReleaseBy: 'Áp dụng cho một người',
  TicketHasSplit: 'Vé này đã bị hủy, vui lòng gửi yêu cầu trong phần hủy',
  TicketHasMerged: 'Vé này đã được thanh toán, xin vui lòng gửi yêu cầu trong phiếu thanh toán',
  RequestReleaseDate: 'Ngày nộp đơn',
  RequestReleaseState: 'Yêu cầu trạng thái thanh toán',
  MblRequestReleaseState: 'Trạng thái yêu cầu phát hành MBL',
  HblRequestReleaseState: 'Trạng thái yêu cầu phát hành HBL',
  NotApplying: 'Không áp dụng',
  Requested: 'Đã áp dụng',
  NoGuarantee: 'Không bảo lãnh',
  InEffect: 'Có hiệu lực',
  Expired: 'Hết hạn',
  Uploaded: 'Đã tải lên',
  NotUploaded: 'Chưa tải lên',
  NoUploadRequired: 'Không cần upload',
  NotUploadedYetPlease: 'Chưa upload, vui lòng',
  LongTermGuaranteeState: 'Tình trạng bảo lãnh dài hạn',
  SingleTicketGuaranteeState: 'Tình trạng bảo lãnh vé đơn',
  WithdrawTheRequestForRelease: 'Rút đơn đăng ký',
  NoRequestReleaseData: 'Không có dữ liệu yêu cầu đặt hàng',
  NoCancelRequestReleaseData: 'Không có dữ liệu yêu cầu rút đơn đăng ký',
  ReleasingDate: 'Đặt ngày',
  mblReleasingDate: 'MBL Đặt ngày',
  receiptDate: 'Thời gian',
  receiptContent: 'Nội dung',
  receiptCode: 'Mã trả về',
  createdDate: 'Thời gian',
  createdBy: 'Người vận hành',
  content: 'Nội dung',
  consignorCode: 'Mã doanh nghiệp Shipper',
  codeAbbreviation: 'Mã viết tắt',
  enterpriseCode: 'Mã doanh nghiệp',
  consignorName: 'Tên doanh nghiệp Shipper',
  consignorDetailAddress: 'Địa chỉ chi tiết của người gửi hàng',
  consignorPhone: 'Số điện thoại Shipper',
  consignorEmail: 'Địa chỉ email của người gửi hàng',
  consignorRelexNumber: 'Số điện thoại của người gửi hàng',
  cityName: 'Tên thành phố',
  consignorCityName: 'Tên thành phố Shipper',
  provinceCode: 'Mã tỉnh',
  provinceName: 'Tên tỉnh',
  postalCode: 'Mã bưu điện',
  countryCode: 'Mã quốc gia',
  aeoEnterpriseCode: 'Mã hóa doanh nghiệp AEO',
  formatSynchronizeToOrder: 'Đồng bộ hóa thông tin định dạng để đặt hàng',
  ladingBill: 'Hướng dẫn vận đơn',
  consigneeCode: 'Mã doanh nghiệp cho người nhận hàng',
  consigneeCodeAbbreviation: 'Mã viết tắt',
  consigneeEnterpriseCode: 'Mã doanh nghiệp',
  consigneeName: 'Tên doanh nghiệp của người nhận hàng',
  consigneeDetailAddress: 'Địa chỉ chi tiết của người nhận hàng',
  consigneePhone: 'Số điện thoại người nhận hàng',
  consigneeEmail: 'Địa chỉ email của người nhận hàng',
  consigneeRelexNumber: 'Số điện thoại của người nhận hàng',
  consigneeCityName: 'Tên thành phố',
  consigneeProvinceCode: 'Mã tỉnh',
  consigneeProvinceName: 'Tên tỉnh',
  consigneePostalCode: 'Mã bưu điện',
  consigneeCountryCode: 'Mã quốc gia',
  consigneeAeoEnterpriseCode: 'Mã hóa doanh nghiệp AEO',
  specificContactName: 'Tên liên hệ cụ thể',
  specificContactPhone: 'Số điện thoại liên hệ cụ thể',
  specificContactAddress: 'Địa chỉ email liên hệ cụ thể',
  specificContactRelexNumber: 'Số điện thoại liên hệ cụ thể',
  notifyingCode: 'Thông báo mã doanh nghiệp',
  notifyingCodeAbbreviation: 'Mã viết tắt',
  notifyingEnterpriseCode: 'Mã doanh nghiệp',
  notifyingName: 'Thông báo tên doanh nghiệp',
  notifyingDetailAddress: 'Thông báo chi tiết địa chỉ',
  notifyingPhone: 'Thông báo số điện thoại',
  notifyingEmail: 'Thông báo địa chỉ email',
  notifyingRelexNumber: 'Thông báo số telex',
  notifyingCityName: 'Tên thành phố',
  notifyingProvinceCode: 'Mã tỉnh',
  notifyingProvinceName: 'Tên tỉnh',
  notifyingPostalCode: 'Mã bưu điện',
  notifyingCountryCode: 'Mã quốc gia',
  notifyingAeoEnterpriseCode: 'Mã hóa doanh nghiệp AEO',
  formatManifestInformation: 'Định dạng thông tin Manifest',
  freightChargesInfo: 'Thông tin chi phí',
  freightChargesUSDTotal: 'Tổng chi phí USD:',
  tips: 'Gợi ý!',
  checkNominatedAgent: 'Đại lý chỉ định không thể để trống!',
  checkActualNotifyParty: 'Thông báo thực tế không thể để trống!',
  checkConsignationCompany: 'Đơn vị ủy thác không được để trống!',
  checkLoadingPort: 'Cảng hàng không thể để trống!',
  checkLoadingPort2: 'Cảng khởi hành không thể để trống!',
  checkPortOfDischarge: 'Cảng dỡ hàng không thể để trống!',
  checkPlaceOfDelivery: 'Địa điểm giao hàng không thể để trống!',
  checkFinalDestination: 'Điểm đến cuối cùng không thể trống rỗng!',
  checkDateOfDepartureAndDateOfArrival: 'Ngày khởi hành không thể muộn hơn ngày đến cảng!',
  checkSales: 'Bán hàng không thể để trống!',
  checkDept: 'Bộ phận không thể để trống!',
  searchInfo: 'Không nhập thông tin truy vấn!',
  checkVslVoy: 'Tên tàu hoặc chuyến bay không được để trống.',
  prePlanBooking: 'Thông tin bổ sung',
  VgmInfo: 'Thông tin VGM',
  ChooseSoNoInfoToCopy: 'Vui lòng kiểm tra thông tin để sao chép~',
  ChooseContainerInfoToCopy: 'Vui lòng chọn thông tin hộp để sao chép~',
  manifestLinkCopy: 'Sao chép liên kết Manifest',
  manifestInviteSupplement: 'Bản kê khai bổ sung',
  manifestQueryLog: 'Kiểm tra lại bản kê khai.',
  manifestCfmStateLog: 'Trạng thái Manifest',
  manifestByPreShipping: 'Bản kê khai trước',
  manifestByClearBooking: 'Làm sạch Manifest',
  manifestCfmButton: 'Xác nhận',
  manifestUnLockButton: 'Mở khóa tạm thời',
  HBLWeight: 'Tổng trọng lượng B/L',
  HBLQuantity: 'Nâng số mảnh',
  BillPortOfLoading: 'Cảng khởi hành B/L',
  BillPortOfDischarge: 'Cảng dỡ hàng B/L',
  BillPlaceOfDelivery: 'Nơi giao hàng B/L',
  UserDefinedField1: 'Trường tùy chỉnh 1',
  UserDefinedField2: 'Trường tùy chỉnh 2',
  UserDefinedField3: 'Trường tùy chỉnh 3',
  UserDefinedArea: 'Thông tin tùy chỉnh',
  PleaseAddConsigneeFirst: 'Vui lòng thêm consignee',
  CopyConsigneeToNotify1: 'Sao chép consignee',
  OnlyOne: 'Chỉ có thể chọn một',
  CopyPoItemInfo: 'Sao chép thông tin thùng hàng',
  CopySuccess: 'Sao chép thành công',
  CopyFaild: 'Sao chép thất bại',
  PaseteSuccess: 'Dán thành công',
  NoPasetePoItemInfo: 'Không sao chép thông tin hộp hàng, xin sao chép trước.',
  IsOrNotSpelling: 'Có đánh vần thêm không?',
  Insure: 'Bảo hiểm',
  billPaymentNo: 'Đơn yêu cầu thanh toán',
  confirmUser: 'Xác nhận chi phí',
  ediFeedBackState: 'Đăng nhập',
  receiptPrompt: 'Mẹo: Gửi dữ liệu trong vòng 20 ngày của bản kê khai, hệ thống sẽ tự động nhận được thư trả lại.',
  loadingManifestReceipt: 'Tải lại bản kê khai',
  customsReceipt: 'Bản kê khai của Tổng cục Hải quan',
  receiving: 'Đang trả lời.',
  receiptSucceeded: 'Chấp nhận thành công',
  receiptFailed: 'Chấp nhận thất bại',
  customCode: 'Mã vùng đóng cửa',
  transportation: 'Phương thức vận chuyển',
  receiptBillType: 'Loại vận đơn',
  transportationName: 'Name',
  receiptVoyage: 'Chuyến bay/Chuyến bay',
  importArrivalSignal: 'Thông báo nhập khẩu',
  receiptBillNumber: 'Danh sách xây dựng',
  entryDepatureDate: 'Ngày nhập cảnh',
  itemCount: 'Số mảnh',
  kilogram: 'Kg',
  receiptWeight: 'Số lượng',
  tallyStatus: 'Trạng thái kiểm kê',
  exportArrivalStatus: 'Trạng thái xuất cảnh',
  sendLog: 'Gửi nhật ký',
  ediStatus: 'Trạng thái EDI',
  ManifestDeliveryStatus: 'Trạng thái gửi Manifest',
  chooseShipper: 'Chọn Shipper',
  chooseConsignee: 'Chọn người nhận hàng',
  chooseNotify: 'Chọn người thông báo',
  bulkReplication: 'Sao chép hàng loạt',
  PlannedDepartureTime: 'Thời gian khởi hành',
  ActualDepartureTime: 'Thời gian khởi hành thực tế',
  PlannedArrivalTimeAtTheFactory: 'Thời gian đến nhà máy',
  RealTimeOfArrivalAtTheFactory: 'Thời gian đến nhà máy thực tế',
  PlannedTimeToLeaveTheFactory: 'Thời gian rời nhà máy',
  ActualTimeToLeaveTheFactory: 'Thời gian rời khỏi nhà máy',
  PlannedArrivalTime: 'Thời gian dự kiến đến',
  ActualArrivalTime: 'Thời gian đến thực tế',
  currentLocation: 'Vị trí hiện tại',
  ViewExceptions: 'Xem ngoại lệ',
  truckingPlaceDep: 'Bãi nâng tủ',
  truckingPlaceDest: 'Trả lại bãi',
  travelTime: 'Thời gian trên đường',
  Hour: 'Giờ',
  Minute: 'phút',
  salesOffice: 'Chi nhánh bán hàng',
  opOffice: 'Chi nhánh hoạt động',
  BookingAgentIsNull: 'Nhân viên đặt chỗ trống.',
  SOPReceiver: 'Người nhận SOP',
  Collectioninformation: 'Thông tin thu tiền',
  Appendqueryrecord: 'Thêm bản ghi truy vấn',
  SalesOfGoods: 'Bán hàng Range Rover',
  BatchProcessing: 'Xử lý hàng loạt',
  ClickSpaceToDropDownOptions: 'Khoảng trống có thể kéo xuống tùy chọn',
  PleaseMaintainTheCorrespondingSalesInThePartner: 'Vui lòng liên hệ đối tác bảo trì',
  CheckRecordedCustomsDeclaration: 'Thông báo phát hành tờ khai hải quan',
  ClearPacking: 'Thùng rỗng',
  CopyMarksFromReceipt: 'Lấy vé số nhỏ',
  PODCountry: 'Cảng đích Quốc gia',
  Details: 'Chi tiết',
  import: 'Nhập khẩu',
  DangerousClass: 'Lớp hàng nguy hiểm',
  DangerousGoodsContact: 'Liên hệ HAZMAT',
  DangerousGoodsContactPhoneNumber: 'Số liên lạc HAZMAT',
  emptyBox: 'Hộp rỗng',
  ShipperByCompany: 'Thông tin công ty (Company Information)',
  ConsigneeByCompany: 'Thông tin công ty (Company Information)',
  PreverifyStatus: 'Tình trạng sơ thẩm',
  ChangeCommit: 'Phí nộp đơn thay đổi',
  ConfirmChangeCommit: 'Có chắc là muốn nộp chi phí thay đổi không?',
  UserDefinedField4: 'Trường tùy chỉnh 4',
  BoardSales: 'Hệ thống ván ép để bán',
  BoardCsr: 'Hỗ trợ hệ thống ván ép',
  BoardSite: 'Trang web hệ thống ván trượt',
  ArrivalMethod: 'Phương thức đến',
  FlightLabel: 'Nhãn hàng không',
  bargePOL: 'Cảng khởi hành sà lan (POL)',
  SalesRequire: 'Yêu cầu bán hàng',
  OnlyDisplayTicket: 'Chỉ hiển thị vé nhỏ đáp ứng các điều kiện',
  batchImportCharge: 'Phí nhập khẩu hàng loạt',
  importCharge: 'Phí nhập khẩu',
  historyLogQuery: 'Truy vấn nhật ký lịch sử',
  noRule: 'Quy tắc số',
  MBLNO: 'MBL NO',
  importSetting: 'Cài đặt nhập',
  receivable: 'Phải nhận',
  payable: 'Đối phó',
  importFile: 'Nhập tập tin',
  confirmImport: 'Xác nhận nhập',
  checkLines: 'Số dòng không được vượt quá 1000 dòng',
  checkLines200: 'Số dòng không được vượt quá 200 dòng',
  checkChargeInfo: 'Vui lòng nhập thông tin liên quan đến chi phí trước khi nhập!',
  internal: 'Nội địa',
  overseas: 'Nước ngoài',
  batchOperate: 'Hoạt động hàng loạt',
  batchImport: 'Nhập hàng loạt',
  activity: 'Quy trình',
  JobInfo: 'Thông tin doanh nghiệp',
  Service: 'Dịch vụ',
  Supplier: 'Nhà cung cấp',
  InnerInfo: 'Thông tin nội bộ',
  Defined: 'Tùy chỉnh',
  MoreInfo: 'Thông tin thêm',
  unDisplayInfo: 'Ẩn thông tin',
  GeneralInfo: 'Thông tin vé nhỏ',
  BatchModifiedState: 'Trạng thái sửa đổi hàng loạt',
  SplitTicketsInfo: 'Thông tin phiếu chia',
  destinationStation: 'Trạm đích',
  departureStation: 'Trạm khởi hành',
  transitStation: 'Trạm trung chuyển',
  destinationStationRailport: 'Trạm đích (đường sắt)',
  departureStationRailport: 'Trạm khởi hành (đường sắt)',
  transitStationRailPort: 'Trạm quá cảnh (đường sắt)',
  CommonInfo: 'Thông tin chung',
  settlementAgent: 'Đại lý thanh toán',
  Dimension: 'Kích thước CM (L * W * H)',
  PaymentType: 'Trả trước/đến thanh toán',
  ToPay: 'Trả tiền',
  PrePay: 'Trả trước',
  PickUpGoods: 'Nhận hàng hay không',
  DocumentationNumberOfPackages: 'Làm số mảnh đơn',
  DocumentationGrossWeight: 'Tổng trọng lượng làm đơn',
  DocumentationVolume: 'Khối lượng đặt hàng',
  DocumentationChargedWeight: 'Trọng lượng thanh toán hóa đơn',
  CustomerQuantity: 'Số lượng khách hàng',
  CustomerGrossWeight: 'Tổng trọng lượng khách hàng',
  CustomerVolume: 'Khối lượng khách hàng',
  CustomerChargedWeight: 'Trọng lượng thanh toán của khách hàng',
  VerifyReviewThrough: 'Kiểm tra lại.',
  VerifyReviewRefusal: 'Từ chối xem lại',
  ImportTime: 'Thời gian nhập',
  descr: 'Ghi chú Mô tả',
  logFile: 'Tập tin nhật ký',
  ChargeBranchId: 'Chi nhánh trực thuộc',
  DateCreated: 'Ngày nhập',
  ProfitOwner: 'Lợi nhuận thuộc về',
  ScfiDeclare: 'Thông báo SCFI',
  ScfiPrice: 'SCFI Giá vận chuyển',
  Copy: 'Sao chép',
  ImportOrder: 'Nhập dữ liệu đặt hàng',
  ImportBusinessNo: 'Nhập số doanh nghiệp',
  SelectOrderNumber: 'Chọn số thứ tự',
  ArrivalTime2: 'Ngày đến đích',
  ProjectName: 'Tên dự án',
  ProjectBatch: 'Lô dự án',
  CargosExpectedArrivalDateByTrucking: 'Ngày giao hàng dự kiến (điểm đến của khách hàng)',
  CargosExpectedArrivalDateWarehouseLoading: 'Ngày dự kiến đến (tải trong kho)',
  CargosExpectedArrivalDatePacking: 'Ngày đóng gói dự kiến',
  EstimatedPackTheCabinetTime: 'Thời gian tải dự kiến',
  MaintainJobNoRule: 'Vui lòng duy trì quy tắc mã số công việc!',
  SelectCodeRule: 'Vui lòng chọn quy tắc mã hóa',
  CodeRuleDesc: 'Mô tả quy tắc mã hóa',
  SpecifyAgentNumber: 'Chỉ định số lượng đại lý hàng hóa',
  CustomsClearanceChargeRelatedEdit: 'Chi phí hoàn thuế chỉ có thể thay đổi liên quan đến chi phí',
  CustomsClearanceNoChargeNoChange: 'Hoàn thuế không mất phí Không thay đổi (tất cả phí sẽ được xóa)',
  ClearFeeNoChargeCustomsClearance: 'Không có chi phí hoàn quan, nếu không thanh lý chi phí đã xác nhận, không thể hoàn quan mà không có chi phí.',
  VotesPreSubmission: 'Vé có được nộp trước không?',
  AllNotPositiveOperationStatus: 'Tất cả các bản ghi dữ liệu được chọn là trạng thái không 【Hoạt động tích cực】',
  AllNotToVerifyStatus: 'Tất cả các bản ghi dữ liệu được chọn là trạng thái không 【Đang được xem xét】',
  ContainerLoadTypeNotCorrect: 'Loại hình tổng hợp nghiệp vụ vé này không phải là tự ghép, buyer consol、 Ủy quyền LCL',
  RecordNotPositiveOperationStatus: 'Việc bán vé không phải là trạng thái hoạt động.',
  RailwayCheckLob: 'Có một loại hình kinh doanh khác nhau cho công việc đã chọn, hãy chọn cùng một loại hình kinh doanh để thử lại.',
  TheTicketIsMain: 'Kinh doanh vé chính',
  TheTicketAssociatedMain: 'Vé này đã liên kết với vé chính.',
  TheTicketAssociatedContainerInfo: 'Dịch vụ vé này đã được liên kết với thông tin đóng gói',
  ContainerLoadTypeIs: 'Toàn bộ kiểu đánh vần đã là',
  NoneModified: 'Không cần sửa đổi',
  ContainerLoadTypeBatchModifySuccess: 'Thay đổi toàn bộ các loại đánh vần thành công:',
  NoDataProcessed: 'Không có dữ liệu đã xử lý',
  CustomsInformation: 'Thông tin khai hải quan',
  AddFile: 'Thêm tập tin',
  CustomsReceiptFile: 'Giấy tờ thu hồi hải quan',
  CustomsReceiptState: 'Tình trạng trả lại hải quan',
  CloneCabinBerth: 'Sao chép cabin',
  BackFillCabinBerth: 'Làm đầy khoang',
  GenerateBusiness: 'Tạo doanh nghiệp',
  ReturnCabin: 'Thoát khỏi cabin',
  CheckBeforeEntrust: 'Bạn ủy thác {0} không có mã SCAC bảo trì {1} và các thông tin liên quan khác, vui lòng kiểm tra lại với đối phương trước khi ủy thác!',
  CheckPortBeforeEntrust: 'Bạn ủy thác 【{0}】 không có bảo trì 【{1}】 cổng, xin vui lòng kiểm tra với đối phương sau đó tiến hành ủy thác!',
  CheckPackBeforeEntrust: 'Bạn ủy thác 【{0}】 không có bảo trì 【{1}】 đóng gói, xin vui lòng kiểm tra với đối phương sau đó tiến hành ủy thác!',
  PortDataPushLog: 'Nhật ký đẩy dữ liệu cảng',
  EdiStatusChangeLog: 'Nhật ký thay đổi trạng thái EDI',
  BookingReceiptLog: 'Nhật ký hoạt động trả phòng.',
  MergeAndSingle: 'Và đơn',
  OuJianDeclaration: 'Thông báo hải quan',
  AirportPort: 'Cảng sân bay',
  Airport: 'Sân bay',
  GoodsStoragePlace: 'Nơi lưu trữ hàng hóa',
  ExchangeServiceAi: 'Có cần dịch vụ khai báo hải quan không?',
  DataPushChangeLog: 'Dữ liệu Push Change Record',
  SendBookingData: 'Gửi dữ liệu đặt phòng',
  SelectAction: 'Chọn hành động',
  IsGroupBranch: 'Có hay không chi nhánh nhóm',
  SmtpServerError: 'Lỗi máy chủ SMTP',
  NotConnectSmtpServer: 'Không thể kết nối máy chủ SMTP',
  NotFindFile: 'Hệ thống không tìm thấy tập tin đã chỉ định',
  SendFileError: 'Lỗi gửi tập tin',
  AttachTemplateError: 'Lỗi mẫu đính kèm',
  MailSentSuccess: 'Gửi thư thành công',
  PleaseSelectAction: 'Vui lòng chọn Action',
  PleaseSelectCategory: 'Vui lòng chọn loại hàng hóa lớn',
  PleaseSelectOpDep: 'Vui lòng chọn bộ phận hoạt động',
  SeaExportLetter: 'Giấy ủy quyền vận chuyển hàng hóa xuất khẩu bằng đường biển',
  DataPush: 'Dữ liệu Push',
  MasterTicketSync: 'Đồng bộ hóa vé chính',
  BookingDataSentSuccess: 'Số liệu đặt khoang đã gửi thành công!',
  CostSettlementObjectBlocked: '(văn) ① Lầm lẫn; ② Giả dối.',
  ConsigneeRequired: 'Vui lòng nhập thông tin giao diện HB/L!',
  OverseaCustomerUpdate: '[{0}] đã hết hạn sử dụng dịch vụ khách hàng nước ngoài cũ, có cập nhật dịch vụ khách hàng nước ngoài mới không [{1}]',
  ConatainerNoRemoveRelation: 'Dữ liệu có số hộp {0} sẽ bị xóa liên kết, có cần tiếp tục không?',
  EDIBooking: 'ĐK EDI',
  EDIContainers: 'Thông tin đóng gói EDI',
  ContainersLog: 'Nhật ký nhận lại thông tin đóng gói',
  PleaseSelect2: 'Vui lòng chọn doanh nghiệp bạn muốn gửi!',
  MingShen: 'Dân sinh',
  MingShenCompany: 'Công ty TNHH đại lý tàu biển quốc tế Minsheng',
  EDIDoc: 'EDI VĐ',
  RoundPaymentAmountExchangeRate: 'ROUND (Số tiền thanh toán * Tỷ giá hối đoái)',
  VGMIsEmpty: 'VGM trống rỗng!',
  VGMRaw: 'VGM gốc',
  VGMCorrection: 'Sửa VGM',
  FileOnlyXlsXlsx: 'Tập tin tải lên chỉ có thể ở định dạng xls, xlsx!',
  FileOnlyXlsx: 'Các tập tin tải lên chỉ có thể ở định dạng xlsx!',
  stayTuned: 'Mong chờ',
  UploadImageFormatWrong: 'Hình ảnh tải lên bị định dạng sai, định dạng hình ảnh chúng tôi hỗ trợ ở giai đoạn này là: PNG、JPG、JPEG， Vui lòng chuyển mã hoặc thay đổi hình ảnh',
  ItIsEmpty: 'Trống',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: 'Thanh toán trước (RMB) - Số tiền thực tế (RMB) - Phí xử lý (RMB) - Bưu điện (RMB) - Phí chấp nhận (RMB)',
  RelatedBusinessNoSpecial: 'Thông tin sản phẩm Thông tin sản phẩm Bình Luận(',
  ReceiptImportFailed: 'Nhập đơn trả lời thất bại!',
  ReceiptImportedSuccessfully: 'Nhập đơn thành công!',
  ReceiptImport: 'Nhập lại',
  CopyLinkPublic: 'Sao chép liên kết (công khai)',
  CopyLinkPromissoryNote: 'Copy link (bản sao)',
  RepeatBoxType: 'Có hai bản ghi loại hộp giống hệt nhau',
  RepeatUldType: 'Một bản ghi của cùng một bộ sưu tập mã đã tồn tại!',
  RealDepartureTime: 'Thời gian rời bến thực tế',
  RealDeparture: 'Rời bến thực tế',
  ActualBerthingTime: 'Thời gian thực tế',
  ImportFailedContactAdministrator: 'Nhập không thành công, vui lòng liên hệ với quản trị viên.',
  ContractPeriod: 'Đối tác: ${0} Hợp đồng tồn tại trong thời hạn hiệu lực, vui lòng điều chỉnh khoản tín dụng tương ứng trong 【Quản lý hợp đồng】.',
  HasBeenSelected: 'Đã được chọn',
  HasExceeded: 'Đã vượt qua!',
  HasExceededCannotEDI: 'Đã vượt quá, không thể EDI!',
  UnloadingPortNotMaintain: '"Cảng dỡ hàng" này của "đơn vị được ủy quyền" hiện tại không duy trì đại lý tương ứng, có làm trống đại lý hàng hóa được chỉ định và thông tin bán hàng đã chọn không?',
  EnYuanHuaXiaKu: 'Nhà hàng gần Enhara Huaxia Khố',
  EnyuanYangyuanKu: 'Nhà hàng gần Enwon Yang Gardens',
  EnyuanGaoxiangku: 'Nhà hàng gần Enhara Takahatsu',
  NotInsuranceOperationPermission: 'Bạn không có quyền hoạt động [được bảo hiểm].',
  CorrectionBillOfLading: 'Sửa vận đơn',
  ConfirmationBillOfLading: 'Xác nhận vận đơn',
  Tips: 'Gợi ý!',
  PickUpTypeDifferentSmallTicket: 'Loại nhận hàng không giống với hóa đơn nhỏ, xác nhận muốn lưu không?',
  OperationDepartmentCannotBeEmpty: 'Bộ phận điều hành không được để trống.',
  FileContentIsEmpty: 'Nội dung tập tin trống',
  FileContentWrong: 'Nội dung file bị lỗi',
  FileSizeCannotLargerThan2MB: 'Kích thước tập tin không được lớn hơn 2MB',
  NoData: 'Không có dữ liệu',
  NoBusinessSelected: 'Chưa chọn doanh nghiệp.',
  OriginalNormal: 'Bản gốc',
  NoImportEDI: 'Không có EDI dẫn',
  PackingDataNotCconsistent: 'Dữ liệu đóng gói danh sách công việc này không khớp với dữ liệu thực tế, vui lòng kiểm tra thông tin đóng gói!',
  CreditControlTheClient: 'Kiểm soát tín dụng của đơn vị ủy thác vé này',
  SaveBusinessBeforeEnterMultiGate: 'Lưu ý: Nhập nhiều điểm, vui lòng lưu doanh nghiệp trước',
  SaveBusinessBeforeEnterMultiGate2: 'Lưu ý: Nhập nhiều điểm hoặc nhiều tủ, vui lòng lưu doanh nghiệp trước',
  BookingWorkspace_PrePlan_ImportExcel: 'Vận tải biển đặt hàng phiên bản cực nhanh - Thông tin cấu hình sẵn - Nhập Excel',
  SpecialCargoNumber: 'Số lô hàng đặc biệt',
  RelevantTicketsResetAndUpdated: 'Sau khi xác nhận, phiếu nhỏ liên quan sẽ được đặt lại và cập nhật, có đồng bộ không?',
  ManifestConfirmed: 'Bản kê khai đã được xác nhận!',
  ManifestDataIsEmpty: 'Dữ liệu về bản kê khai trống rỗng!',
  ManifestConfirmationFailed: 'Bản kê khai đã thất bại!',
  NodeTriggerFailed: 'Kích hoạt nút thất bại!',
  LoadingOfPackingInformationFailed: 'Hộp thông tin tải thất bại.',
  PlanDepartureTime: 'Thời gian khởi hành',
  PlannedBerthingTime: 'Lập kế hoạch neo đậu',
  OriginalPlanDepartureTime: 'Thời gian rời bến theo kế hoạch ban đầu',
  OriginalPlannedBerthingTime: 'Thời gian cập bến theo kế hoạch ban đầu',
  NowPlanDepartureTime: 'Thời gian rời bến theo kế hoạch hiện tại',
  NowPlannedBerthingTime: 'Thời gian cập bến theo kế hoạch hiện tại',
  CurrentETA: 'ời gian đến cảng hiện tại',
  OriginalETA: 'Thời gian đến cảng theo lịch ban đầu',
  CurrentETA1: 'Thời gian đến cảng hiện tại (Current ETA)',
  OriginalETA1: 'Thời gian đến cảng theo lịch ban đầu (Original ETA)',
  ShippingScheduleNew: 'nhập khuôn mẫu (phiên bản mới)',
  ShippingScheduleold: 'nhập khuôn mẫu (phiên bản cũ)',
  ImportNew: 'Nhập khẩu (New Version)',
  ImportOld: 'Import (phiên bản cũ)',
  PlannedBerthing: 'Kế hoạch neo đậu',
  PlanDeparture: 'Kế hoạch rời bến',
  BookingEDI: 'Đăng ký EDI',
  BookingCorrection: 'Sửa chữa đặt cọc',
  PortMaintainedDesignatedFreightForwarder: 'Cảng đã duy trì một đại lý hàng hóa được chỉ định tương ứng, có sử dụng đại lý hàng hóa được chỉ định được duy trì tại cảng đó không?',
  MBLStatusNotIsUnStart: 'Vé MBL đến trạng thái đơn không phải là chưa bắt đầu và không thể nhập.',
  PrimaryOrderNotSameReceipt: 'Số chính của nghiệp vụ vé này không nhất trí với số chính của nghiệp vụ vé, có tiếp tục dẫn vào không?',
  RequestSuccessful: 'Yêu cầu thành công!',
  SpecialCharacters: 'Các ký tự đặc biệt không thể bắt đầu đăng ký khu vực cảng hoặc dữ liệu công ty tàu',
  EnterReleaseNumber: 'Vui lòng nhập số đặt hàng',
  SelectAPieceOfData: 'Vui lòng chọn một phần dữ liệu!',
  SelectARecord: 'Vui lòng chọn một kỷ lục!',
  ChooseDesignatedAgent: 'Vui lòng chọn đại lý hàng hóa được chỉ định!',
  ChooseSpecialGoods: 'Vui lòng chọn hàng đặc biệt!',
  CargoInformationIsEmpty: 'Thông tin hàng hóa trống rỗng.',

  InviteSupplementaryLinksPublic: 'Mời liên kết bổ sung (công khai)',
  InviteSupplementaryLinkPromissoryNote: 'Liên kết bổ sung lời mời (phiếu này)',
  DownloadCWTemplate: 'Tải về CargoWare Stencil',
  DownloadCWTemplateJC: 'Tải về CargoWare Template',
  DownloadSeaHouseTemplate: 'Tải về Sea Butler Templates',
  DownloadWseTemplate: 'Thiết bị vớt váng dầu mỡ cho xử lý nước thải -PetroXtractor - Well Oil Skimmer (',
  DownloadWseTemplateSh: 'Tải về CargoWare Template (Thượng Hải)',
  DownloadWseTemplateVgm: 'Tải xuống mẫu',
  SendingChannelVgm: 'Gửi kênh',
  MailSendingFailed: 'Gửi thư thất bại!',
  DistributionFailed: 'Giao hàng thất bại',
  SalesAndOperationAreSame: 'Bán hàng và hoạt động giống nhau, xác nhận bạn muốn lưu?',
  PreConfiguredManifestAPI: 'Giao diện Manifest API',
  PreConfiguredManifestDeletion: 'Gỡ bỏ bản kê khai trước',
  PreConfiguredManifestIsEmpty: 'Đối tượng xóa bản kê khai được phân phối trước trống, vui lòng thử lại sau khi làm mới trang',
  CorrectionOfPreAllocatedManifest: 'Sửa bản kê khai trước',
  OperationFailed: 'Chiến dịch thất bại!',
  RedOffsetCannotModified: 'Chi phí xung đỏ hoặc chi phí xung đỏ không thể sửa đổi lại, xin vui lòng chọn tăng điều chỉnh.',
  RedOffsetCannotDeleted: 'Phí đỏ hoặc phí đỏ không thể xóa, vui lòng chọn lại',
  MaintainNodeDetailCode: 'Vui lòng duy trì chi tiết nút Mã',
  DeleteNumRecord: 'Bạn có chắc chắn muốn xóa bản ghi {0} này không?',
  DeleteNumFile: 'Bạn có chắc chắn muốn xóa {0} tập tin này hàng loạt?',
  ClickYesRetrievedToReturnedStatus: 'Nhấp vào Yes để chuyển đến trang in và các chứng từ "đã lấy lại" được thay đổi thành trạng thái "đã trả lại".',
  ClickYesToReturnedStatus: 'Nhấp vào Yes sẽ chuyển đến trang in và sửa đổi chứng từ thành trạng thái hoàn trả.',
  FileNotAllowedView: 'Tệp không cho phép bất cứ ai xem hoặc tải xuống.',
  NoPermissionToView: 'Bạn không có quyền xem hoặc tải xuống tệp [{0}]',
  UploadFailed: 'Tải lên thất bại!',
  UploadSuccess: 'Upload thành công!',
  UploadSuccessNoOrder: 'Tải lên thành công, không tìm thấy đơn đặt hàng liên quan!',
  UploadedFileNotMatch: 'Các loại tập tin tải lên không phù hợp, xin vui lòng kiểm tra!',
  UploadType: 'Loại upload',
  FileSource: 'Nguồn tài liệu',
  ReceiptType: 'Loại pullback',
  SendAisle: 'Kênh EDI',
  BusinessNotSubmitted: 'Doanh nghiệp chưa nộp, không thể hoàn trả',
  BusinessNotBeenApproved: 'Nghiệp vụ vẫn chưa được xét duyệt, xác nhận muốn trả lại sao?',
  NoPermissionToViewOrprinted: 'Bạn không có quyền xem các tập tin được tải lên hoặc in bởi người khác.',
  DocumentDelivery: 'Giấy tờ gửi đi',
  SameStatusCanBePrinted: 'Chỉ có thể in giấy tờ cùng trạng thái!',
  ReceiptContent: 'Nội dung trả về',
  ReceiptTime: 'Thời gian trả lại',
  PrintCommonControls: 'In các điều khiển chung',
  CustomsBrokerOthers: 'Đại lý hải quan/Khác',
  ReceiveReceiptTime: 'Thời gian nhận lại',
  ReceivingAddress: 'Địa chỉ nhận',
  bookingParty: 'Đơn vị đặt hàng',
  BusinessIsLocked: 'Doanh nghiệp đã bị khóa và không thể hoàn trả',
  ConfirmUploadFileType: 'Vui lòng xác nhận loại tệp tải lên, bạn có muốn tiếp tục tải lên không?',
  InputCustomerName: 'Vui lòng nhập tên khách hàng!',
  InputExpressNumber: 'Vui lòng nhập số chuyển phát nhanh!',
  InputExpressAddress: 'Vui lòng nhập địa chỉ chuyển phát nhanh!',
  InputRecipient: 'Vui lòng nhập người nhận!',
  InputRecipientName: 'Vui lòng nhập tên người nhận!',
  InputReceivingcompany: 'Vui lòng nhập đơn vị nhận hàng!',
  InputReceivingAddress: 'Vui lòng nhập địa chỉ nhận!',
  InputContactNumber: 'Vui lòng nhập số liên lạc!',
  InputContactNumberMark: 'Vui lòng nhập số liên lạc!',
  InputReturnExpressNumber: 'Vui lòng nhập số chuyển phát nhanh trở lại!',
  ReturnInformation: 'Thông tin',
  ReturnDateGreaterThanRetrieveDate: 'Ngày hoàn trả phải lớn hơn ngày lấy lại!',
  DateModified: 'Thời gian cập nhật',
  OperationCannotBeEmpty: 'Thao tác không thể để trống.',
  OperationCompanyCannotBeEmpty: 'Công ty không được để trống.',
  BookingAudit: 'Kiểm tra đặt phòng',
  UseThisNo: 'Sử dụng số này',
  WarehousingFee: 'Phí lưu kho',
  BookingSuccess: 'Đặt phòng thành công',
  ToBeConfirmed: 'Đặt phòng đang chờ xác nhận.',
  BookingFail: 'Đặt phòng thất bại',
  CabinState: 'Trạng thái cabin',
  CostGenerationMethod: 'Cách tạo chi phí',
  SettlementInPriginalCurrency: 'Thanh toán bằng đồng tiền gốc',
  SettlementInBillCurrency: 'Thanh toán bằng đơn vị tiền tệ',
  ShowDetails: 'Hiển thị chi tiết',
  ImportResultLog: 'Nhập nhật ký kết quả',
  ImportComplete: 'Nhập xong',
  SuccessItemFailedItem: 'Thanh 【{0}】 thành công, thanh 【{1}】 thất bại.',
  ContinueImporting: 'Tiếp tục nhập',
  DownloadResultLog: 'Tải nhật ký kết quả',
  PONo: 'Số PO',
  VoyageOnlyNum: 'Chuyến bay chỉ có thể nhập số hoặc chữ cái.',
  UpdateSuccess: 'Thay đổi thành công.',
  ShippingSpace: 'Phòng',
  RejectTips: 'Xác nhận rằng bạn muốn từ chối {0} để vượt qua kiểm tra? Vui lòng nhập lý do từ chối:',
  GenerateBusinessTips: 'Xác nhận tạo doanh nghiệp? (Không thể hủy bỏ sau khi tạo)',
  ReturnedShipping: 'Có xác nhận đã trả lại khoang không? (Không thể hủy bỏ sau khi hồ sơ được trả lại)',
  ReturnedShippingSuccess: 'Rút lui thành công.',
  ShippingCompanyAndBookingAgent: 'Vui lòng nhập công ty tàu tương ứng và đại lý đặt phòng',
  CabinCopySuccess: 'Các khoang đã được sao chép thành công với số doanh nghiệp mới là:',
  CheckShippingCompanyAndBookingAgent: 'Công ty tàu và đại lý đặt phòng không thể chỉ điền một mục',
  ReviewRejectedSuccess: 'Từ chối thành công',
  ReviewSuccess: 'Tái kiểm thành công',
  BatchReviewSuccess: 'Kiểm tra lại hàng loạt thành công',
  CheckBatchReview: 'Nghiệp vụ phúc thẩm số lượng lớn không thể vượt quá 50 điều!',
  RefuseSuccess: 'Từ chối thành công',
  BatchAuditSuccess: 'Kiểm toán hàng loạt thành công',
  AuditSuccess: 'Kiểm toán thành công',
  CheckCreditTipOne: 'Các đơn vị ủy thác của các doanh nghiệp sau đây đã bị kiểm soát quá mức, không thể xem xét thông qua',
  CheckCreditTipTwo: 'Đơn vị ủy thác nghiệp vụ sau đây đã vượt mức tín nhiệm, xác nhận muốn xét duyệt thông qua sao?',
  BatchAuditBusinessTip: 'Nghiệp vụ xét duyệt số lượng lớn không thể vượt quá 50 điều!',
  CheckCreditSaveTip: 'Do kiểm soát tín hiệu vượt quá, vé đã bị khóa, sẽ không thể in hoặc EDI, vui lòng liên hệ với cấp trên để mở khóa khi cần thiết!',
  CabinCopy: 'Sao chép cabin',
  EnterShippingCompany: 'Vui lòng nhập công ty tàu vào 【Phòng {0}】',
  EnterBookingAgent: 'Vui lòng nhập đại lý đặt phòng vào 【Phòng {0}】',
  EnterEtd: 'Vui lòng nhập ngày khởi hành vào 【Phòng {0}】',
  CheckEnterShippingCompanyBookingAgentEtd: 'Vui lòng nhập công ty tàu tương ứng, đại lý đặt chỗ, ngày khởi hành.',
  UnreviewedBusinessNumber: 'Số doanh nghiệp chưa được kiểm toán: {0}',
  UnreviewedBusinessNumber2: 'Số ủy quyền chưa được kiểm toán',
  DateOfCreation2: 'Thời gian tạo',
  plateNumberAndMblCannotBeEmpty: 'Biển số xe và số vận đơn không được để trống',
  ActualDateOfDeparture: 'Ngày khởi hành thực tế',
  ActualDateOfDeparture2: 'Ngày khởi hành thực tế (ATD)',
  nameOfVesselCannotBeEmpty: 'Tên tàu không được để trống.',
  voyageNumberCannotBeEmpty: 'Chuyến bay không thể rỗng.',
  shippingCompanyCannotBeEmpty: 'Công ty tàu không được để trống.',
  MasterShippingCompanyCannotBeEmpty: 'Công ty tàu chính không được để trống',
  hasBeanSend: 'Đã gửi',
  notSend: 'Chưa gửi',
  UpdateTime: 'Thời gian cập nhật',
  CategoryOfGoods: 'Loại hàng hóa lớn',
  ShipperLine1: 'Gửi hàng đầu tiên',
  ConsigneeLine1: 'Người nhận hàng đầu tiên',
  NotifyPartyLine1: 'Thông báo dòng đầu tiên',
  CargoDocShipperLine1: 'Vận đơn vận chuyển hàng đầu tiên',
  CargoDocConsigneeLine1: 'Dòng đầu tiên của người nhận B/L',
  CargoDocShipper: 'Vận đơn vận chuyển',
  CargoDocConsignee: 'Người nhận vận đơn',
  CargoDocNotify: 'Thông báo vận đơn',
  CargoDocNotifyPartyLine1: 'Thông báo vận đơn hàng đầu tiên',
  MBLBillOfLadingNum: 'Số dòng chảy đơn chính',
  HBLBillOfLadingNum: 'Dòng chảy đơn lẻ',
  RegularBusiness: 'Chuyển sang kinh doanh chính thức',
  InputDate2: 'Ngày nhập',
  ExpectedArrivalDate: 'Ngày dự kiến đến cảng',
  PleaseChooseEtdStartDate: 'Vui lòng chọn ngày bắt đầu ETD.',
  PleaseChooseEtdEndDate: 'Vui lòng chọn ngày kết thúc ETD.',
  VOYAGE_NUMBER_ALERT: 'Vui lòng điền số chuyến bay.',
  voyageNumberRepeat: 'Chuyến bay không thể lặp lại.',
  DirectOrderOrNot: 'Đơn hàng thẳng',
  EDICode: 'Mã EDI',
  MSCVesselImport: 'Nhập khẩu MSC',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: 'Hồ sơ công ty tàu không được để trống.',
  CannotBeTheSame: 'Hãng tàu ghép không được trùng với hãng tàu chính',
  PortNotNull: 'Có dữ liệu cảng trống, tất cả cảng trong mỗi chuyến đều không được để trống',
  PortDuplication: 'Không được trùng lặp cảng',
  EtdAndEtaNotNull: 'Original ETA và Original ETD không thể đều trống',
  shipNameCannotBeEmpty: 'Tên tiếng Trung hoặc tiếng Anh của tàu không được để trống.',
  alreadyExistsShipNameAndContinueToSave: 'Đã có tên tiếng Trung hoặc tiếng Anh của cùng một tên tàu, có tiếp tục bảo tồn không?',
  ExportAllToExcel: 'Xuất tất cả Excel',
  FlightAndTime: 'Chuyến bay/chuyến',
  exportThisPageEdi: 'Xuất trang này EDI',
  ExportAgentList: 'Danh sách đại lý xuất',
  ContinueToExport: 'Tiếp tục xuất',
  OnlyMainTicketAndFCLServicesCanBeExported: 'Chỉ có Master Ticket và Whole Box Business mới có thể xuất Doanh nghiệp đã đánh dấu của bạn không thể xuất',
  IgnoresNonExportableServices: 'Chỉ có vé chính và hệ thống xuất doanh nghiệp trọn gói sẽ tự động bỏ qua doanh nghiệp không thể xuất có tiếp tục xuất không?',
  ExportSuccess: 'Xuất thành công',
  voyageShippingCompanyCanNotNull: 'Công ty tàu không được để trống',
  PleaseSelectShippingName: 'Vui lòng chọn tên tàu',
  DownloadTemplate: 'Tải xuống mẫu',
  BLForm: 'Hình thức B/L',
  FreeDetention: 'Thời gian thuê miễn phí',
  FreeDemurrage: 'Số ngày miễn phí',
  CustomsAreaApplication: 'Ứng dụng khu vực quan',
  SettlementCompanyNotEmpty: 'Bộ phận thanh toán không thể để trống!',
  StartMbl: 'Tiền tố đơn chính',
  EndMbl: 'Kết thúc đơn vị chính',
  BillOfLading: 'Số nhận hàng',
  CartonQuantityCannotBeZero: 'Số lượng hộp không được để trống!',
  DistributionNo: 'Số đơn quay số',
  DistributionWarehouse: 'Kho phân phối',
  PreDateOfCustomsDeclaration: 'Dự báo ngày đóng cửa',
  sendFailed: 'Gửi thất bại',
  SelfDeclaration: 'Tự khai hải quan',
  FilingType: 'Loại khai báo',
  emailAccount: 'Khai báo tài khoản',
  secondGeneration: 'Lưu ý: Thế hệ thứ hai phải điền số hồ sơ hải quan Canada',
  CanadianCustomsRecordNumber: 'Số hồ sơ hải quan Canada',
  ExchangeService: 'Có cần dịch vụ thay đổi môi giới hải quan không?',
  SpecialRelationshipOfBuyer: 'Người bán có quan hệ đặc biệt',
  IncludeRoyalty: 'Đã bao gồm tiền bản quyền',
  AffectPrice: 'Ảnh hưởng đến giá',
  WoodPacking: 'Cho dù đóng gói bằng gỗ',
  Combination: 'Kết hợp',
  Split: 'Tách',
  FinalStepSync: 'Đồng bộ chặng cuối',
  FinalStepSyncBtn: 'Đồng bộ chặng cuối',
  Synced: 'Đã đồng bộ',
  NotSynced: 'Chưa đồng bộ',
  PleaseSelectSyncOrder: 'Vui lòng chọn đơn hàng cần đồng bộ',
  PleaseFillLastMilePlanner: 'Vui lòng điền Trưởng bộ phận kinh doanh chặng cuối',
  PleaseSelectNotSyncedOrder: 'Vui lòng chọn đơn hàng chưa đồng bộ',
  CombinationJob: 'Kinh doanh kết hợp',
  ReceivableChargeLockedStatus: 'Trạng thái khóa phí phải thu',
  PayableChargeLockedStatus: 'Trạng thái khóa chi phí phải trả',
  NotLocked: 'Không khóa',
  ChargeLocked: 'Phí phải trả hoặc phải trả đã bị khóa và không thể thực hiện thao tác này!',
  ArChargeLocked: 'Phí phải thu đã bị khóa và không thể thực hiện thao tác này!',
  ApChargeLocked: 'Phí phải trả đã bị khóa và không thể thực hiện việc này!',
  LockedStatus: 'Trạng thái khóa',
  LockedDate: 'Thời gian khóa',
  LockAr: 'Khóa để nhận',
  UnLockAr: 'Thu hồi Lockout',
  LockAp: 'Khóa phải đối phó',
  UnLockAp: 'Thu hồi khóa phải trả',
  importExpenseStatus: 'Trạng thái chi phí sau khi nhập',
  accountingDate: 'Ngày tài chính sau khi nhập',
  BatchReturnSubmit: 'Gửi hàng loạt rút tiền',
  BatchReturnPreSubmission: 'Trả lại hàng loạt Pre-Submission',
  BatchUnlockReceivableExpenses: 'Mở khóa hàng loạt có tính phí',
  BatchUnlockPayableFees: 'Mở khóa hàng loạt phải trả phí',
  UnlockApplyBtn: 'Gửi yêu cầu mở khóa',
  UnlockApplyTitle: 'Yêu cầu mở khóa phí',
  UnlockApplyJobCount: 'Số đơn trong yêu cầu này: {0}',
  UnlockApplyCountLimitTip: 'tối đa 200 đơn mỗi yêu cầu',
  UnlockApplyReason: 'Lý do mở khóa',
  UnlockApplyReasonPlaceholder: 'Vui lòng nhập lý do mở khóa',
  UnlockApplyReasonRequired: 'Vui lòng nhập lý do mở khóa',
  UnlockApplyReasonOverLength: 'Lý do mở khóa không được vượt quá 500 ký tự',
  DeclaredProfitImpact: 'Số tiền ảnh hưởng lợi nhuận kê khai',
  UnlockApplyAmountRequired: 'Vui lòng nhập số tiền ảnh hưởng lợi nhuận kê khai',
  UnlockApplySubmit: 'Gửi yêu cầu',
  UnlockApplyPrecheckFailed: 'Kiểm tra không thành công. Các đơn sau không thể gửi yêu cầu, vui lòng điều chỉnh và thử lại:',
  UnlockApplyFailureReason: 'Lý do thất bại',
  UnlockApplyOnlySeaExport: 'Chỉ đơn xuất khẩu đường biển mới có thể gửi yêu cầu',
  UnlockApplyOverLimit: 'Một lần thao tác không được vượt quá 200 đơn',
  UnlockApplyChargeNotLocked: 'Phí phải thu/phải trả đều chưa bị khóa, không cần gửi yêu cầu mở khóa',
  UnlockApplyJobNotLocked: 'Đơn hàng hiện tại chưa bị khóa, không thể gửi yêu cầu mở khóa!',
  UnlockApplyJobStateInvalid: 'Trong các đơn đã chọn có đơn chưa ở trạng thái Đã duyệt, vui lòng kiểm tra!',
  UnlockApplySubmitted: 'Đã gửi yêu cầu, số lô: {0}',
  UnlockApplyApproving: 'Đang chờ phê duyệt mở khóa',
  UnlockApplyUnlocking: 'Đang mở khóa',
  UnlockApplyUnlockedBanner: 'Phí của đơn hàng này đã được mở khóa để chỉnh sửa và sẽ tự động khóa lại vào 01:00 sau 3 ngày',
  BatchLockingReceivableExpenses: 'Bulk Lockout có tính phí',
  BatchLockingPayableFees: 'Số lượng lớn khóa phải trả phí',
  ReplaceSOPTemplatesInBatches: 'Mẫu SOP thay thế hàng loạt',
  BatchUpdateScNo: 'Sửa đổi hàng loạt số xấp xỉ',
  BatchUpdateScNoSuccess: 'Sửa đổi số lượng lớn thành công: {0}',
  BatchUpdateScNoCheck: 'Chỉ có thể thay đổi một danh sách các thao tác dương với số lượng lớn.',
  BatchReturnSubmitCheck: 'Chỉ cho phép hủy bỏ trạng thái kinh doanh là một danh sách đã gửi.',
  MasterChargeIsShare: 'Chi phí vé chính có được chia không?',
  PackageDisplayName: 'Tên hiển thị gói',
  ChargeSource: 'Nguồn dữ liệu',
  AddressOfContact: 'Địa chỉ liên lạc',
  FinancialExamineDate: 'Ngày xét duyệt tài chính',
  ReceiptStatus: 'Trạng thái trả về',
  TransitInformation: 'Thông tin quá cảnh',
  ThreeWay: 'Ba cấp độ',
  placeOrder: 'Đặt hàng',
  BatchUpdateCustomJobType: 'Thay loạt loại hình KD tùy chỉnh',
  CustomJobTypeBatchModifySuccess: 'Thay đổi hàng loạt các loại hình kinh doanh tùy chỉnh thành công:',
  BatchManagerSubmission: 'Gửi bởi Batch Supervisor',
  BatchManagerSubmissionTips: 'Người giám sát chỉ có thể đệ trình nghiệp vụ hoạt động tích cực và đệ trình trước với số lượng lớn!',
  BatchManagerSubmissionSuccessfully: 'Quản lý hàng loạt đã đệ trình thành công:',
  VotesManagerSubmission: 'Vé có được trình lên giám đốc không?',
  CopyEnglishDescriptionOfGoodsFromMergeJob: 'Nhập tên tiếng Anh',
  CopyMarkFromMergeJob: 'THAM GIA ĐỘC QUYỀN',
  SyncToSmallTicket: 'Đồng bộ hóa vé nhỏ',
  externalBusinessStatus: 'Trạng thái đặt hàng', // 爱拼订单状态
  SoNo1: 'S/O No.',
  NaturalPerson: 'Người tự nhiên',
  LegalPerson: 'Pháp nhân',
  IndividualAssociation: 'Hiệp hội cá nhân',
  TelSeparate: 'Mã vùng Vui lòng sử dụng' - 'Tách ra',
  EnsNo: 'Số ENS',
  ShippingCompanyEORI: 'Hãng tàu EORI',
  DeclarantEORI: 'Người khai báo EORI',
  Memberstate: 'Quốc gia đầu tiên gia nhập EU',
  ENSNumber: 'Số ENS',
  EnsHsCodeNotMatch: 'Số thứ tự thông tin hàng hóa không khớp với thông tin hộp',
  EnsCorrelativeNoRepeat: 'Thông tin sản phẩm được lặp lại',
  LinkedCargoInformationNoNotNull: 'Thông tin liên quan Thông tin hàng hóa Số sê-ri không được để trống',
  maxLength: 'Độ dài không được vượt quá {0} ký tự',
  PleaseEnterLength: 'Vui lòng nhập {0} ký tự',
  FreightTermConflict: 'Lựa chọn có mâu thuẫn với lựa chọn địa điểm giao hàng tại cảng dỡ hàng',
  FreightTermConflict2: 'Lựa chọn có mâu thuẫn với lựa chọn địa điểm nhận hàng tại cảng hàng',
  NeedPrefix: 'Cần khai báo với tiền tố, tiền tố đơn: {0}',
  RemoveThePrefix: 'Cần loại bỏ tiền tố: {0}',
  PhoneTooLong: 'Mã vùng không được lớn hơn 4 ký tự và điện thoại không được lớn hơn 20 ký tự',
  SaveOnly: 'Chỉ lưu',
  Only6: 'Chỉ hỗ trợ 6 chữ số',
  ChargesPaymentMethod: 'Phương thức thanh toán phí',
  CopyConsignor: 'Sao chép người gửi hàng',
  CopConsignee: 'SaoChép NH',
  BuyerAndSellerInformation: 'Thông tin người mua',
  StreetNumber: 'Số đường phố',
  WaitingForReceipt: 'Gửi lần cuối thành công và không nhận được thư trả lời, vui lòng đợi thư trả lời gửi lại',
  DirectlyRepresenting: 'Đại diện trực tiếp',
  IndirectRepresentation: 'Đại diện gián tiếp',
  NeedOne: 'Chỉ cần thêm một phần dữ liệu',
  ContainShutOutJob: 'Bao gồm doanh nghiệp hủy bỏ quan hệ',
  BatchEditJobNo: 'Thay đổi số lượng doanh nghiệp',
  IncludingSCFIFreightRate: 'Bao gồm giá cước SCFI',
  SCFIDesignatedBoxType: 'SCFI chỉ định loại hộp',
  JingyiSystemForecast: 'Dự báo hệ thống Jingyi',
  OriginalAHR: 'AHR gốc',
  AddChr: 'Tăng CHR',
  CorrectAFR: 'Sửa AFR',
  NonRepeatingNumbers: 'Vui lòng nhập số không trùng lặp',
  AddressFormatting: 'Định dạng địa chỉ',
  SendToGoFreight: 'Gửi đến FREIGHT',
  ViewSendLog: 'Xem nhật ký gửi',
  BookingFreightRate: 'Giá vận chuyển cabin',
  SelectedDataDeclaration: 'Chọn khai báo dữ liệu',
  EmptySubmissionDeclaration: 'Khai báo rỗng',
  SettlementFreightRate: 'Định giá vận chuyển',
  DeclarationRecord: 'Hồ sơ khai báo',
  ImNotHavePermissionDetails: 'Không xứng đáng! Bạn không có quyền xem chi tiết.',
  ActionOptionsNotCaptured: 'Không bắt được tùy chọn hành động!',
  BatchNotSupportedPleaseAgain: 'Gửi hàng loạt không được hỗ trợ, vui lòng chọn lại!',
  ItFreightAndRepeatedAllowed: 'Đã gửi đến GO FREIGHT, không cho phép gửi lại',
  SentSuccessfully: 'Gửi thành công',
  CheckTheSendingLog: 'Xem bản ghi gửi',
  OnlyToViewTheSelect: 'Chỉ có thể chọn một doanh nghiệp để xem nhật ký gửi, vui lòng chọn lại!',
  ItUpTo50Businesses: 'Có thể xử lý tối đa 50 công việc.',
  Business: 'Kinh doanh:',
  NonIntegralType: 'Loại Non-Complete Collage',
  SendComplete: 'Gửi xong',
  PackingList: 'Danh sách hộp',
  PleaseContainerBusinessForOperation: 'Vui lòng chọn doanh nghiệp trọn gói để hoạt động!',
  EmptyInterfaceSendingPleaseWait: 'Giao diện dữ liệu hộp trống đang được gửi đi, xin chờ một chút......',
  VerificationOfDeclarationData: 'Kiểm tra dữ liệu khai báo',
  DataCheckTheDataAgain: 'Xác minh dữ liệu không thành công, hãy thử lại sau khi kiểm tra dữ liệu.',
  PleaseWhetherToSubmitThis: 'Vui lòng xác nhận nếu bạn gửi cái này',
  TicketData: 'Dữ liệu vé?',
  DataDeclarationSucceeded: 'Khai báo dữ liệu thành công.',
  EmptySubmittedSuccessfully: 'Gửi rỗng thành công.',
  NotData: 'Không có dữ liệu.',
  ThereElectronicPackingListData: 'Không có dữ liệu email.',
  SendFailed: 'Gửi thất bại:',
  Empty: 'Trống',
  PleaseOfDepartureMustPort: 'Xin vui lòng xác nhận rằng cảng khởi hành phải là cảng Thượng Hải.',
  PleaseMustBeTheExchange: 'Vui lòng xác nhận rằng cảng dỡ hàng phải là cảng được chỉ định cho nhà ga hàng không.',
  PleaseOfGoodsMustGoods: 'Vui lòng xác nhận loại hàng hóa phải là hàng phổ thông.',
  PleaseOfTheMainCY: 'Vui lòng xác nhận rằng Điều khoản vận chuyển chính phải là "CY-CY".',
  PleaseTradeTermsMustCIF: 'Vui lòng xác nhận rằng các điều khoản thương mại phải là "CIF".',
  PleaseBoxQuantityInformationCorrect: 'Vui lòng xác nhận thông tin về khối lượng hộp là chính xác.',
  TheAmountReceivableIncludesUSD: 'Vui lòng xác nhận phí - phải thu bao gồm các khoản tiền USD được chỉ định.',
  NoBillOfLadingInformation: 'Không có thông tin vận đơn HBL.',
  ResponseDataIsEmpty: 'Dữ liệu phản hồi trống',
  PleaseToViewTheLog: 'Vui lòng chọn doanh nghiệp bạn muốn xem nhật ký gửi!',
  ExportEDI: 'Xuất khẩu EDI?',
  LandTransportationDetailsEditing: 'Thông tin chi tiết về Land Transport',
  PreviewOfBookingFileParsing: 'Xem thử phân tích tập tin đặt phòng',
  GenerateOrder: 'Tạo đơn đặt hàng',
  HangInTheAir: 'Chưa hoàn thành',
  Completed: 'Đã hoàn thành',
  Dustbin: 'Thùng rác',
  PictureLoadingFailed: 'Tải ảnh không thành công',
  ResolutionCompletionTime: 'Thời gian hoàn thành phân tích',
  ViewParsingResults: 'Xem kết quả phân tích',
  ViewOrder: 'Xem đơn đặt hàng',
  AreYouWantToDelete: 'Xác nhận bạn muốn xóa?',
  BusinessNumber: 'Số doanh nghiệp',
  LCL: 'LCL trong FCL',
  NearlyAWeek: 'Gần một tuần',
  NearlyAMonth: 'Gần một tháng',
  NearlyThreeMonths: 'Gần 3 tháng',
  DragUploadTheFileIdentified: 'Kéo tập tin vào đây để tải lên tập tin cần nhận dạng',
  SupportUploadFormat: 'Hỗ trợ định dạng tải lên',
  ParsingFailed: 'Phân tích thất bại',
  ParsingComplete: 'Phân tích xong',
  OrderGenerated: 'Lệnh đã tạo',
  UploadCompletedParsing: 'Tải lên xong, đang phân tích......',
  Second: 'giây',
  ReviewRejectedBusinessNumber: 'Số doanh nghiệp từ chối xem xét lại',
  RejectedBusinessNumber: 'Số doanh nghiệp bị từ chối',
  TheNotExceed5Lines: 'Tối đa không được vượt quá 5 dòng!',
  Interface: 'Giao diện',
  Sinotrans: 'Vận chuyển giữa và ngoài',
  SinotransEastChinaCoLtd: 'Trung Quốc vận chuyển nước ngoài Đông Trung Quốc Công ty TNHH',
  NingboEPort: 'Cửa khẩu điện tử Ninh Ba',
  SeaHousekeeper: 'Hải quản gia',
  Wse: 'Việt',
  CargoWare: 'Cargoware gửi',
  EDISend: 'EDI gửi',
  OtherChannel: 'Các kênh khác',
  Ningbo99Road: 'Đường Ninh Ba 99',
  DeclarationHistory: 'Lịch sử khai báo',
  CredentialNumber: 'Số chứng từ',
  ResponseCode: 'Mã phản hồi',
  ElectronicBoxListSendingHistory: 'E-mail danh sách gửi lịch sử',
  PrintTime: 'Thời gian in',
  PrintingTimes: 'Số lần in',
  BookingDataFeedback: 'Phản hồi dữ liệu đặt chỗ',
  QuerySendingLog: 'Nhật ký gửi truy vấn',
  SendDataInformation: 'Gửi thông tin dữ liệu',
  ExportAllEDI: 'Xuất tất cả EDI',
  UploadThisPageEDI: 'Tải lên trang này EDI',
  UploadAllEDI: 'Tải lên tất cả EDI',
  EmailUploadEDI: 'Tải lên thư EDI',
  IsExportEDI: 'Xuất khẩu EDI?',
  UploadEDI: 'Tải lên EDI?',
  IsUploadAllEDI: 'Tải lên tất cả các EDI?',
  MailSending: 'Gửi thư',
  UploadEDISucceeded: 'Tải lên EDI thành công',
  FailedToUploadEDI: 'Tải lên EDI không thành công',
  MultiSegmentNumberRuleConfiguration: 'Cấu hình quy tắc số nhiều đoạn',
  StartNumber: 'Số bắt đầu',
  IncrementalRule: 'Quy tắc tăng dần',
  DirectExport: 'Xuất trực tiếp',
  Plus1: 'Cộng 1',
  Plus10: 'Cộng 10',
  TheNumberCannotBeEmpty: 'Số ban đầu không được để trống.',
  IllegalNumberEntry: 'Nhập số không hợp pháp.',
  TheMustBeGreaterZero: 'Số lượng phải lớn hơn 0.',
  IncrementRuleIsNotSelected: 'Quy tắc tăng dần không được chọn.',
  PleaseBusinessNumberSearchCriteria: 'Vui lòng nhập số doanh nghiệp Điều kiện tìm kiếm',
  UploadCompletedProcessing: 'Upload xong, đang xử lý',
  SuccessfulProcessing: 'Xử lý thành công',
  ProcessingFailed: 'Xử lý thất bại',
  ExportTime: 'Thời gian xuất',
  UnitPriceCannotBe0: 'Đơn giá không thể bằng 0',
  ExchangeRateCannotBe0: 'Tỷ giá hối đoái không thể bằng 0',
  CustomsNoCannotBeBlank: 'Số đóng cửa không thể để trống!',
  ShipperCityCannotBeBlank: 'Vui lòng nhập tên thành phố của người gửi hàng',
  PrimaryCustomsNo: 'Số chính',
  GetPackingInformation: 'Nhận thông tin đóng gói',
  GetGoodsInformation: 'Nhận thông tin hàng hóa',
  GetGoodsInformationTip: 'REFERENCES [Tên bảng tham chiếu] (',
  SynchronizeMainTicketPackingInformation: 'Đồng bộ hóa thông tin đóng gói vé chính',
  CaseNumberCannotBeEmpty: 'Số hộp không được để trống.',
  InvalidCaseNumber: 'Số hộp không hợp lệ.',
  TheSealNumberCannotBeEmpty: 'Phong hào không thể để trống.',
  BoxTypeCannotBeEmpty: 'Hộp không thể rỗng.',
  EnglishNameCannotBeEmpty: 'Tên tiếng Anh không được để trống.',
  TheMarkCannotBeEmpty: 'Đầu không thể trống rỗng.',
  HscodeCannotBeEmpty: 'HSCode không thể để trống.',
  EqCodeMatchError: 'Loại hộp Các loại hộp không khớp, vui lòng chọn lại',
  ThePackageCannotBeEmpty: 'Bao bì không được để trống.',
  ThePiecesCannotBeEmpty: 'Số lượng không được để trống.',
  GrossWeightCannotBeEmpty: 'Trọng lượng không thể rỗng.',
  VolumeCannotBeEmpty: 'Khối lượng không thể rỗng.',
  DanUNNoCannotBeEmpty: '【UN Code】 Hàng hóa nguy hiểm bắt buộc, phạm vi 0001-9999',
  DanClassNoCannotBeEmpty: '【Lớp hàng nguy hiểm】 Hàng nguy hiểm Bắt buộc, Phạm vi: 1-9.9',
  DangerousGoodsContactCannotBeEmpty: 'Hàng hóa nguy hiểm không được để trống.',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: 'Số liên lạc hàng nguy hiểm không được để trống',
  TherePleaseEnterItTab: 'Không có thông tin nhập khẩu, vui lòng kiểm tra nhập khẩu tại trang "Boxing Information"',
  NoMasterTicketInformationYet: 'Tạm thời không có thông tin vé chính!',
  WeighingMethod: 'Cách cân',
  VGMLLC: 'Công ty trách nhiệm VGM',
  VGMWeightAddress: 'VGM cân địa chỉ',
  VGMSignature: 'Chữ ký VGM',
  TareWeight: 'Trọng lượng vỏ',
  TareWeightUnit: 'Hộp Tare đơn vị',
  WeighingAddress: 'Cân địa chỉ',
  WeighingMethodCannotBeEmpty: 'Cách cân không được để trống.',
  TheWeightCannotBeEmpty: 'Tổng trọng lượng không thể để trống.',
  VGMCompanyCannotBeEmpty: 'Công ty trách nhiệm VGM không được để trống.',
  VGMSignatureCannotBeEmpty: 'Chữ ký VGM không được để trống.',
  MailboxCannotBeEmpty: 'Hộp thư không được để trống.',
  PhoneNumberCannotBeEmpty: 'Điện thoại không được để trống.',
  WeighingAddressCannotBeEmpty: 'Địa chỉ không được để trống.',
  NotifierCodeCannotBeEmpty: 'Mã doanh nghiệp không được để trống.',
  ContactNotifierCannotBeBlank: 'Thông báo liên lạc không được để trống.',
  ImportTallyInformation: 'Nhập thông tin kiểm kê',
  PTImport: 'Nhập PT',
  SelectTime: 'Chọn thời gian',
  CaseNoSealNo: 'Số hộp - Số niêm phong',
  CopySmallTicketCost: 'Chi phí sao chép hóa đơn nhỏ',
  PleaseCostToBeCopied: 'Vui lòng chọn chi phí để sao chép.',
  CrossTenantDelegationHistory: 'Bản ghi trạng thái lịch sử ủy quyền chéo',
  Operator: 'Tuyển dụng',
  OperationTime: 'Thời gian làm việc',
  DelegationStatusHistory: 'Lịch sử trạng thái ủy quyền',
  GeneratePrimaryDocNo: 'Tạo đơn vị chính',
  PleasePrimaryOrderNumberRule: 'Vui lòng chọn quy tắc đơn chính',
  PleaseCodeOfTheNo: 'Vui lòng chọn mã dịch vụ cho đơn vị chính',
  SendOnlineManifestInvitationEmail: 'Online Manifest Thư mời Gửi',
  PleaseConfirmEmailAddress: 'Vui lòng xác nhận địa chỉ email:',
  ShippingPreConfigurationInformationManifest: 'Đăng ký vận tải biển Extreme Edition - Thông tin bổ sung - Thư mời trực tuyến',
  TheSentToTheIt: 'Liên kết mời đã được gửi đến hòm thư, xin chú ý kiểm tra và nhận!',
  TotalCustomsNo: 'Tổng số đơn hàng',
  TotalNumberOfPieces: 'Tổng số mảnh',
  TotalGrossWeight: 'Tổng trọng lượng',
  TotalVolume: 'Tổng khối lượng',
  CustomsNoNotImported: 'Không nhập số đơn đóng:',
  ImportDate: 'Ngày nhập',
  ImportUser: 'Nhập người dùng',
  SendUser: 'Gửi người dùng',
  ManifestImportUser: 'Bản kê khai nhập người dùng',
  SendTag: 'Gửi thẻ',
  SubtotalOfCustomsOrderNo: 'Tắt số phụ',
  ConfirmToVoid: 'Có xác nhận hủy bỏ hay không?',
  MBNOCannotBeEmpty: 'MB/L Không thể để trống!',
  ShipNameCannotBeEmpty: 'Tên tàu không được để trống!',
  EnglishShipNameCannotBeEmpty: 'Tên tàu bằng tiếng Anh không được để trống',
  VoyageCannotBeEmpty: 'Chuyến bay không thể trống rỗng!',
  ShippingCompanyCannotBeEmpty: 'Công ty tàu không thể để trống!',
  ShippingAgentCannotBeEmpty: 'Người lái tàu không thể để trống!',
  DestinationPortCannotBeEmpty: 'Cảng đích không thể trống rỗng!',
  GoodsTypeCannotBeEmpty: 'Loại hàng hóa không được để trống!',
  TransportationTermsCannotBeBlank: 'Điều khoản vận chuyển không được để trống!',
  FreightTermsCannotBeBlank: 'Điều khoản vận chuyển không thể để trống!',
  BillTypeCannotBeEmpty: 'Loại B/L không được để trống!',
  PaymentPlaceCannotBeEmpty: 'Địa điểm thanh toán không được để trống!',
  MattersNeedingAttention: 'Lưu ý',
  DontRemindMeAgain: 'Lần sau đừng nhắc nữa.',
  CloseSpace: 'Đóng cửa',
  TheBeenSentToSending: 'Bản kê khai số đóng giữa 【{0}】 đã được gửi EDI, bạn có tiếp tục gửi không?',
  SelectToSendPreManifest: 'Chọn Gửi kênh kê khai trước',
  SelectCorrectConfiguredManifestChannel: 'Chọn Correct Pre-fit Manifest Channel',
  SelectDeleteConfiguredManifestChannel: 'Chọn Remove Pre-fit Manifest Channel',
  ThePleaseRefreshTheAgain: 'Làm sạch đối tượng manifest trống, vui lòng thử lại sau khi làm mới trang',
  CustomsClearanceNo: 'Số đơn hàng',
  ShippingCompanyOperation: 'Hoạt động của công ty tàu',
  CustomsRestAssured: 'Hải quan yên tâm',
  PlanType: 'Loại chương trình',
  AcceptanceTime: 'Thời gian thụ lý',
  ScheduledStartTime: 'Thời gian bắt đầu',
  PlannedEndTime: 'Thời gian kết thúc dự kiến',
  DepartureTime2: 'Thời gian mở cửa:',
  PortCutOffTime: 'Thời gian chặn cảng:',
  ActualBerthingTimeColon: 'Thời gian neo đậu thực tế:',
  ActualDepartureTimeColon: 'Thời gian rời bến thực tế:',
  ClickToViewTheTrailer: 'Click để xem trailer',
  DisplayPortArea: 'Dữ liệu sau đây là dữ liệu của Cảng/Công ty tàu',
  DetailedData: 'Dữ liệu chi tiết',
  manualPrompt: 'Orange Data: Dịch vụ dữ liệu',
  thirdPartyPrompt: 'Dữ liệu màu xanh nhạt: Nhập thủ công',
  promptNo: 'Dữ liệu màu xám: Không có dữ liệu',
  promptNoData: 'KoCD',
  ArrivalReportStatus: 'Báo cáo tình trạng giao hàng',
  CustomsClearanceSheetStatus: 'Trạng thái đơn hải quan',
  PlanDetails: 'Chi tiết chương trình',
  PutInTheBox: 'Đã đặt hộp',
  EmptyBox: 'Hộp nâng rỗng',
  Arrival: 'Đến cảng',
  EstimatedCYOpening: 'Dự kiến mở cảng',
  PortDocCutOff: 'Cảng chặn',
  ActualBerthing: 'Thực tế neo đậu',
  ActualDeparture: 'Thực tế lái thuyền',
  customsClearance: 'Hải quan phát hành',
  DockRelease: 'Bến tàu thả',
  CancelCustomsClearance: 'Hủy bỏ biển',
  CancelDockRelease: 'Hủy đặt mã',
  AllocateVehiclesToTransportSth: 'Tải',
  Sail: 'Trang chủ',
  Departure: 'Khởi hành',
  Pickup: 'Nâng trọng lượng',
  BusinessFunction: 'Chức năng kinh doanh',
  ClickTheButton: 'Nhấn nút',
  ReturnAddress: 'Địa chỉ hộp trả lại',
  DepartureTime3: 'Thời gian khởi hành',
  ArrivalWharf: 'Đến bến cảng',
  departureTime: 'Thời gian xuất cảng',
  StowageTime: 'Thời gian tải',
  AbnormalCause: 'Nguyên nhân bất thường',
  StackingTime: 'Thời gian mã hóa',
  StackingState: 'Trạng thái mã hóa',
  SeaReleaseTime: 'biển thời gian',
  SeaReleaseDescription: 'Description',
  SeaReleaseState: 'Trạng thái thả biển',
  arrivalTime: 'Thời gian đến',
  TrailerFollow: 'Trailer đi theo',
  SuitcaseLocation: 'Địa điểm hành lý',
  BoxReleaseTime: 'Thời gian đặt hộp',
  EstimatedPickUpPoint: 'Điểm hành lý dự kiến',
  Wharf: 'Bến cảng',
  NameNumberOfImportedVessels: 'Tên tàu nhập khẩu',
  FieldBoxPosition: 'Vị trí hộp trường',
  NameNumberOfExportVessel: 'Tên tàu xuất khẩu',
  containerWeight: 'Trọng lượng thùng hàng',
  VGMWharfWeighing: 'VGM Dock cân',
  ContainerHolder: 'Người giữ hộp (chỉ có cảng Thượng Hải)',
  LeadSeal: 'Số niêm phong chì',
  TransshipmentPort: 'Cảng trung chuyển',
  VGMMessageReceiving: 'Nhận thông báo VGM',
  ApproachMode: 'Cách tiếp cận',
  ArrivalMessageTime: 'Thời gian giao hàng',
  AppearanceMode: 'Cách xuất hiện',
  ReeferTemperatureRequired: 'Nhiệt độ kho lạnh',
  ReceivedTheReleaseTime: 'Đã nhận. Thời gian thả.',
  NationalInspectionRelease: 'Kiểm tra nhà nước.',
  OverrunCode: 'Mã quá hạn',
  WharfStowage: 'Tải bến cảng',
  EmptyContainerRelease: 'Name',
  Front: 'Trước',
  After: 'Sau',
  SuperLong: 'Siêu dài',
  FlowTo: 'Dòng chảy',
  Left: 'Trái',
  Right: 'Phải',
  UltraWide: 'Siêu rộng',
  MaritimeReleaseException: 'Hàng hải bất thường',
  SuperHigh: 'Siêu cao',
  QuantityOfBoxesAndPieces: 'Số lượng hộp:',
  GreaterActualNumberOfPieces: 'Lớn hơn số lượng thực tế:',
  BoxWeight: 'Trọng lượng hộp:',
  GreaterThanActualWeight: 'Lớn hơn trọng lượng thực tế:',
  BoxVolume: 'Khối lượng hộp:',
  LargerThanActualVolume: 'Lớn hơn khối lượng thực tế:',
  JobNoColon: 'Số công việc:',
  AddSpellCustomsOrderNo: 'Thêm số đánh vần',
  PleaseForAddingAndForm: 'Vui lòng chọn quy tắc cộng số',
  PleaseSelectSuffixSeparator: 'Vui lòng chọn dấu phân cách hậu tố',
  PleaseCustomsDeclarationNoSpelled: 'Vui lòng nhập số lượng đơn đặt hàng cần đánh vần',
  DirectToCanada: 'Trực tiếp đến Canada',
  ToInlandWarehouse: 'Đến kho nội địa',
  TransitClearancePullToStates: 'Quá cảnh ở Canada, không thông quan, kéo đến Hoa Kỳ',
  TheThroughTheUnitedStates: 'Hàng hóa đi Mỹ',
  PleaseSelectAnAccount: 'Vui lòng chọn tài khoản',
  PleaseOfYourCurrentFirst: 'Hãy bắt đầu bằng cách duy trì mã của bộ phận hiện tại của bạn!',
  ItServiceProviderOfHouse: 'Đã trở thành"Trang chủ"Dịch vụ',
  YouHisPartnerAndService: 'Bạn có thể đăng ký trực tuyến để trở thành đối tác của anh ấy và tận hưởng dịch vụ đặt hàng trực tuyến.',
  PleaseSelectTheEntrustingCompany: 'Vui lòng chọn đơn vị ủy thác!',
  PleaseSelectDestinationAgent: 'Vui lòng chọn đại lý cảng đích!',
  UncheckedSmallTicket: 'Vé nhỏ không được đánh dấu',
  CustomerInformation: 'Thông tin khách hàng',
  CodeCannotBeEmpty: 'Mã không được để trống.',
  TheNameCannotBeEmpty: 'Tên không được để trống.',
  CertificateTypeCannotBeBlank: 'Loại giấy tờ không được để trống.',
  IDNumberCannotBeEmpty: 'Số giấy tờ không được để trống.',
  AddressCannotBeEmpty: 'Địa chỉ không được để trống.',
  CityCannotBeEmpty: 'Thành phố không thể trống rỗng.',
  CountryCannotBeEmpty: 'Đất nước không thể trống rỗng.',
  ThisSuccessfullyInsuredRepeatedAllowed: 'Việc kinh doanh vé này đã được bảo hiểm thành công và không được phép lặp lại',
  Seller: 'Người bán',
  Manufacturer: 'Nhà sản xuất',
  Consolidator: 'Bộ sưu tập',
  OriginalBookingParty: 'Bên đặt hàng ban đầu',
  GoodsReceiver: 'Người nhận hàng',
  PackingPoint: 'Điểm đóng gói',
  Importer: 'Nhập khẩu',
  AMSNoCannotBeBlank: 'Số đơn vị AMS không thể để trống.',
  SCACCompanyCannotBeEmpty: 'Công ty tàu SCAC không thể để trống.',
  TheDischargeCannotBeEmpty: 'Cảng hàng không được để trống.',
  TheDeliveryCountryCannotBeEmpty: 'Đất nước giao hàng không được để trống.',
  TheDeliveryCannotBeEmpty: 'Đất giao hàng không được để trống.',
  CorrectionOfBillOfLading: 'Sửa vận đơn',
  OriginalBillOfLading: 'B/L gốc',
  TheBillOfLadingEmpty: 'Nơi vận chuyển B/L không thể trống',
  SailingDateEmpty: 'Ngày khởi hành không được để trống',
  TransceiverSelection: 'Lựa chọn Telephone',
  YouServiceOfTheManifest: 'Các vấn đề về danh sách hàng dự phòng có thể bấm vào biểu tượng, tư vấn dịch vụ khách hàng của Hải quản gia.',
  OriginalCleaningManifest: 'Bản kê khai làm sạch gốc',
  Correction1: 'Sửa 1',
  CorrectCleaningManifest: 'Sửa bản kê khai sạch',
  SendPreConfiguredManifest: 'Gửi bản kê khai trước',
  CorrectionOfPreAllocationManifest: 'Sửa bản kê khai trước',
  DeletePreConfiguredManifest: 'Loại bỏ bản kê khai trước',
  CancelPreConfiguredManifest: 'Hủy bỏ bản kê khai trước',
  OriginalPreAllocatedManifest: 'Bản kê khai trước gốc',
  CleanManifestAPI: 'Làm sạch Manifest API',
  OriginalVGM: 'VGM gốc',
  HscodeConfigurationInformationCannotEmpty: 'HSCode của thông tin cài sẵn không thể để trống.',
  HscodeInformationMustBeDigits: 'HSCode của thông tin cần có 6 bit.',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: 'Vui lòng đánh dấu thông tin hàng hóa mà bạn muốn sửa đổi bản kê khai',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: 'Thông tin bạn chọn không thay đổi, vui lòng xác nhận',
  PleaseSelectAllSeaHouseUpdateData: 'Bạn thay đổi nội dung mô-đun 【Thông tin cơ bản về Manifest】&【Thông tin vận chuyển của khách hàng】 và cần chọn tất cả các thông tin đã gửi để gửi cùng nhau.',
  SendingSucceeded: 'Gửi thành công!',
  TheTheReceiptLogInformation: 'Bản kê khai gốc đã được gửi, nhấp vào nhật ký nhận lại để xem thông tin nhận lại bản kê khai.',
  UpdateSucceeded: 'Update thành công!',
  PleaseSuccessfullyIfNotFirst: 'Vui lòng xác nhận rằng bản kê khai gốc đã được gửi thành công hay chưa, nếu không, vui lòng gửi bản kê khai gốc trước.',
  DeleteSucceeded: 'Xóa thành công!',
  WseModifyReasonNotEmpty: 'Vui lòng chọn lý do thay đổi',
  WseModifyRemarkNotEmpty: 'Xin hãy bổ sung thêm mô tả.',
  WseDeleteReasonNotEmpty: 'Vui lòng chọn lý do xóa',
  WseDeleteRemarkNotEmpty: 'Xin vui lòng thêm mô tả',
  BrandNew: 'Mới',
  SecondHand: 'Sử dụng',
  Unknown: 'Không rõ',
  ReImportAfterModification: 'Có thể nhập lại sau khi sửa đổi',
  FailedToDownloadData: 'Tải xuống dữ liệu thất bại',
  ClickVehiclePositioningAndTrack: 'Nhấn vào nút để truy vấn vị trí xe và quỹ đạo lái xe.',
  VehiclePositioningTrack: 'Đường mòn định vị xe',
  IfToTheCurrentIt: 'Tình trạng chi phí phải trả của công ty vận tải hiện tại đã thay đổi, (đã xóa/chỉnh sửa) sẽ không còn được đồng bộ hóa với thẻ chi phí, bạn có tiếp tục không?',
  VehicleTrajectory: 'Đường đua xe',
  DistributionCustomsNo: 'Số đơn đặt hàng',
  BookingReceipt: 'Đặt phòng.',
  InMailOfThePrevail: 'Giai đoạn kiểm tra nội bộ, tùy thuộc vào thư của chủ tàu',
  CorrectBooking: 'Sửa chữa đặt phòng',
  OriginalBooking: 'Đặt phòng ban đầu',
  TheBeVoidedAndThis: 'Số chính đã được tạo, việc tạo lại sẽ hủy bỏ số gốc và tạo ra số mới, bạn có xác nhận rằng bạn muốn làm điều đó không?',
  BasicTab: 'Thẻ trang cơ bản',
  TheHairBodyCannotEmpty: 'Phần lông thực tế không thể rỗng',
  PackageCannotBeEmpty: 'Bao bì không thể rỗng',
  MBLTab: 'Thẻ trang MBL',
  ShipperCannotBeBlank: 'Người gửi hàng không thể để trống',
  ConsigneeCannotBeEmpty: 'Người nhận hàng không được để trống',
  NotifierCannotBeBlank: 'Thông báo không thể để trống',
  TheEmptyPleaseRefreshAgain: 'Bản kê khai trước trống, vui lòng thử lại sau khi làm mới trang',
  TheIsEmptyPleaseAgain: 'Đối tượng sửa bản kê khai được phân phối trước trống, vui lòng thử lại sau khi làm mới trang',
  VGMRefreshThePageAgain: 'Đối tượng VGM rỗng, hãy thử lại sau khi làm mới trang',
  TheCleaningIsEmptyPleaseAgain: 'Bản kê khai sạch được lắp sẵn đối tượng trống, vui lòng thử lại sau khi làm mới trang',
  TheNoCannotBeBlank: 'Số đóng không được để trống.',
  MBLNoCannotEmpty: 'MB/L không thể để trống.',
  NewGoods: 'Sản phẩm mới',
  DeleteGoods: 'Xóa hàng hóa',
  TotalOfThisBox: 'Hộp này tổng cộng:',
  DataComparison: 'So sánh dữ liệu',
  UpdatePortAreaData: 'Cập nhật dữ liệu cảng',
  NoPortDataHasBeenObtained: 'Chưa có thông tin về cảng',
  SynchronizePortData: 'Đồng bộ hóa dữ liệu cảng',
  NotVerified: 'Chưa kiểm tra',
  SystemVerification: 'Kiểm tra hệ thống phù hợp',
  ManualVerification: 'Kiểm tra thủ công phù hợp',
  ToBeConfirmed2: 'Để được xác nhận',
  TheInThePortOpened: 'Chưa mở dịch vụ chuyển phát dữ liệu cảng',
  TheDirectlyImportTheCall: 'Dịch vụ dữ liệu hàng hóa cảng có thể giúp bạn kiểm tra xem thông tin hàng hóa cảng có chính xác hay không, cũng có thể trực tiếp nhập dữ liệu hàng hóa cảng vào nghiệp vụ. Nếu cần mở, hãy liên lạc với dịch vụ khách hàng trực tuyến hoặc gọi điện thoại liên lạc:',
  HarbourNotInServiceNoOpen: 'Cảng biển tương ứng tạm thời chưa mở dịch vụ so sánh dữ liệu, không thể cung cấp chức năng so sánh dữ liệu. Hiện nay hỗ trợ các cảng biển khác tiến hành so sánh dữ liệu, nếu cần mở cửa xin liên hệ với dịch vụ khách hàng trực tuyến hoặc gọi điện thoại liên lạc:',
  HarbourInServiceNoOpen: 'Dịch vụ dữ liệu hàng hóa Hồng Công có thể giúp bạn kiểm tra xem thông tin hàng hóa Hồng Công có chính xác hay không, cũng có thể trực tiếp nhập dữ liệu hàng hóa Hồng Công, thực hiện dễ dàng nhập dữ liệu. Nếu cần mở, hãy liên lạc với dịch vụ khách hàng trực tuyến hoặc gọi điện thoại liên lạc:',
  HarbourNotInServiceOpen: 'Hiện nay không hỗ trợ việc đưa và so sánh dữ liệu của khu vực cảng này.',
  ThisActionCannotBeUndone: 'Hành động này không thể hủy bỏ',
  DoYouWantToContinue: 'Ngài còn muốn tiếp tục không?',
  ItPortDataAndVerified: 'Không khớp với dữ liệu cảng, không kiểm tra được.',
  TheNotContainTheData: 'Dữ liệu hiện tại không chứa dữ liệu cảng',
  PortInformationVerification: 'Kiểm tra thông tin cảng',
  SIsMissingAndVerified: 'S/O NO Không thể kiểm tra',
  PleaseNoForTheFirst: 'Xin vui lòng điền S/O NO cho tờ khai hiện tại.',
  TheOverwriteTheCurrentData: 'Chức năng ghi đè lên dữ liệu hiện tại',
  OperationSucceeded: 'Chiến dịch thành công!',
  OrderNumber: 'Số đơn đặt hàng',
  TotalPacking: 'Tổng số gói',
  ContainerList: 'Danh sách container',
  UpdateStatus: 'Cập nhật trạng thái',
  ClearThePackingInformation: 'Xóa thông tin đóng gói',
  ExportThePackingPlan: 'Xuất lịch đóng gói',
  checkGoods: 'Xem sản phẩm',
  checkPackages: 'Xem bao bì',
  NumberOfPackages: 'Số lượng gói',
  AskForPositionTime: 'Yêu cầu thời gian vào kho',
  EstimatedPositionTime: 'Thời gian dự kiến vào kho',
  CheckTheDetailsOfTheGoods: 'Xem chi tiết hàng hóa',
  UnableToRemove: 'Không thể tháo rời, container bị khóa hoặc đóng gói',
  removeOrderTips: 'Bạn có chắc chắn để loại bỏ lệnh này?',
  removeOrder: 'Xóa đơn hàng',
  PackageNo: 'Số gói',
  NumberOfPackagesAnticipateOrReality: 'Số gói (pre/real)',
  Code4: 'Mã hóa',
  LengthAnticipateOrReality: 'Dài (tiền/thực)',
  WidthAnticipateOrReality: 'Rộng (trước/thực)',
  HighAnticipateOrReality: 'Cao (tiền/thực)',
  UnitVolumeAnticipateOrReality: 'Khối lượng đơn vị (pre/real)',
  GrossWeightAnticipateOrReality: 'Tổng trọng lượng đơn (pre/real)',
  Considerations: 'Lưu ý',
  Anufacturer: 'Sản xuất',
  EstimateLoadingTime: 'Dự kiến thời gian tốt.',
  ActualWarehousingTime: 'Thời gian thực tế vào kho',
  NO: 'Số',
  NoCorrespondingFile: 'Không lấy được tập tin tương ứng!',
  ChooseState: 'Chọn trạng thái',
  ActualPackingTime: 'Thời gian đóng gói thực tế',
  ChooseActualPackingTime: 'Vui lòng chọn thời gian đóng gói thực tế',
  updateContainerStateTip: 'Cập nhật không thành công và có một lệnh mở cho hộp',
  firstCleanedContainer: 'Vui lòng chọn container cần xóa trước',
  containerBeCleared: 'Container không thể dọn sạch',
  removeSelectedContainer: 'Bạn có chắc chắn để loại bỏ tất cả các đơn đặt hàng theo container đã chọn?',
  ClearContainerInformation: 'Xóa thông tin container',
  goodsOperateTips: 'Vui lòng lưu thông tin số đơn trước khi vận hành hàng hóa',
  removeGoodsTips: 'Vui lòng chọn sản phẩm cần loại bỏ',
  NumberOfCartons: 'Số thùng carton',
  importGoodsTips: 'Vui lòng chọn sản phẩm để nhập khẩu',
  ChooseGoods: 'Chọn hàng',
  RemoveTheGoods: 'Xóa đơn hàng',
  Source: 'Nguồn',
  PreCommitUser: 'Giao nộp trước',
  PreCommitDate: 'Thời gian nộp trước',
  SubmissionDate: 'Thời gian gửi',
  CommitUser: 'Tác giả',
  RelatedSubmissionDate: 'Thời gian giao dịch liên kết',
  RelatedCommitUser: 'Tác giả kinh doanh liên kết đến và đi',
  RelatedPreCommitUser: 'Giao dịch dự phòng nghiệp vụ liên quan',
  RelatedPreCommitDate: 'Thời gian nộp trước cho các doanh nghiệp liên kết đến và đi',
  FcAuditDate: 'Thời gian xét duyệt',
  FcAuditUser: 'Đánh giá',
  LockJobDate: 'Khóa thời gian đơn',
  LockJobUser: 'Khóa đơn',
  PrintListTip: 'Vui lòng chọn một danh sách bạn muốn in',
  CargoActArrivalDatePacking: 'Ngày đóng gói thực tế',
  releaseStowageState: 'Trạng thái tải thả',
  ChangeHistory: 'Lịch sử thay đổi',
  SynchronizationInformation: 'Thông tin đồng bộ',
  SyncChargeToEas: 'Đồng bộ hóa EAS',
  NoEasCharge: 'Không có chi phí để đồng bộ hóa với EAS.',
  CheckEasChargeState: 'Không có phí để đồng bộ hóa với EAS, vui lòng kiểm tra trạng thái phí EAS.',
  CheckBusinessUuid: 'Business UUID không thể để trống!',
  KingDeeChargePush: 'Chi phí bướm vàng đẩy',
  ExternalSerialNumber: 'Số tài liệu',
  EmptyCabinetDate: 'Thời gian vào nhà máy của tủ trống',
  RealArrivalsDate: 'Thời gian nhập cảnh thực tế',
  ActualLiftingDate: 'Thời gian nâng thực tế',
  DeliveryDoneDate: 'Thời gian hoàn thành giao hàng',
  CleaningDate: 'Thời gian dọn dẹp',
  ReturnBoxDate: 'Thời gian hoàn trả hộp',
  DestinationDeliveryTime: 'Thời gian giao hàng tại cảng đích',
  DestinationReturnTime: 'Thời gian trống tại cảng đích',
  PortDischargeTime: 'Thời gian dỡ hàng thực tế',
  EstimatedPortDischargeTime: 'Thời gian xả dự kiến',
  UnloadingTime: 'Thời gian dỡ hàng',
  LiftingTime: 'Thời gian nâng trọng lượng',
  RailwayDepartureTime: 'Thời gian vận chuyển đường sắt thực tế',
  EstimatedRailwayDepartureTime: 'Thời gian vận chuyển đường sắt dự kiến',
  RailwayDischargeTime: 'Thời gian dỡ hàng đường sắt thực tế',
  EstimatedRailwayDischargeTime: 'Dự kiến thời gian dỡ hàng đường sắt',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: 'Thời gian dự kiến đến nơi giao hàng',
  Arrived: 'Giới thiệu',
  Acquire: 'Thanh toán',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: 'Thời gian giao hàng thực tế',
  EstimatedCustomsReleaseTime: 'Thời gian đóng cửa dự kiến',
  EstimatedPickupTime: 'Thời gian nâng dự kiến',
  ActualPickUpTime: 'Thời gian nâng thực tế',
  EstimatedDeliveryToWarehouseTime: 'Thời gian giao hàng dự kiến',
  EstimatedReturnTime: 'Thời gian còn trống.',
  ActualReturnTime: 'Thời gian còn trống.',
  PODDeliveryInformation: 'Cảng đích Gửi thông tin',
  ActualDeliveryToWarehouseTime: 'Thời gian giao hàng thực tế',
  EstimatedDeliveryToCustomersWarehouseTime: 'Thời gian giao hàng dự kiến',
  ActualDeliveryToCustomersWarehouseTime: 'Thời gian giao hàng thực tế',
  PickupMessage: 'CY-DOOR， Kho Unboxing từ cảng đến kho FCL/LCL',
  DeliveryToWarehouseMessage: 'Thời gian gửi đến kho cảng đích sau khi nâng trọng lượng',
  EstimatedDeliveryToCustomersWarehouseMessage: 'Từ kho LCL đến kho của khách hàng (B2B)/Giao hàng km cuối cùng từ kho vận chuyển (B2C)',
  ActualDeliveryToCustomersWarehouseMessage: 'Từ kho LCL đến kho của khách hàng/Giao hàng km cuối cùng từ kho vận chuyển',
  CargoReadyDate: 'Hàng tốt thời gian',
  BackUpWarehouse: 'Vị trí trước',
  PleaseSelectBackUpWarehouse: 'Chọn 【Vị trí trước】',
  HeavyContainerMobilization: 'Hộp nặng tiếp cận',
  checkLines100: 'Số dòng được chọn không được vượt quá 100 dòng!',
  estimatedDeliveryTime: 'Thời gian xuất kho dự kiến',
  estimatedArrivalTime: 'Thời gian dự kiến đến cảng',
  EmailGroup: 'Nhóm thư',
  EmailTemplate: 'Mẫu thư',
  CargoAllocationList: 'Danh sách cabin',
  CheckApproved: 'Vui lòng đánh dấu doanh nghiệp để xem xét!',
  StateVerifyingReview: 'Kiểm toán (To be reviewed)',
  VotesSubmission: 'Vé có được đệ trình không?',
  BatchSubmitCheckOperate: 'Chỉ có thể đệ trình danh sách đang thao tác với số lượng lớn!',
  BatchSubmitCheckPre: 'Chỉ có thể đệ trình danh sách đệ trình trước với số lượng lớn!',
  CancelFormalHblTips: 'Đã tồn tại hình thức phân phối, xin vui lòng bỏ chọn sau khi xóa!',
  BatchSend: 'Gửi hàng loạt',
  BatchSendCheck: 'Vui lòng đánh dấu vào phí EAS cần gửi',
  BatchSendTip: 'Chỉ có thể đồng bộ hóa các khoản phí chưa được xem xét, vui lòng kiểm tra trạng thái phí',
  PleaseSelectRemovedContainer: 'Vui lòng chọn thông tin đóng gói cần xóa!',
  PleaseRemovedSplitOrder: 'Xin vui lòng loại bỏ các hình thức liên quan đến việc hủy bỏ hiện tại!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: 'Có những ngoại lệ sau đây đối với dữ liệu đã nhập, vui lòng kiểm tra dữ liệu trong biểu mẫu',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: 'Không có vé chính liên kết, không thể nhập dữ liệu hộp',
  ImportContainerInformation: 'Nhập thông tin hàng hóa hộp?',
  SecondLoadingTime: 'Tàu trung chuyển',
  SecondDepartureTime: 'Trung chuyển khởi hành',
  SecondArrivalTime: 'Trung chuyển đến cảng',
  SecondUnloadingTime: 'Tải trung chuyển',
  TransferModeAtTransferPoint: 'Phương thức vận chuyển điểm trung chuyển',
  DispatchVehiclesAtDestination: 'Gửi xe đến cảng đích',
  PortOfDestinationServices: 'Dịch vụ cảng đích',
  Manifest: 'Bản kê khai trước',
  Other: 'Khác',
  Temperature: 'Nhiệt độ',
  OpenVentilation: 'Mở thông gió',
  VentilationQuantity: 'Khối lượng thông gió',
  VentilationUnit: 'đơn vị thông gió',
  FlashPointUnit: 'Flashpoint đơn vị',
  HazardForm: 'Hàng nguy hiểm',
  AutoSpecialGoods: 'tự động nhận được thông tin về hàng hóa đặc biệt',
  HaveMaintainedSpecialInfo: 'phát hiện được rằng bạn đã duy trì thông tin về hàng hóa đặc biệt, có tự động nhận được thông tin về đóng hộp dựa trên tên tiếng anh và mã hs không?',
  PackingInformation: 'thông tin đã được đóng gói.',
  NoPackingInformation: 'không có thông tin đóng gói.',
  Humidity: 'Độ ẩm%',
  OverSize: 'Siêu kích thước',
  ZYQHG: 'Trái/Phải/Trước/Sau/Tuyệt vời (CM)',
  PortOfDestinationCustomsClearance: 'Thông quan cảng đích',
  DestPortCustomsClearanceInfo: 'Thông tin thông quan',
  PleaseSelectData: 'Vui lòng chọn dữ liệu đã xác định',
  PlateNumberAndBillLadingNumberCannotEmpty: 'Biển số xe và số vận đơn không được để trống',
  LineXQuantityMustGreaterThanZero: 'Số lượng phần của dòng {rowNum} phải lớn hơn 0',
  LineXQuantityExceedsMaxValue: 'Dòng {rowNum} số phần {quantity} vượt quá giá trị tối đa {maxValue}',
  LineXWeightMustGreaterThanZero: 'Tổng trọng lượng của hàng {rowNum} phải lớn hơn 0',
  LineXWeightExceedsMaxValue: 'Tổng trọng lượng của dòng {rowNum} vượt quá giá trị tối đa {maxValue}',
  LineXCubageMustGreaterThanZero: 'Thể tích dòng {rowNum} phải lớn hơn 0',
  LineXCubageExceedsMaxValue: 'Dòng {rowNum} thể tích {cubage} vượt quá giá trị tối đa {maxValue}',
  HasExport: 'Đã xuất',
  DelegatedAssociatedBusinessStatus: 'Tình trạng kinh doanh liên kết ủy thác',
  TransactionRelatedBusinessStatus: 'Tình trạng kinh doanh liên kết',
  SecondarySynchronization: 'Đồng bộ hóa bậc hai',
  NumberOfCustomsOrders: 'Số ít',
  CustomerClosingTime: 'Khách hàng mất thời gian',
  AddToMainTicket: 'Có nên tham gia mainsticket hay không',
  CustomsDeclarationRemark: 'Ghi chú khai hải quan',
  OperationGuide: 'Hướng dẫn vận hành',
  ServiceInformation: 'Hướng dẫn dịch vụ',
  ScopeServices: 'Phạm vi dịch vụ',
  DeletionGuide: 'Hướng dẫn sửa đổi cảng Thượng Hải',
  BusinessData: 'Thông tin kinh doanh cảng Thượng Hải',
  SecondVesselInformation: 'Thông tin hai chiều',
  vesselText: 'Thông qua dữ liệu hàng hóa trong cảng lấy được tên tàu: ${1}, thời gian: ${2}, không phù hợp với tên tàu: ${3}, thời gian: ${4}, có ghi vào thời gian tàu lấy được bằng vận đơn và làm trống dữ liệu thời gian tàu đã lấy không?',
  textiles: 'Trang chủ',
  nonTextiles: 'Không dệt',
  importEmpty: 'Nhập và làm trống',
  importNotEmpty: 'Nhập không rỗng',
  ignore: 'Bỏ qua',
  empty: 'Trống rỗng',
  salveNoDcToKeepMaster: 'Đơn vị ủy thác này không duy trì nhân viên chứng từ tương ứng, có giữ lại nhân viên chứng từ chính hay không?',
  CustomersCollectByBubble: 'Khách hàng thu phí bong bóng',
  CollectionBySupplier: 'Nhà cung cấp tính phí bọt',
  Slac: 'Số lượng lô hàng nhỏ',
  BookingShutOut: 'Đặt phòng hoàn tất',
  tip: 'Mẹo',
  ShippingCompanyDialogModifyText: 'Ông đã sửa đổi công ty tàu, có xóa sạch thông tin cảng đến đã có không? Nếu bạn mở dịch vụ theo dõi hàng hóa của Công ty tàu, bạn sẽ đăng ký lại thông tin về cảng biển đặt hàng.',
  ShippingCompanyDialogDeleteText: 'Ông đã xóa công ty tàu, có xóa sạch thông tin về cảng đã có không?',
  emptyDestinationInformation: 'Trống rỗng',
  noEmptyDestinationInformation: 'Không trống',
  BatchModifyBusiness: 'Kinh doanh sửa đổi hàng loạt',
  DataAdjustment: 'Điều chỉnh dữ liệu',
  OriginalData: 'Dữ liệu gốc:',
  AfterAdjustment: 'Sau khi điều chỉnh:',
  inputContainerNo: 'Vui lòng điền số hộp',
  inputSealNo: 'Vui lòng điền số niêm phong',
  BoxType: 'Loại hộp Loại hộp',
  BusinessPeopleType: 'Nhân viên kinh doanh',
  clearConfirm: 'Đã đánh dấu Business 【{0}】 【{1}】 Dữ liệu sẽ bị xóa, có xác nhận không?',
  clearCategoryConfirm: 'Đánh dấu Business 【{0}】 Dữ liệu sẽ bị xóa, có xác nhận không?',
  changeTwoConfirm: 'Đã đánh dấu Business 【{0}】 【{1}】 Dữ liệu sẽ được thay thế, có xác nhận không?',
  changeOneConfirm: 'Chọn Business 【{0}】 Dữ liệu sẽ được thay thế, có xác nhận không?',
  hasRefreshCharge: 'Đại lý đặt chỗ đã có chi phí, có làm mới chi phí không?',
  SuccessTip: 'Thành công {0} mục',
  hasOneAtleast: 'Vui lòng thử lại sau khi chọn ít nhất một tùy chọn!',
  successTipAlreadyNotEditCharge: 'Thành công {0} mục, <br/> giải thích: <br/> {1} đã tồn tại chi phí không thể chỉnh sửa, vui lòng xử lý kịp thời!',
  hasOneNoAtleast: 'Vui lòng thử lại sau khi điền ít nhất một trường!',
  maxSelectBusiness: 'Đánh dấu nhiều hơn {0} mục kinh doanh, vui lòng thử lại sau khi chọn lại!',
  requireAllSelect: 'Vui lòng thử lại sau khi chọn {0} và {1} đã sửa đổi',
  hasOneCategoryAtleast: 'Vui lòng chọn dữ liệu bạn cần viết!',
  adjustedDestinationAgent: 'Nhập đại lý cảng đích đã điều chỉnh!',
  whetherCoverMBLReceiver: 'Dữ liệu đại lý cảng đích đã chọn sẽ bị thay thế. Ghi đè thông tin người nhận MBL bằng thông tin đại lý mới?',
  lclSlavesJobCannotModify: 'Một vé nhỏ không thể sửa đổi trường này！',
  BusinessNotSameOpAndSalesOffice: 'Kinh doanh {0} Chi nhánh hoạt động không phù hợp với chi nhánh bán hàng',
  SuccessfullyClearXPieces: 'Xóa thành công {0} thanh {1} dữ liệu',
  PartSuccessClearXPieces: 'Xóa thành công {0} thanh {1} dữ liệu, không thành công {2} thanh, nguyên nhân thất bại:',
  DataAdjustmentSame: '{0} Dữ liệu nhất quán trước và sau khi điều chỉnh, không có thay đổi nào được thực hiện lần này',
  DataAdjustmentAgainConfirm: 'Đã đánh dấu Doanh nghiệp {0} Dữ liệu sẽ được thay thế, có xác nhận không?',
  SuccessfullyReplacedXPieces: 'Thay thế thành công {0} thanh {1} dữ liệu',
  NotReplacedXPieces: 'Không tìm thấy {0} phù hợp với điều kiện, lần này thay thế 0',
  PartSuccessReplacedXPieces: 'Thay thế thành công {0} thanh {1} dữ liệu, không thành công {2} thanh, nguyên nhân thất bại:',
  BusinessisNotPositiveOperation: 'Kinh doanh không hoạt động',
  BusinessisBlocked: 'Kinh doanh {0} bị khóa',
  BusinessisHblLock: 'Kinh doanh {0}HBL Danh sách khóa',
  BusinessisInvalidLoadType: 'Kinh doanh {0} Loại đánh vần đầy đủ không phải là đánh vần ủy quyền',
  BusinessisContainerExist: 'Doanh nghiệp {0} đã có các loại hộp được điều chỉnh',
  BusinessPicecNotMatch: 'Không có loại hộp tương ứng với dữ liệu gốc',
  BusinessisMblHblContainerExist: 'Kinh doanh {0} Đã tham gia MBL Tháo dỡ Đơn/HBL Tháo dỡ Đơn/Mẫu Đơn',
  BusinessisContainerSealNoExist: 'Doanh nghiệp {0} Số hộp đã điền',
  BusinessisTruckingContainerExist: 'Doanh nghiệp {0} Thông tin liên quan',
  BusinessisDischarginTruckingExist: 'Kinh doanh {0} Đã liên kết Cảng đích',
  BusinessisAmsContainerExist: 'Bản kê khai chống khủng bố liên quan',
  CopyFailedBusinessNumber: 'Một cú nhấp chuột sao chép số doanh nghiệp thất bại',
  PackagingCategoryOfDangerousGoods: 'Danh mục đóng gói hàng nguy hiểm',
  CargoReleaseWay: 'Cách đặt hàng',
  WarehouseLoadingRemarks: 'Lưu ý thiết bị trong kho',
  CheckStatuses: 'Đánh dấu trạng thái:',
  ClearStatuses: 'Xóa đánh dấu:',
  SelectAtLeastOneAdjustment: 'Vui lòng thử lại sau khi chọn ít nhất một điều chỉnh!',
  ClearStateComfirm: 'Đã đánh dấu Doanh nghiệp {0} Trạng thái đánh dấu sẽ bị xóa, bạn có xác nhận không?',
  CheckStateComfirm: 'Đã đánh dấu Doanh nghiệp {0} Trạng thái đánh dấu sẽ được đánh dấu, bạn có xác nhận không?',
  SuccessfullyCancelXPieces: 'Hủy thành công {0} dữ liệu',
  SuccessfullyCheckXPieces: 'Đánh dấu thành công {0} mục dữ liệu',
  PartSuccessClearXThePieces: 'Xóa thành công {0} thanh dữ liệu, không thành công {1} thanh, nguyên nhân thất bại:',
  PartSuccessCheckXThePieces: 'Đánh dấu thành công {0} thanh dữ liệu, không thành công {1} thanh, nguyên nhân thất bại:',
  BusinessisCargoDocLock: 'Kinh doanh {0} Danh sách khóa',
  DataCategoryProcessingFailed: 'Lỗi xử lý danh mục dữ liệu',
  PleaseSelectATemplate: 'Vui lòng chọn mẫu',
  PleaseSelectANode: 'Vui lòng chọn Node',
  PleaseSelectAState: 'Vui lòng chọn trạng thái',
  SuccessModifiedXBusinessState: '{0} Điều khoản kinh doanh đã được sửa đổi thành công',
  SuccessWithdraw: 'Đã rút {0}',
  PleaseSpecificTemplateFilePreview: 'Vui lòng chọn tập tin mẫu cụ thể để xem trước!!!',
  CopyLast: 'Sao chép lần trước',
  WaybillNumberCopy: 'Bản sao số đơn',
  CargoInformation: 'Thông tin hàng hóa',
  BillOfLadingQuantity: 'Nâng số mảnh',
  Packing: 'Đóng gói',
  PleaseChoose: '-- Vui lòng chọn --',
  CustomerType: 'Loại khách hàng',
  HTSCode: 'Số HTS',
  EnglishCommodityName: 'Tên tiếng Anh',
  TransportationInformation: 'Thông tin vận chuyển',
  MBLNumber: 'Số MB/L',
  HBLNumber: 'Số HB/L',
  CCNNumber: 'Số CCN',
  ShipName: 'Tên tàu',
  ShipNumber: 'Số tàu',
  PortArrivalDate: 'Ngày đến cảng',
  CountryOfOrigin: 'Nước xuất xứ',
  BillLadingPlaceOfDispatch: 'Nơi vận chuyển B/L',
  BillLadingPortOfDeparture: 'Cảng khởi hành B/L',
  BillLadingPortOfDischarge: 'Cảng dỡ hàng B/L',
  BillLadingPlaceOfDelivery: 'Nơi giao hàng B/L',
  LastOverseasPort: 'Cảng ngoài khơi cuối cùng',
  FirstPortOfCall: 'Cảng đầu tiên của cuộc gọi',
  SynchronizeHBLInformation: 'Đồng bộ hóa thông tin HBL',
  addHbl: 'Tăng đơn đặt hàng',
  NonVesselCarrierSCAC: 'Hãng hàng không SCAC',
  DeclarationAccount: 'Khai báo tài khoản',
  DeclarationType: 'Loại khai báo',
  DirectToTheUnitedStates: 'Trực tiếp đến Hoa Kỳ',
  ToTheInlandWarehouse: 'Đến kho nội địa',
  TransferClearancePullToStates: 'Quá cảnh ở Canada, không thông quan, kéo đến Hoa Kỳ',
  CargoThroughTheUnitedStates: 'Hàng hóa đi Mỹ',
  ContainerInformation: 'Thông tin đóng gói',
  AddContainerInformation: 'Thêm thông tin đóng hộp',
  RemoveContainerInformation: 'Xóa thông tin đóng gói',
  BoxSpecies: 'Loại hộp',
  BoxHeight: 'Chiều cao hộp',
  ContainerNumber: 'Số hộp',
  SealNumber: 'Số niêm phong',
  CommodityName: 'Danh mục',
  PleaseEnterTheCommodityNameOrHSCode: 'Vui lòng nhập tên hàng hóa hoặc mã HS',
  ShippingCompanyContractNoRequired: 'Số hợp đồng hãng tàu không được để trống',
  ApplicableRoutesNoRequired: 'Tuyến đường áp dụng không được để trống',
  ShippingCompanyNoRequired: 'Công ty vận tải không được để trống',
  ValidityNoRequired: 'Thời hạn hiệu lực không được để trống',
  ShippingCompanyAndBaseDifferent: 'Hãng tàu của hợp đồng này không khớp với thông tin đã nhập trong tab cơ bản. Xác nhận ghi đè?',
  GiveUp: 'Hủy',
  BackFillToRoute: 'Số hợp đồng này có nhiều tuyến đường áp dụng. Vui lòng chọn tuyến đường cần điền lại vào tab cơ bản.',
  MultipleApplicableRoutesDifferent: 'Số hợp đồng này có nhiều tuyến đường áp dụng và đều khác với thông tin đã nhập trong tab cơ bản. Vui lòng chọn tuyến đường cần điền lại vào tab cơ bản.',
  ApplicableRoutesDifferent: 'Tất cả tuyến đường áp dụng của số hợp đồng này đều khác với thông tin trong tab cơ bản. Xác nhận ghi đè?',
  ShippingCompanyDifferent: 'Hãng tàu bạn chọn không khớp với hãng tàu áp dụng của hợp đồng đã chọn. Xác nhận ghi đè?<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: 'Tuyến đường cảng bạn chọn không khớp với tuyến đường áp dụng của hợp đồng đã chọn. Xác nhận ghi đè?<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: 'ETD bạn chọn không phù hợp với thời hạn hiệu lực của hợp đồng. Xác nhận ghi đè?<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: 'Thời hạn hiệu lực của hợp đồng đã chọn không bao gồm ETD. Xác nhận ghi đè?<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: 'Không điền ngược',
  ValidPeriodMessage: 'Thời hạn hiệu lực hợp đồng: {0}',
  ValidPeriodEtdMessage: 'Thời hạn hiệu lực hợp đồng: {0}, ETD: {1}',
  NumberApplicableToShippingCompany: 'Hãng tàu áp dụng của hợp đồng: {0}',
  NumberApplicableToAirline: 'Tuyến đường áp dụng của hợp đồng: {0}',
  PleaseToDeleteTheContract: 'Bạn có chắc chắn muốn xóa {0} số hợp đồng đã chọn? Thao tác này không thể hoàn tác.',
  ScNoIsUsed: 'Số cuộc hẹn này đã được sử dụng và không thể xóa',
  BeginDateNotLessThanEndDate: 'Ngày bắt đầu hiệu lực không thể muộn hơn ngày kết thúc',
  ConfirmEnableTips: 'Sau khi kích hoạt, người dùng có thể chọn số hợp đồng này trong trang chi tiết đơn hàng. Xác nhận kích hoạt?',
  EnableTips: 'Chỉ có thể kích hoạt khi tất cả số hợp đồng đã chọn đang ở trạng thái vô hiệu hóa',
  DisEnableTips: 'Sau khi vô hiệu hóa, số hợp đồng này sẽ không thể được chọn trong chi tiết đơn hàng. Xác nhận vô hiệu hóa?',
  ConfirmDisEnableTips: 'Chỉ có thể vô hiệu hóa khi tất cả số hợp đồng đã chọn đang ở trạng thái kích hoạt',
  ContractRatePropertyRequired: 'Tính chất giá hợp đồng không được để trống',
  NACRequired: 'NAC không được để trống',
  CommodityNameRequired: 'Tên hàng hóa không được để trống',
  ContractNumberRequired: 'Số hợp đồng của hãng tàu đã tồn tại',
  PleaseSelectAirLine: 'Vui lòng chọn tuyến đường (có thể chọn nhiều)',
  PleaseInputNumber: 'Vui lòng nhập số',
  CargoInsuranceQuantityRequired: 'Số lượng bảo hiểm hàng hóa không được để trống',
  CargoInsuranceUnitRequired: 'Đơn vị bảo hiểm hàng hóa không được để trống',
  SendingStatus: 'Trạng thái gửi',
  SendingStatusUpdateTime: 'Gửi thời gian cập nhật trạng thái',
  CancellationStatus: 'Hủy trạng thái',
  Notifier: 'Thông báo',
  SecondNotifier: 'Thông báo thứ hai',
  ShippingAndReceivingInformation: 'Gửi và nhận tin nhắn',
  ShipperName: 'Tên người gửi hàng',
  CompanyTitle: 'Đầu',
  Address: 'Địa chỉ',
  Phone: 'Điện thoại',
  Optional: 'Không bắt buộc',
  ConsigneeName: 'Tên người nhận hàng',
  NotifierName: 'Tên thông báo',
  SecondNotifierName: 'Name',
  BatchModifyDestinationPortInformation: 'Sửa đổi hàng loạt thông tin cảng đích',
  OverseasWarehouseNonAmazonWarehouse: 'Kho trung chuyển ở nước ngoài không phải là kho Amazon',
  SelectedBePositivePleaseSelect: 'Doanh nghiệp đã chọn phải hoạt động tích cực, vui lòng chọn lại!',
  DomesticWarehouse: 'Kho nội địa',
  OverseasWarehouse: 'Kho nước ngoài',
  ContainerNumber2: 'Số hộp:',
  ContainerNumberContainerNoNull: 'Số hộp: containerNoNull',
  Exceeded: 'Đã vượt quá',
  CancelCustomsReturn: 'Hủy bỏ đóng cửa',
  AttachmentContentTooLarge: 'Phụ kiện nội dung quá lớn',
  LockedPleaseContactSupervisorUnlock: 'Đã khóa, không in được, xin hãy liên lạc với cấp trên để mở khóa!',
  FCLProfitPrinting: 'In lợi nhuận FCL',
  LCLProfitPrinting: 'LCL lợi nhuận in',
  DueToPrintOrUnlock: 'Do kiểm soát tín hiệu vượt quá, vé đã bị khóa, sẽ không thể in hoặc EDI, vui lòng liên hệ với cấp trên để mở khóa khi cần thiết!',
  FeeName: 'Tên chi phí',
  BatchFeeScheme: 'Gói cước số lượng lớn',
  NoCostCanBeTranscribed: 'Không có chi phí sao chép.',
  ThisBeenSentEDIAllowed: 'Thông tin về bản kê khai này đã được gửi qua EDI và không được phép xóa.',
  TheVoidedAndCannotAgain: 'Bản kê khai này đã bị hủy bỏ, không thể hủy bỏ lần nữa.',
  ShanghaiManifestShippingCompany: 'Công ty vận tải biển Thượng Hải:',
  NoResultsFound: 'Không tìm thấy kết quả',
  ExportClearanceNewRegulation: 'Quy định mới về xuất khẩu',
  ShanghaiAfterClearanceManifestContinuing: 'Hải quan Thượng Hải số 172 chuyển điều kiện cho hàng, truyền thông tin phóng biển về bến cảng bằng "Danh sách chở hàng", mời khách hàng sau khi hoàn thành khai báo hải quan tự chú ý trạng thái danh sách chở hàng, tình hình bất thường kịp thời liên hệ với dịch vụ khách hàng xác nhận. Đến lúc đó, danh sách khoang dư thừa trong thùng không kịp thời xóa bỏ, hàng rơi không kịp thời, sau khi cho đi thêm vào đánh vần không chuẩn mực, sửa đổi số liệu của danh sách khoang không thành công, đánh vần hỗn hợp, số vận đơn tái sử dụng trong vòng hai năm đều sẽ ảnh hưởng đến việc xếp tàu. Thứ hai, sau khi nhận được thư trả lại bình thường, nếu gặp phải tình huống bất kỳ thư trả trước nào cần sửa đổi, xóa bỏ hoặc tăng thêm thư trả lời, cần liên hệ với người lái trước để xóa thư trả lời sau đó tiếp tục thao tác.',
  YangshanDistrictNovember152021: 'Quận Yangshan Quan: 15 tháng 11 năm 2021',
  WaigaoqiaoDistrictNovember222021: 'Khu vực Outer Harbor: 22 tháng 11 năm 2021',
  GarbageManifest: 'Bản kê khai rác',
  N1YourGoodsAreManifest: '1. Hải quan nghiêm cấm kê khai rác! Theo quy định của hải quan, mỗi một phiếu kê khai trước, phải tương ứng với một phiếu vận chuyển thực tế. Sau khi bản kê khai được gửi đi, nếu hàng hóa của bạn không được vận chuyển (vì lý do không bắt kịp tàu, thay đổi kế hoạch vận chuyển, v.v.), bản kê khai vé được coi là bản kê khai rác!',
  N2StowManifestMustSent: '2. Ví dụ về danh sách rác: Sau khi tàu thuyền thay đổi, danh sách dự bị ban đầu nhất định phải xóa, sau khi xóa mới có thể gửi danh sách dự bị mới!',
  N3OnTheFreightManifest: '3. Hậu quả của việc không xóa danh sách rác: không chỉ ảnh hưởng đến việc xếp hàng, hải quan cao nhất cũng có thể phạt 50.000 tệ và hủy bỏ tư cách khai hải quan! Sau khi xuất hiện danh sách rác, xin liên hệ với dịch vụ khách hàng kịp thời để hỗ trợ xóa danh sách rác!',
  BusinessNotSelected: 'Chưa chọn doanh nghiệp.',
  DoNotImportAndSend: 'Nhập khẩu không gửi',
  ViewReceipt: 'Xem trả lại',
  ImportEXCEL: 'Nhập Excel',
  Receipt: 'Chấp nhận',
  ReceiptNumber: 'Số return',
  Time: 'Thời gian',
  PleaseSelectAccount: 'Vui lòng chọn tài khoản',
  MappingValueNotEmpty: '{0} không được để trống, vui lòng cấu hình mã bản đồ cho {0} trong quản lý bản đồ',
  AfrFieldNotEmpty: '{0} không được để trống',
  AfrEfreightDgTip: 'Hàng nguy hiểm không thể sử dụng chế độ gửi trực tiếp. Vui lòng chuyển lại về chế độ gửi gián tiếp. Và vui lòng bổ sung thông tin hàng nguy hiểm trên YiFei.',
  AfrFieldNotAccess: 'Không được vượt quá {0} ký tự',
  CustomerNumberCannotBeEmpty: '【Thông tin khách hàng】 Đơn vị AMS không thể rỗng.',
  CustomerNOCannotBeEmpty: '【Thông tin khách hàng】 MB/L NO không thể để trống.',
  CustomerPortCannotBeEmpty: '【Thông tin khách hàng】 Cảng dỡ hàng không được để trống.',
  CustomerDeliveryCannotBeEmpty: '【Thông tin khách hàng】 Nơi giao hàng không thể để trống.',
  AMSNumber: 'Số AMS',
  AFRNumber: 'Số AFR',
  ACINumber: 'Số ACI',
  EManifestNumber: 'Số eManifest',
  SendSucceeded: 'Gửi thành công',
  NotSent: 'Chưa gửi',
  ServiceChannel: 'Kênh dịch vụ',
  ExpectedAmazonWarehouseEntryTime: 'Thời gian dự kiến vào kho Amazon',
  DestinationDeliveryMethod: 'Phương thức giao hàng tận nơi',
  CourierCompany: 'Công ty chuyển phát nhanh',
  TrackingNumber: 'Số đơn chuyển phát nhanh',
  POoriginalNumber: 'PO (số gốc)',
  CustomsDeclarationMethod: 'Cách khai hải quan',
  CustomsClearanceMethod: 'Phương pháp thủ tục hải quan',
  EORIEnterpriseNumber: 'Tàu Enterprise EORI',
  VATTaxNumber: 'VAT/Mã số thuế',
  VATRegistrationCountry: 'Quốc gia đăng ký VAT',
  VATRegistrationAddress: 'Địa chỉ đăng ký VAT',
  VATCompanyEnglishName: 'Tên tiếng Anh của công ty VAT',
  WithPower: 'Trực tiếp',
  WithMagnet: 'Với Magnetic',
  Powder: 'Bột',
  Liquid: 'Chất L.',
  EstimatedWarehouseEntrygoodArrivalTime: 'Dự kiến thời gian nhập kho/hàng tốt',
  RemoteWarehouse: 'Vị trí xa',
  OceanFreight: 'Phí vận chuyển',
  ServiceChannel2: 'Kênh dịch vụ:',
  FeeType: 'Loại phí:',
  EstimatedAmount: 'Số tiền ước tính:',
  Equivalent: 'Liên kết',
  FreightRateLevel: 'Cấp vận chuyển:',
  BillingWeight: 'Trọng lượng TT:',
  CalculationMethod: 'Cách tính toán:',
  EstimatedTimeCannotBeEmpty: 'Dự tính thời gian nhập kho không thể để trống!',
  DestinationCannotBeEmpty: 'Điểm đến không thể để trống!',
  DestinationCountryCannotBeEmpty: 'Mục đích quốc gia không thể là trống rỗng!',
  ZipCodeCannotBeEmpty: 'Bưu điện không được để trống!',
  CannotBeEmpty: 'Không thể để trống!',
  PleaseTheConsignorUnitFirst: 'Vui lòng chọn đơn vị ủy thác trước.',
  DearAndThenCarryOperation: 'Hôn, xin lưu nghiệp vụ trước, sau đó tiến hành thao tác phân phối hàng tự động.',
  ClearanceMethod: 'Phương pháp thủ tục hải quan',
  EstimatedStorageReadyGoodsTime: 'Dự kiến thời gian nhập kho/hàng tốt',
  ForeignWarehouse: 'Kho nước ngoài',
  WithElectricity: 'Trực tiếp',
  WithMagnetism: 'Với Từ',
  YourPieceWeightAndTo: 'Hàng hóa của bạn đã tham gia so sánh dữ liệu, tự động đóng gói sẽ cập nhật thông tin về phiếu gốc và phiếu chính.',
  Prompt: 'Mẹo',
  GotIt: 'Hiểu rồi.',
  DocumentNumber: 'Số giấy tờ',
  Origin: 'Xuất xứ',
  AreaCode: 'Mã vùng',
  BoxAndCargoInformationFunction: 'Thông tin không nhất quán, xin xác nhận thông tin có chính xác không? Bạn có thể kiểm tra để sửa đổi thông tin thùng hàng trên trang cơ bản hoặc khớp thông tin thùng hàng thông qua chức năng 【Cập nhật dữ liệu cảng】.',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: 'LƯU Ý: Khi dữ liệu cảng không phù hợp với thông tin đóng gói, có thể dẫn đến cảnh báo không đẩy, cảnh báo liên quan đến cài đặt SOP',
  TheComparisonFunctionToPossible: 'Đã nhận được thông tin mới nhất về thùng hàng tại cảng, vui lòng sử dụng 【Cập nhật dữ liệu cảng】 để chọn dữ liệu thùng hàng bạn muốn càng sớm càng tốt',
  DetectionOfBasicTab: 'Phát hiện dấu trang cơ bản',
  InconsistentThePortAreaReturn: 'Trở về cảng',
  PleaseTheOperationIsCorrect: 'Không phù hợp',
  YouBoxAndCargoTab: 'Vui lòng kiểm tra tại 【Thông tin đóng gói】 ngay bây giờ.',
  BoxNum: 'Một cái hộp.',
  GoCheck: 'Kiểm tra đi.',
  BoxQuantity: 'Số lượng hộp',
  BoxModel: 'Loại hộp',
  CutOffDate: 'Ngày cắt',
  PortOpeningTime: 'Thời gian mở cửa',
  PortOpeningDate: 'Ngày mở cửa',
  ScheduledBerthingTime: 'Lập kế hoạch neo đậu',
  ScheduledDepartureTime: 'Thời gian khởi hành',
  ActualUnloadingTime: 'Thời gian dỡ hàng thực tế',
  ActualHeavyLiftingTime: 'Thời gian nâng thực tế',
  ActualEmptyReturnTime: 'Thời gian còn trống.',
  PleasePackingInformationToRemoved: 'Vui lòng chọn thông tin đóng gói cần xóa!',
  BillOfLadingType: 'Loại B/L',
  ArrivalDate: 'Ngày đến cảng',
  ShippingType: 'Loại vận chuyển',
  DischargingPort: 'Cảng dỡ hàng',
  DeliveryPlace: 'Nơi giao hàng',
  CustomerShippingInformation: 'Thông tin vận chuyển của khách hàng',
  CargoReceiver: 'Người nhận hàng',
  Buyer: 'Người mua',
  Modify: 'Sửa đổi',
  PleaseSelectABox: 'Vui lòng chọn hộp',
  ReleaseOrderNumber: 'Đặt số đơn:',
  ExportReleaseNewRegulation: 'Quy định mới về xuất khẩu',
  WechatPrompt: 'Xin vui lòng mỗi người dùng cần mở vào các thiết lập và công cụ - thông tin cá nhân, mở quyền gửi tin Wechat và theo dõi số công chúng.',
  YangshanAreaNovember152021: 'Quận Yangshan Quan: 15 tháng 11 năm 2021',
  WaigaoqiaoAreaNovember222021: 'Khu vực Outer Harbor: 22 tháng 11 năm 2021',
  GarbageCargoManifest: 'Bản kê khai rác',
  N1ActuallyShippedIfGarbage: '1. Hải quan nghiêm cấm kê khai rác! Theo quy định của hải quan, mỗi một phiếu kê khai trước, phải tương ứng với một phiếu vận chuyển thực tế. Sau khi bản kê khai được gửi đi, nếu hàng hóa của bạn không được vận chuyển (vì lý do không bắt kịp tàu, thay đổi kế hoạch vận chuyển, v.v.), bản kê khai vé được coi là bản kê khai rác!',
  N2ManifestMustBeDeletion: '2. Ví dụ về danh sách rác: Sau khi tàu thuyền thay đổi, danh sách dự bị ban đầu nhất định phải xóa, sau khi xóa mới có thể gửi danh sách dự bị mới!',
  N3YuanOnTheManifest: '3. Hậu quả của việc không xóa danh sách rác: không chỉ ảnh hưởng đến việc xếp hàng, hải quan cao nhất cũng có thể phạt 50.000 tệ và hủy bỏ tư cách khai hải quan! Sau khi xuất hiện danh sách rác, xin liên hệ với dịch vụ khách hàng kịp thời để hỗ trợ xóa danh sách rác!',
  DetailsOfSeaExportGoods: 'Chi tiết hàng hóa xuất khẩu bằng đường biển',
  PleaseSelectTheSpecifiedData: 'Vui lòng chọn dữ liệu đã xác định',
  LicenseOfLadingNumberEmpty: 'Biển số xe và số vận đơn không được để trống',
  NoRelevantInformation: 'Không có thông tin liên quan.',
  EstimatedDeliveryTime: 'Thời gian giao hàng dự kiến',
  ActualDeliveryTime: 'Thời gian giao hàng thực tế',
  ObtainedContainerAndGoodsData: 'Tên tàu bạn đã nhập',
  Sailing: 'Chuyến đi:',
  WithBookingTab: 'Chuyến bay lấy tên từ cảng.',
  InconsistentFromTheBillData: 'Không nhất quán, có phải các chuyến đi tên tàu được nhập vào khu vực cảng và dữ liệu thời gian tàu được làm trống để lấy không?',
  InconsistentFromTheBillDataTips: 'Lưu ý: Nếu tên tàu không chính xác có thể dẫn đến thời gian tàu không chính xác (thời gian dự kiến rời bến, thời gian khởi hành, thời gian thực tế rời bến)',
  TheTicketIsNotImport: 'Vé MBL đến trạng thái đơn không phải là chưa bắt đầu và không thể nhập.',
  Correction: 'Sửa',
  ThisItIs1Again: 'Công việc {0} này đã được gửi thành công một thuê bao EDI,< <br>Bài viết này là {1}- {2},<br>Vui lòng xác nhận xem bạn có cần gửi lại không?',
  PleaseOnePieceOfData: 'Vui lòng chọn một phần dữ liệu!',
  BatchImport: 'Nhập hàng loạt',
  GoodsInformationImport: 'Nhập thông tin hàng hóa',
  SeaFreight: 'Phí vận chuyển',
  AirFreight: 'Phí vận chuyển hàng không',
  Freight: 'Chi phí vận chuyển',
  BatchCostScheme: 'Gói cước số lượng lớn',
  Shanghai: 'Thượng Hải',
  Qingdao: 'Thanh Đảo',
  SeaguardianSupportsSM2WeighingMethod: 'Kênh quản gia biển chỉ hỗ trợ phương pháp cân SM2.',
  ContainerNumberSealNumber: 'Số hộp - Số niêm phong',
  DueCannotBePrintedNeeded: 'Do kiểm soát tín hiệu vượt quá, vé đã bị khóa, sẽ không thể in hoặc EDI, vui lòng liên hệ với cấp trên để mở khóa khi cần thiết!',
  LockedContactTheSuperiorUnlock: 'Đã khóa, không in được, xin hãy liên lạc với cấp trên để mở khóa!',
  ModificationSuccessful: 'Sửa đổi thành công',
  StatusConversionSuccessful: 'Chuyển đổi trạng thái thành công.',
  NoDeclarationFormCreated: 'Chưa tạo tờ khai hải quan',
  Cleared: 'Đã thu thập đủ.',
  Uncleared: 'Không nhận đủ',
  SentOut: 'Đã gửi',
  TakenOver: 'Đã nhận hóa đơn',
  Filed: 'Lưu trữ',
  TaxRefunded: 'Đã hoàn thuế',
  ReturnedbyOurCompany: 'Đã lấy lại (tôi)',
  ReturnedtoTheCustomer: 'Đã hoàn trả (Khách hàng)',
  WithdrawalOfDocumentStatus: 'Chứng từ rút tiền',
  DocumentStatus: 'Tình trạng chứng từ',
  SendOut: 'Gửi đi',
  Archive: 'Lưu trữ',
  RefundTax: 'Hoàn thuế',
  RetrieveourCompany: 'Lấy lại (My)',
  Returncustomer: 'Hoàn trả (Khách hàng)',
  StateNotSelected: 'Chưa chọn trạng thái.',
  DateNotSelected: 'Chưa chọn ngày.',
  WithdrawalSuccessful: 'Rút lui thành công.',
  NoDataSelected: 'Chưa chọn dữ liệu.',
  PleaseANewDeclarationForm: 'Vui lòng tạo tờ khai mới.',
  NoDataModified: 'Không có dữ liệu bị thay đổi',
  SavedSuccessfully: 'cứu thành công.',
  BatchIsInconsistentPleaseSelect: 'Trạng thái in hàng loạt không nhất quán, xin vui lòng chọn lại.',
  NoDataAvailableForPrinting: 'Không có dữ liệu để in.',
  Document: 'Chứng từ',
  Date: 'Ngày',
  NoFilesAvailable: 'Không có tài liệu',
  Takeover: 'Nhận hóa đơn',
  Retrieve: 'Lấy lại',
  FileNotSelected: 'Tập tin không được chọn.',
  NoTemplateFound: 'Không tìm thấy',
  ForTheCorrespondingPrint: 'Mẫu in tương ứng',
  BookingAPI: 'Đặt phòng API',
  BillOfLadingAPI: 'Vận đơn API',
  PleaseTheBusinessToSend: 'Vui lòng chọn doanh nghiệp bạn muốn gửi!',
  ContainerQuantity: 'Số hộp',
  BookingEdiSendingChannel: 'Kênh EDI',
  BookingEdiSendingTime: 'Thời gian EDI',
  EdiStateQuery: 'Truy vấn trạng thái EDI',
  JiLianStar: 'Liên minh mới',
  NotBeSent: '(Lưu ý: Dòng này không được gửi)',
  FullyStored: 'Hoàn toàn vào kho',
  CancelFullWarehousing: 'Hủy toàn bộ thư viện',
  StoredTipOne: 'B5-05=giá trị thông số Kd, (cài 2)',
  StoredTipTwo: 'Xác nhận hoạt động?',
  StoredTipThree: 'Chọn dữ liệu có trạng thái thư viện là 【{0}】',
  StoredTipFour: 'Hóa đơn nhập kho của nghiệp vụ vé này đã hoàn toàn nhập kho!',
  SelectedRightData: 'Vui lòng chọn dữ liệu phù hợp',
  EmptyContainerNotificationTime: 'Thời gian thông báo tủ trống',
  WaitBookingVerifyBatch: 'Trong quá trình xét duyệt hàng loạt, xin chờ một chút, sau khi xét duyệt thành công sẽ nhắc nhở bạn.',
  BookingVerifyBatch: 'Nghiệp vụ xét duyệt số lượng lớn không thể vượt quá 500 điều!',
  Roles: 'Vai trò',
  ZipForCountry: 'US, CA Bắt buộc',
  PleaseZipForSend: 'Vui lòng chọn Postal Code để gửi!',
  BL_EDI_SendChannel: 'Kênh gửi vận đơn EDI',
  BL_EDI_SendTime: 'Thời gian gửi B/L EDI',
  VGM_EDI_SendChannel: 'Kênh gửi VGM EDI',
  VGM_EDI_EDISendTime: 'VGM EDI Thời gian gửi',
  CleanManifest_EDI_SendChannel: 'Làm sạch Manifest EDI Send Channel',
  CleanManifest_EDI_SendTime: 'Thời gian gửi bản kê khai sạch EDI',
  Way99_EDI_SendChannel: '99 kênh gửi EDI danh sách hành lý',
  Way99_EDI_SendTime: '99 cách vận chuyển danh sách EDI gửi thời gian',
  AMS_EDI_SendChannel: 'Kênh gửi AMS EDI',
  AFR_EDI_SendChannel: 'AFR EDI Kênh gửi',
  ACI_EDI_SendChannel: 'Kênh gửi ACI EDI (CW)',
  ACI_EDI_SendTime: 'Thời gian gửi ACI EDI (CW)',
  AMS_JS_STATE: 'AMS Gửi trạng thái',
  ACI_JS_STATE: 'ACI gửi trạng thái',
  AFR_JS_STATE: 'AFR Gửi trạng thái',
  AMS_EDI_SendTime: 'Thời gian gửi AMS EDI',
  AHR_EDI_SendTime: 'AHR EDI Thời gian gửi',
  ENS_EDI_SendTime: 'Thời gian gửi ENS',
  PreShippingBill_EDI_SendChannel: 'Bản kê khai trước EDI Send Channel',
  PreShippingBill_EDI_SendTime: 'Thời gian gửi bản kê khai trước EDI',
  OverseaAgent_EDI_SendChannel: 'Đại lý EDI gửi kênh ở nước ngoài',
  OverseaAgent_EDI_SendTime: 'Đại lý EDI ở nước ngoài Thời gian gửi',
  PortOfHubSecond: 'Cảng HUB - 2 chiều',
  PortOfHubThird: 'Cảng HUB - 3 chiều',
  ProvisioningStatus: 'Trạng thái pre-fit',
  ArrivalInformation: 'Thông tin cảng',
  QuantityConsign: 'Số kiện (ủy ban)',
  QuantityActual: 'Số kiện (thực)',
  WeightConsign: 'Tổng trọng lượng',
  WeightActual: 'Tổng trọng lượng (thực)',
  CubageConsign: 'Thể tích (ủy ban)',
  CubageActual: 'Âm lượng (thực)',
  VolumetricWeightConsign: 'Tài liệu',
  VolumetricWeightActual: 'Tài liệu (thực)',
  ChargeWeightConsign: 'Trọng lượng tính phí',
  ChargeWeightActual: 'Trọng lượng tính phí',
  CategoryOfGoodsName: 'Name',
  ShipperLine2: 'Người gửi hàng 2',
  ConsigneeLine2: 'Người nhận hàng 2',
  NotifyPartyLine2: 'Thông báo dòng thứ hai',
  ShipperLine3: 'Người gửi hàng 3',
  ConsigneeLine3: 'Người nhận hàng 3',
  NotifyPartyLine3: 'Thông báo cho người thứ ba',
  ShipperLine4: 'Người gửi hàng 4',
  ConsigneeLine4: 'Người nhận hàng 4',
  NotifyPartyLine4: 'Thông báo dòng 4',
  ShipperLine5: 'Người gửi hàng 5',
  ConsigneeLine5: 'Người nhận hàng 5',
  NotifyPartyLine5: 'Thông báo dòng 5',
  ShipperLine6: 'Người gửi hàng 6',
  ConsigneeLine6: 'Người nhận hàng 6',
  NotifyPartyLine6: 'Thông báo dòng 6',
  ShipperLine7: 'Người gửi hàng 7',
  ConsigneeLine7: 'Người nhận hàng 7',
  NotifyPartyLine7: 'Thông báo dòng 7',
  OperationLog: 'Nhật ký hoạt động',
  DimensionLength: 'Kích thước CM (chiều dài)',
  DimensionWidth: 'Kích thước CM (W)',
  DimensionHeight: 'Kích thước CM (H)',
  SystemAdd: 'Nền tảng mới',
  FreeContainerEndTime: 'Thời gian hết hạn miễn phí',
  FreeStorageEndTime: 'Thời gian hết hạn miễn phí',
  QuantityConsign2: 'Số lượng (delegate)',
  QuantityBooking: 'Số lượng kiện (đặt hàng)',
  QuantityActual2: 'Số mảnh (thực tế)',
  QuantityDocumentation: 'Số mảnh (đơn đặt hàng)',
  WeightConsign2: 'Tổng trọng lượng KGS (ủy quyền)',
  WeightBooking: 'Tổng trọng lượng KGS (đặt hàng)',
  WeightActual2: 'Tổng trọng lượng KGS (thực tế)',
  WeightDocumentation: 'Tổng trọng lượng KGS (Đơn hàng)',
  CubageConsign2: 'Khối lượng CBM (ủy quyền)',
  CubageBooking: 'Khối lượng CBM (đặt hàng)',
  CubageActual2: 'Khối lượng CBM (thực tế)',
  CubageDocumentation: 'Khối lượng CBM (Đơn đặt hàng)',
  ChargeWeightConsign2: 'Trọng lượng thanh toán M/T (ủy quyền)',
  ChargeWeightBooking: 'Trọng lượng thanh toán M/T (đặt hàng)',
  ChargeWeightActual2: 'Trọng lượng thanh toán M/T (thực tế)',
  ChargeWeightDocumentation: 'Trọng lượng thanh toán M/T (Đơn đặt hàng)',
  DensityConsign: 'Mật độ kg/m³ (ủy quyền)',
  DensityBooking: 'Mật độ kg/m³ (đặt hàng)',
  DensityActual: 'Mật độ kg/m³ (thực tế)',
  DensityDocumentation: 'Mật độ kg/m³ (Đơn đặt hàng)',
  ConsignationCompany2: 'Đơn vị ủy thác/Thông báo thực tế',
  ConsignationCompanyHeader2: 'Head of the delegate unit/Head of the actual notifications/Head of the delegate đơn vị ủy thác/Head of người thông báo thực tế',
  WarehouseSupplier2: 'Nhà cung cấp kho/Kho',
  ShipperDetail: 'Chi tiết vận chuyển',
  ConsigneeDetail: 'Chi tiết người nhận hàng',
  NotifyDetail: 'Thông báo chi tiết',
  MasterBillNo2: 'Số đơn chính/MBL',
  SynchroniseBooking: 'Thông tin đặt phòng đồng bộ',
  HBLNoRepeat: 'Có HB/L NO trùng lặp, số đơn:"{0}"',
  ConfirmSynchronizeHBL: 'Synchronise HBL được làm trống để thêm thông tin nhập thủ công. Tiếp tục không?',
  GetFiles: 'Lấy tập tin',
  UploadCustomerFiles: 'Tải lên phần khách hàng',
  CustomerSelfIssuedFiles: 'Tài liệu khách hàng tự xuất',
  CheckTheBLLog: 'Phải, nhật ký đơn.',
  Surrendered: 'Đặt hàng điện phóng',
  InterfaceName: 'Tên giao diện',
  DataFlowDirection: 'Dòng chảy dữ liệu',
  CheckTheBLCenterApiLog: 'Nhật ký trung tâm đơn',
  PleaseMaintainTheCorresponding: 'Vui lòng duy trì {0} người tương ứng',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: 'Vui lòng duy trì số điện thoại của đối tác',
  XhqCsrMsg: 'Thông điệp cờ tín hiệu',
  copyLink: 'Sao chép liên kết',
  openLink: 'Mở liên kết',
  BillNotCfm: 'B/L chưa được xác nhận, vui lòng xác nhận trước',
  ATDIsNull: 'Chưa rời cảng, xin vui lòng phóng điện sau khi rời cảng.',
  BillNotRelease: 'Trạng thái vận đơn, không"Đặt hàng"',
  CfmBillFirst: 'Chưa có, vui lòng click trước"Xác nhận cặp"',
  IsReleased: 'Đã đặt hàng, không thể tải lên bản thảo khách hàng ở đây.',
  IsReleased2: 'Đã đặt hàng, không cần lặp lại thao tác',
  UnStartOrUnConfirmCanUpload: 'Tài liệu có thể được tải lên khi vận đơn 【Chưa bắt đầu】 hoặc 【Không xác nhận】',
  LinkIsNull: 'Link trống',
  OnlySurrenderedSupport: 'Chỉ "SURRENDERED" B/L phương pháp, hỗ trợ e-thả',
  SynchronizePackingInfo: 'Cập nhật đồng bộ thông tin đóng gói',
  ManifestNotConfirmed: 'Bản kê khai không được xác nhận!',
  AreYouSureSynchronizePackingInfo: 'Bạn chắc chắn muốn cập nhật thông tin đóng gói đồng bộ?',
  NoDataSynced: 'Không đồng bộ hóa bất kỳ dữ liệu, vui lòng xác nhận loại hộp~',
  VirtualBillType: 'Hình thức Phân loại',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: 'ĐL cảng đích khác ĐL hàng hóa chỉ định',
  MultipleCustomsDeclarationInaccurate: 'Có một cảnh có nhiều hơn một công việc báo cáo quan, dữ liệu sẽ không chính xác. Vui lòng liên hệ với nhà khai hải quan trực tuyến để thông báo chi tiết về khai hải quan.',
  OnlySupportOneCustomsDeclaration: 'Tính năng này chỉ áp dụng cho việc tạo ra 1 kịch bản ủy quyền hải quan trong 1 doanh nghiệp.',
  OnlySupportOneCustomsCommission: 'Vui lòng chọn một ủy thác khai hải quan, yêu cầu kiểm tra bản thảo.',
  hblRefNo: 'HBL mở Ref',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: 'Phí đẩy hàng loạt (ủy quyền chéo)',
  ChargeConfirmed: 'Chi phí cần xác nhận',
  ViewReception: 'Xem nhận',
  ViewSending: 'Xem gửi',
  branchTransactions: 'Giao dịch chi nhánh',
  OurJobNo: 'Số doanh nghiệp của chúng tôi',
  TheirJobNo: 'Số doanh nghiệp đối tác',
  firstSendTime: 'Thời gian gửi lần đầu',
  ConfirmReceiveTheseCharges: 'Xác nhận nhận các khoản phí này?',
  AuditOperator: 'Kiểm toán Operator',
  Dimensions: 'Kích thước Thông số kỹ thuật (L * W * H Đơn vị M)',
  DoorRemarks: 'Hướng dẫn thêm về Door Point',
  BillOfLadingDesignatedFreightAgentFeedback: 'B/L - Phản hồi đại lý hàng hóa được chỉ định',
  ChangeValue: 'Sửa đổi giá trị',
  AcceptChange: 'Chấp nhận sửa đổi',
  Rejected: 'Không chấp nhận',
  AgentFeedbackRemarks1: 'Ý kiến thay đổi của đại lý hàng hóa đã được chấp nhận',
  AgentFeedbackRemarks2: 'Ý kiến sửa đổi trên mạng đại lý hàng hóa chỉ định đã bị bác bỏ,',
  AgentFeedbackRemarks3: 'Vui lòng offline để xác nhận sửa đổi cuối cùng với người gửi hàng và đại lý được chỉ định',
  AgentEmailSend: 'Gửi thư đến đại lý hàng hóa được chỉ định',
  ETAFirstPortOfCall: 'Ngày cập bến cảng đầu tiên',
  ETAFirstPortOfCallNotNull: 'Ở chế độ On-Board,"ETA First Port of Call"Không thể để trống',
  DocumentOffice: 'Công ty chứng từ',
  CustomerOffice: 'Dịch vụ khách hàng',
  PleaseReferToTheEmailForSpecificErrorInformation: 'Xem thêm thông tin chi tiết về email',
  AMSDeleteTips: 'AMS No đã không gửi thành công AMS trong hệ thống và không thể xóa',
  MultipleMode: 'Chế độ đa đơn',
  NumberExchange: 'Trao đổi số đơn',
  ReturnMode: 'Trở về Single Mode',
  OcrTip: '* Mẹo: Có thể thiết lập các trường ghi âm hiển thị bổ sung trong "Cấu hình cơ bản - Cài đặt nhận dạng tài liệu".',
  OcrOtherInfo: 'Các thông tin ghi chép khác:',
  DocumentRecognitionSettings: 'Thiết lập nhận dạng tài liệu',
  SeOcr: 'Nhận dạng thư ký xuất khẩu bằng đường biển',
  ocrOtherField: 'Vui lòng chọn Extra Record Field',
  ocrTextMapper: 'Nhận dạng các ánh xạ văn bản',
  IdentifyingText: 'Nhận dạng văn bản',
  mappedValue: 'Giá trị bản đồ',
  addMapper: 'Bản đồ mới',
  editMapper: 'Sửa bản đồ',
  supplierCharge: 'Phí nhà cung cấp',
  supplierOrderNo: 'Số đơn nhà cung cấp',
  supplierName: 'Tên nhà cung cấp',
  supplierMatchName: 'Name',
  chargeItemLocal: 'Name',
  refMsg1: 'Thông tin tham khảo (1)',
  refMsg2: 'Thông tin tham khảo (II)',
  supportNo: 'Số đơn phụ trợ',
  pushTime: 'Thời gian đẩy',
  confirmCharge: 'Phí xác nhận',
  selectBeConfirmedCharge: 'Vui lòng chọn phí để xác nhận',
  RefreshSuccessfulRows: 'Làm mới thành công {0}',
  SupplierFeesToBeProcessed: 'Chi phí nhà cung cấp đang chờ xử lý',
  ReceivingBranch: 'Nhận văn phòng chi nhánh',
  ReceivingMatchBranch: 'Nhận tên chi nhánh phù hợp',
  PleaseRefreshThePage: 'Không tìm thấy mã bản đồ, hãy duy trì bản đồ. Nếu đã bảo trì, hãy làm mới.',
  BusinessDateIsNull: 'Ngày kinh doanh tương ứng với doanh nghiệp là trống',
  NoJobMatch: 'Không có doanh nghiệp phù hợp, xin vui lòng làm mới',
  ReleaseGoodsJY: 'Hàng JY',
  ReleaseJY: 'Đặt hàng JY',
  TakeContainerJY: 'Túi xách JY',
  ContainerPreloadJY: 'Đóng gói JY',
  CancelContainerPreloadJY: 'Hủy đóng gói jy',
  ReleaseGoodsPhotos: 'Đặt hàng ảnh',
  ReleaseGoodsStatus: 'Trạng thái thả hàng',
  NoticeTime: 'Thời gian thông báo',
  ReleaseGoods: 'Đặt hàng',
  warehouseNoNotNull: 'Số nhà kho không được để trống',
  warehouseNotNull: 'Tên kho không được để trống, vui lòng chọn nhà kho hoặc nhà cung cấp kho trên trang cơ bản',
  consignerNotNull: 'Khách hàng không được để trống',
  ReleaseRemarks: 'GC Đặt hàng',
  RequireDate: 'Ngày yêu cầu',
  TakeContRemarks: 'Ghi chú cho trường hợp',
  ConfirmSendPackingInstructions: 'Xác định gửi lệnh đóng gói?',
  AlreadySentReleaseGoods: 'Đã gửi đơn đặt hàng, đừng đẩy nhiều lần',
  PleaseSelectWarehouseNo: 'Vui lòng chọn số kho',
  TheWarehouseNoHasBeenReleased: 'Số lượng đã từng được gửi đi, có còn gửi đi không?',
  ViewReleaseGoodsPhotos: 'Xem ảnh thả hàng',
  JyWarehouseInterfaceLog: 'Nhật ký kết nối kho hàng',
  JyWarehouseApiLog: 'Nhật ký giao diện kho tiên tri',
  LclDynamic: 'Động LCL',
  TakeContainerNotice: 'Thông báo hành lý',
  TakeContainerDone: 'Hộp hoàn thành',
  PreloadContainerOrder: 'Hướng dẫn đóng gói',
  PreloadContainerDone: 'Đóng gói xong',
  SendPort: 'Giao hàng tận nơi.',
  SendPortStart: 'Giao hàng tận nơi.',
  ArrivalPort: 'Cổng vào (báo cáo kho)',
  ExistEmptyContainer: 'Hộp được đánh dấu được giữ trong hộp có thông tin đóng gói trống',
  docLink: 'Đối với liên kết đơn',
  Field: 'Lĩnh vực',
  ErrorDescription: 'Description',
  VerificationPrompt: 'Mẹo xác minh',
  InformationSavingOnly: 'Chỉ lưu thông tin',
  Required: 'BB',
  InputTwoAbove: 'Vui lòng nhập nhiều hơn 2',
  SendError: 'Gửi thất bại',
  CounterTerrorismManifestConfiguration: 'Bản kê khai chống khủng bố',
  AfrAccount: 'Tài khoản AFR',
  AfrPassword: 'Mã AFR',
  ApplicantEORI: 'Người khai báo EORI',
  AccountIsNotNull: 'Vui lòng chọn số tài khoản đã gửi',
  PasswordIsNotNull: 'Vui lòng duy trì mật khẩu đã gửi',
  Notification: 'Thông báo',
  Error: 'Thông tin sai',
  NoSendingRecord: 'Chưa gửi hồ sơ',
  GetExceptions: 'Lấy ngoại lệ',
  WaitingReceipt: 'Sự tồn tại của cùng một tên tàu, cùng một chuyến đi Nvocc SCAC chưa được gửi đến hải quan, không thể gửi được, hãy kiên nhẫn chờ đợi',
  NotOperable: 'Có những trường hợp không nhận được hồi âm hoặc không gửi thành công, không thể gửi bản gốc, sửa chữa, xóa',
  AmsVgm: 'Bản kê khai/VGM',
  AmsReceipt: 'AMS Trả lời',
  AciReceipt: 'ACI Trả lời',
  AfrReceipt: 'AFR Trả lời',
  VgmReceipt: 'VGM trả lại',
  ManifestReceipt: 'Kiểm tra lại bản kê khai.',
  UserDefinedRole1: 'Tùy chỉnh bài viết 1',
  UserDefinedRole2: 'Tùy chỉnh vị trí 2',
  AmsReceiptRemind: 'Báo cáo chống khủng bố',
  DangerousCargoCode: 'Loại hàng hóa - Hàng hóa nguy hiểm',
  CustomerToOrder: 'Khách hàng đến Single',
  DesignatedGoodsToBillOfLading: 'Chỉ định Cargo-to-Order',
  OverwriteOriginalRemark: 'Trang chủ [Bracket0]',
  DownloadPortServiceScope: 'Tải xuống phạm vi dịch vụ cảng',
  AllowSaleProduct: 'Sản phẩm bán chạy',
  FullOrInside: 'Toàn bộ/trong nước',
  Commissioned: 'Đã ủy nhiệm',
  weightVolumeBillWeightConsolidated: 'Trọng lượng/khối lượng/trọng lượng thanh toán bao gồm và duy nhất',
  weightVolumeBillWeightConsolidatedTip: 'Doanh nghiệp được lựa chọn tồn tại và duy nhất và sẽ thống kê và duy nhất trọng lượng/khối lượng/trọng lượng thanh toán. Mặc định thống kê trọng lượng/khối lượng/trọng lượng thanh toán của thẻ trang cơ bản.',
  AttentionForSynchronizedContainer: 'Lưu ý: Cài đặt này có hiệu lực khi bạn điền số hộp. Nếu không điền thì không có hiệu lực.',
  BatchFillGpExplain: 'Điền vào mô tả GP hàng loạt',
  AiDocRecognition: 'Chứng nhận AI',
  AiRecognition: 'Nhận dạng AI',
  SupportMultipleFiles: 'Hỗ trợ nhận dạng nhiều tệp liệu như đơn nhận hàng, văn kiện xác nhận đơn nhận đơn nhận hàng, thư gửi thư, v. v!',
  DragOrClick: 'Kéo tập tin vào đây hoặc',
  ClickUpload: 'Click vào Upload',
  FileSizeLimit: 'Bạn chỉ có thể tải lên một tệp mỗi lần và tệp riêng lẻ không vượt quá 4MB',
  InvalidFileType: 'Kiểu tập tin không chính xác',
  FileTooLarge: 'Kích thước tập tin không được vượt quá 4MB',
  Reupload: 'Tải lên lại',
  StartRecognition: 'BĐ Nhận dạng',
  RecognitionInProgress: 'Nhận dạng...... Xin vui lòng sau đó, nó sẽ mất khoảng 30s',
  RecognitionTextTip: 'Vui lòng sao chép và dán nội dung trực tiếp sau khi nhấn vào nút nhận dạng, hệ thống sẽ tự động nhận dạng và điền nội dung vào trường tương ứng',
  EstimatedTime: 'Mong đợi {thời gian}',
  RecognitionSuccess: 'Xác định thành công',
  RecognitionFailed: 'Xác định thất bại',
  AiRecognitionWarn: 'Nhận dạng AI có thể có lỗi, vui lòng kiểm tra cẩn thận trước khi gửi',
  SupportsShanghaiPortShipAgent: 'Chỉ hỗ trợ xem tàu tương ứng với cảng Thượng Hải',
  ServiceNotActivated: 'Bạn chưa mở dịch vụ này',
  updateOrderContent: 'Cập nhật nội dung lệnh',
  CheckCustomsBrokerComfirm: '【Nhà môi giới hải quan】 đã được chọn, trường 【Nhà môi giới hải quan】 của doanh nghiệp tương ứng sẽ được cập nhật hàng loạt, có xác nhận không?',
  CheckCustomsBrokerComfirm2: '【Dịch vụ khai hải quan】 đã chọn nhưng không chọn 【Nhà môi giới hải quan】, trường 【Dịch vụ khai hải quan】 của doanh nghiệp sẽ được làm trống hàng loạt, có xác nhận không?',
  ClearCustomsBrokerComfirm: 'Chọn Clear Business Local Services 【Khai báo hải quan】 và xóa hàng loạt trường 【Khai báo hải quan】 của doanh nghiệp đã chọn, bạn có xác nhận không?',
  EdiEuBolInfo: 'Thông tin bổ sung về vận đơn đường dây Euro',
  EuroLineENSDeclaration: 'Logo khai báo Euro ENS',
  SelectEuroLineENSDeclaration: 'Vui lòng chọn"Logo khai báo Euro ENS"',
  ManifestType: 'Loại Manifest',
  SelectManifestType: 'Vui lòng chọn loại biểu mẫu',
  SupplementaryDeclarant: 'Người khai báo bổ sung',
  ChemicalIdentifier: 'Logo hóa chất',
  ChemicalProduct: 'Hóa chất',
  NonChemicalProduct: 'Không hóa chất',
  ChemicalCUSCODE: 'Mã hóa chất CUS CODE',
  PostalInformation: 'Thông tin bưu điện',
  PostalInformation2: 'Thông tin bưu chính<br>(với tên đường phố, số hai chọn một)',
  EORICode: 'Mã EORI',
  ShipperStreetNumber: 'Số đường giao hàng',
  ShipperStreetName: 'Name',
  ActualShipperStreetNumber: 'Số đường giao hàng thực tế',
  ActualShipperStreetName: 'Name',
  ShipperZipCode: 'Mã bưu điện của người gửi hàng',
  ShipperAddress: 'Địa chỉ người gửi hàng',
  ConsigneeStreetNumber: 'Số đường dành cho người nhận hàng',
  ConsigneeStreetName: 'Name',
  ActualConsigneeStreetNumber: 'Số đường thực tế của người nhận hàng',
  ActualConsigneeStreetName: 'Name',
  ConsigneeZipCode: 'Mã bưu điện của người nhận hàng',
  ConsigneeAddress: 'Địa chỉ người nhận hàng',
  NotifyStreetNumber: 'Thông báo số đường phố',
  NotifyStreetName: 'Thông báo tên đường',
  NotifyZipCode: 'Mã bưu điện thông báo',
  ActualShipper: 'Người gửi hàng thực tế',
  ActualShipperName: 'Tên người gửi hàng thực tế',
  ActualConsignee: 'Người nhận hàng thực tế',
  ActualConsigneeName: 'Name',
  ByBillingDate: 'Ngày tạo hóa đơn',
  ByBusinessDate: 'Theo ngày kinh doanh',
  CostRateValue: 'Tỷ giá hối đoái lấy giá trị',
  CopyBusiness: 'Kinh doanh sao chép',
  CopyActualShipper: 'Sao chép người gửi hàng',
  CopyActualConsignee: 'SaoChép NH',
  SelectEORICode: 'Vui lòng nhập thông tin mã EORI cho trường {0}',
  TOOrderRequired: 'Order cần cung cấp',
  EORICodeExample: 'Loại mã+Mã số',
  PlsInputParameter: 'Vui lòng nhập {0}',
  PlsSelectUnLCL: 'Vui lòng chọn loại đánh vần hoàn chỉnh cho doanh nghiệp không tự ghép',
  StreetInfo: 'Số đường phố, tên đường phố hoặc thông tin bưu chính',
  ImportingLater: 'Đang nhập, vui lòng hành động sau',
  BusinessSeq: 'Số doanh nghiệp',
  Yard: 'Trang chủ',
  PleaseSelectCarrier: 'Vui lòng chọn hãng vận chuyển tương ứng',
  ModifyStatus: 'Sửa đổi trạng thái',
  ModifyManifestStatusTip: 'Chỉ hỗ trợ trạng thái sửa đổi số đóng đã gửi bản kê khai',
  AllSoNos: 'Tất cả các số đóng',
  PlsSelectSoNo: 'Vui lòng chọn số đóng cần sửa đổi',
  FclOrderType: 'Chi tiết đơn đặt hàng FCL',
  LclOrderType: 'BC Chi tiết đơn đặt hàng',
  ConsoleOrderType: 'Chi tiết lệnh không vào kho',
  CopyBusinessSendConsigneeNotify: 'Dịch vụ sao chép',
  DeclarationInformation: 'Thông tin khai báo',
  RelatedInformation: 'Thông tin liên kết',
  SubstratumDeclarant: 'Người khai báo cấp dưới',
  PortInformation: 'Thông tin cảng',
  BuyerName: 'Tên người mua',
  BuyerAddress: 'Địa chỉ người mua',
  BuyerEORICode: 'Mã EORI của người mua',
  BuyerPostalCode: 'Mã bưu điện của người mua',
  BuyerCountry: 'Quốc gia của người mua',
  BuyerCity: 'Thành phố của người mua',
  SellerName: 'Tên người bán',
  SellerAddress: 'Địa chỉ người bán',
  SellerEORICode: 'Mã EORI của người bán',
  SellerPostalCode: 'Mã bưu điện của người bán',
  SellerCountry: 'Quốc gia của người bán',
  SellerCity: 'Thành phố của người bán',
  UCRNO: 'UCR NO',
  ShipperEORI: 'Người gửi EORI',
  ConsigneeEORI: 'Người nhận hàng EORI',
  NotifyEORI: 'Thông báo EORI',
  FactoryEORI: 'Nhà máy EORI',
  WarehouseEORI: 'Nhà kho EORI',
  LCLPersonEORI: 'Thương hiệu: EORI',
  ActualShipperCountry: 'Quốc gia gửi hàng',
  ActualShipperCity: 'Thành phố Shipper',
  ActualRecipientCountry: 'Quốc gia nhận hàng',
  ActualRecipientCity: 'Thành phố nhận hàng',
  NotifyPhone: 'Điện thoại thông báo',
  NotificationCountry: 'Quốc gia thông báo',
  NotifyPersonCity: 'Thông báo Thành phố',
  BuyerStreetNumber: 'Số đường phố của người mua',
  BuyerStreetName: 'Tên đường phố của người mua',
  SellerStreetNumber: 'Số đường phố của người bán',
  SellerStreetName: 'Name',
  CopyActualRecipient: 'Sao chép người nhận hàng thực tế',
  CopyActualShip: 'Sao chép người gửi hàng thực tế',
  LinkSendAmsError: 'Không được phép gửi lại trong khi đang gửi',
  DangerousCode: 'Mã hàng nguy hiểm',
  PleaseEnterHeader: 'Vui lòng nhập tiêu đề',
  PleaseEnterAddress: 'Vui lòng nhập địa chỉ 1',
  PleaseEnterAddress2: 'Vui lòng nhập địa chỉ 2',
  PleaseSelectCountry: 'Vui lòng chọn quốc gia',
  PhoneFormat: 'Chỉ được nhập số',
  PleaseEnterState: 'Vui lòng nhập bang/tỉnh',
  PleaseEnterCity: 'Vui lòng nhập thành phố',
  PleaseEnterPostalCode: 'Vui lòng nhập mã bưu điện',
  PleaseEnterMbl: 'Vui lòng nhập số vận đơn chính không bao gồm SCAC code',
  VesselCallSignCheck: 'Chỉ được 1-9 ký tự hoa và số',
  MarksFormat: 'Chỉ được chữ hoa/thường, số, gạch ngang, gạch chéo, phẩy, khoảng trắng, hai chấm, dấu ngoặc, cộng, gạch dưới',
  MustBe3: 'Phải đúng 3 ký tự',
  OneCargoInfo: 'Chỉ cần thêm một thông tin hàng hóa tổng hợp',
  Instructions: 'Trình bày cụ thể lý do',
  ExplanationRequired: 'Chọn “khác” thì bắt buộc nhập',
  ConfirmDeletion: 'Xác nhận xóa',
  HblCheck: 'Chỉ cho phép chữ in hoa, số, dấu nối và dấu gạch chéo',
  MustBe2: 'Phải đúng 2 ký tự',
  MustBe11: 'Phải đủ 11 ký tự, chữ hoặc số, ký tự thứ 4 phải là U',
  MustBeU: 'Ký tự thứ tư phải là U',
  MustBe4: 'Phải đúng 4 ký tự',
  VesselNotNull: 'Vui lòng nhập tên tàu trong tab đặt chỗ',
  VoyageNotNull: 'Vui lòng nhập chuyến tàu trong tab đặt chỗ',
  EtaNotNull: 'Vui lòng nhập ETA trong tab thông tin cơ bản',
  StreetName: 'Tên đường phố',
  ExampleIllustrateEORI: 'Ví dụ về EORI12828',
  CycleTwoHundredTimesNotUseMbl: 'Đã đăng ký 200 lần nhưng không tìm thấy ứng dụng nào.',
  GenerateMblButLessThan: 'Đã tạo thanh 【{0}】 với số đóng không thể sử dụng còn lại',
  selectedRowCount: 'Đã chọn: {0}',
  specialOperationCode: 'Mã hoạt động đặc biệt',
  doubleClickToAddSpecialOperationCode: 'Nhấn đúp để thêm mã hoạt động đặc biệt',
  selectSpecialOperationCode: 'Nhấp đúp để chọn mã hoạt động đặc biệt',
  selectOperationRequirement: 'Nhấp đúp để chọn yêu cầu hoạt động',
  TransshipmentTransportationMethod: 'Phương pháp vận chuyển',
  specialHandlingCodes: 'Mã hoạt động đặc biệt',
  AddApproximateSymbolToItemColumn: 'Thêm số ước vào thanh tên',
  BusinessLockedStatus: 'Trạng thái khóa doanh nghiệp',
  ImportChargeAllBusiness: 'Xử lý toàn bộ khi một số nghiệp vụ tồn tại đồng thời trong nhiều loại hình nghiệp vụ, nghĩa là số tồn tại cả trong xuất khẩu và xuất khẩu hàng hải, được nhập khẩu đồng thời vào cả doanh nghiệp xuất khẩu và xuất khẩu hàng hải.',
  OriginBillOfLading: 'Vận đơn gốc',
  ShippingOrder: 'Tài liệu ủy thác',
  EmptyOut: 'Thùng rỗng (Empty Out)',
  GateIn: 'Cổng vào (Gate in)',
  VesselDeparturePOL: 'Tàu rời cảng (Vessel Departure POL)',
  SendAll: 'Gửi tất cả cùng một lúc',
  PendingPickingOrder: 'Đơn hàng chờ chọn',
  PickingList: 'Chọn hóa đơn',
  WarehouseReleaseReceipt: 'Danh sách xuất kho',
  QuickSearchMBL: 'Bản mẫu:Main number',
  QuickSearchPickingOrderNo: 'Truy cập nhanh: Chọn số',
  DeliveryStation: 'Trạm giao hàng',
  AssemblyPlanNumber: 'Kế hoạch lắp ráp',
  FlightDateRange: 'Phạm vi ngày bay',
  OutboundInstruction: 'Có lệnh xuất kho không?',
  WarehouseEntryNumber: 'Danh sách nhập kho',
  BoardNumber: 'Ban giấy số',
  GenerateAPickingList: 'Tạo danh sách chọn hàng',
  GenerateAndIssueOrders: 'Tạo và đặt hàng',
  PickingOrderNumber: 'Chọn số',
  PickingStatus: 'Tình trạng chọn hàng',
  ThisPickingOrderNoIs: 'Số đơn hàng lần này là:',
  SuccessfullyGenerated: 'Tạo thành công',
  CloseAndCopyPickingOrderNo: 'Đóng và sao chép đơn hàng chọn',
  PleaseCheckSameDataWareHouse: 'Hàng hóa từ các kho khác nhau, không thể trên một danh sách chọn',
  DifferentGoodsCannotSamePickingList: 'Hàng hóa từ các trạm giao hàng khác nhau, không thể trên một danh sách chọn',
  PickingCompleted: 'Chọn hàng hoàn thành',
  CancelPickingCompleted: 'Hủy chọn hàng hoàn tất',
  OutboundStatus: 'Trạng thái ra kho',
  OutboundConfirmation: 'Xác nhận xuất kho',
  CancelWarehouseConfirmation: 'Hủy xác nhận xuất kho',
  WarehouseConfirmationSuccessful: 'Ra kho xác nhận thành công',
  CancelWarehouseConfirmationSuccessfully: 'Hủy bỏ xác nhận thành công',
  PleaseSelectCorrespondPickingList: 'Vui lòng đánh dấu vào danh sách chọn hàng tương ứng',
  PleaseCheckDataPickingCompletionUnOutBound: 'Vui lòng chọn dữ liệu đã hoàn thành và chưa xuất kho',
  PleaseCheckDataPickingCompletionOutBound: 'Vui lòng chọn dữ liệu đã hoàn thành và đã xuất kho.',
  NotAllowEditPickingCompletion: 'Dữ liệu đã chọn xong không được phép chỉnh sửa',
  NotAllowDeletePickingCompletion: 'Dữ liệu đã chọn xong không được phép xóa',
  PleaseCheckDataRemoved: 'Vui lòng chọn dữ liệu cần xóa',
  KeepLeastOneDetail: 'Giữ ít nhất một chi tiết',
  CargoVehicle: 'Range Rover xe tải',
  OutboundRemarks: 'Ghi chú ra kho',
  DeliveryTime3: 'Thời gian nhận hàng',
  OutboundUser: 'Nhà xuất bản',
  PreWarehouseNumberOfPackages: 'Số kiện hàng tại kho tiền trạm',
  PreWarehouseGrossWeight: 'Trọng lượng gộp tại kho tiền trạm',
  PreWarehouseVolume: 'Thể tích tại kho tiền trạm',
  PreWarehouseChargeableWeight: 'Trọng lượng tính cước tại kho tiền trạm',
  CargoTerminalNumberOfPackages: 'Số kiện hàng tại trạm hàng hóa',
  CargoTerminalGrossWeight: 'Trọng lượng gộp tại trạm hàng hóa',
  CargoTerminalVolume: 'Thể tích tại trạm hàng hóa',
  CargoTerminalChargeableWeight: 'Trọng lượng tính cước tại trạm hàng hóa',
  DocumentationChargeableWeight: 'Trọng lượng tính cước trong chứng từ',
  SignedDocumentNumberOfPackages: 'Số kiện hàng trong chứng từ đã ký',
  SignedDocumentGrossWeight: 'Trọng lượng gộp trong chứng từ đã ký',
  SignedDocumentVolume: 'Thể tích trong chứng từ đã ký',
  SignedDocumentChargeableWeight: 'Trọng lượng tính cước trong chứng từ đã ký',
  WarehouseEntrySerialNumber: 'Số dòng chảy vào kho',
  DeadlineForDeclaringHazards: 'Hạn chót khai báo nguy cơ',
  BookingManagementListPage: 'Trang danh sách quản lý chỗ ngồi',
  PrintByFleet: 'In the fleet',
  BoxContents: 'Nội dung thùng hàng',
  BatchAssignMasterOrderNumbers: 'Gán số đơn hàng chính theo lô',
  PleaseForThePositiveAssign: 'Vui lòng chọn nghiệp vụ thực hiện thao tác tích cực để phân配',
  SuccessfullyItemsFailed1Items: 'Đã phân bổ thành công {0} mục, thất bại {1} mục!',
  ReasonForFailure: 'Nguyên nhân thất bại:',
  MBLNOAlreadyExists: 'Số MB/L đã tồn tại',
  NonOperational: 'Không hoạt động',
  UnableTheMainTrackingNumber: 'Không tìm thấy số đơn chính',
  WarehouseEntryInformation: 'Thông tin nhập kho',
  NumberOfItemsReceived: 'Số lượng hàng hóa nhập kho',
  GrossWeightUponEntry: 'Khối lượng tổng cộng khi nhập kho',
  WarehouseVolume: 'Thể tích kho hàng'
}
